module.exports = {
  BusinessNo: 'Job No.',
  WarehouseNo: 'W/H No',
  MasterBillNo: 'MBL',
  HBL: 'HBL',
  FileNo: 'File No',
  BookingNo: 'BKG No.',
  ItemNo: 'Project No.',
  BusinessReferenceNo: 'Job Ref No.',
  BillNo: 'Bill No',
  PreBookingNo: 'Pre-Bkg No.',
  CBANumber: 'CBA Number',
  CustomsStatus: 'Customs status',
  CustomsStatusUpdateTime: 'Customs status update time',
  ReceiptDetails: 'Receipt details',
  CustomsBrokerStatus: 'Customs broker status',
  CustomsReceiptRecord: 'Customs receipt record',
  CustomsTime: 'Customs time',
  CustomsCode2: 'Customs code',
  UnifiedCoding: 'Unified coding',
  CustomsDescription: 'Customs Description',
  HBLSplitCombineNo: 'HBL Split/Combine No.',
  MBLSplitCombineNo: 'MBL Split/Combine No.',
  ConsignationCompany: 'Customer',
  BookingAgent: 'Booking Agent',
  BookingOrExchangeAgent: 'Booking Agent/Documentary Agent',
  CarrierAgent: 'Carrier Agent',
  ShippingCompany: 'Carrier',
  OperateCarrier: 'Operate carrier',
  VSACarrier: 'VSA Carrier',
  InternalVoy: 'Internal voy',
  CopyShip: 'Copy information from operate carrier to VSA carrier',
  ContainerNo: 'Container No.',
  BoxController: 'Box controller',
  LFD: 'LFD',
  CarNumber: 'Car number',
  ContainerNoOutOfRange: 'Length of EQ No. is out of range',
  CurrentVehicleLocation: 'Current Vehicle Location',
  TravelTrajectory: 'TransportTrajectory',
  DrivingState: 'Driving state',
  PortOfLoading: 'POL',
  PortOfLoadingPOR: 'port of receipt',
  TransitPort: 'T/S Port',
  PortOfDestination: 'Port of Dest.',
  PortOfDestinationPod: 'Port of Dest.',
  PortOfDischarge: 'POD',
  PortOfDischargeSeaAndComprehensive: 'Unloading port (sea/comprehensive)',
  DischargingPortCountry: 'Unloading port country/region',
  DestinationPortCountry: 'Destination port country/region',
  dischargingPort: 'discharging port',
  DeliveryCountry: 'Delivery Country',
  FirstPortOfDischarge: 'First POD',
  branchLineDateOfDeparture: 'departure time of barge vessel',
  branchLineDateOfArrival: 'arrival time of barge vessel',
  DateOfDeparture: 'ETD',
  DateOfDeparture2: '(Estimated Time of Departure)ETD',
  BookingDate: 'Booking Date',
  BargeDateOfDeparture: 'Barge ETD',
  BargeCYCutOffDate2: 'Barge CY Cut Off',
  BargePortOfLoading: 'Barge POL',
  BargeVessel: 'Vessel',
  BargeVoyage: 'Barge Voyage',
  BargePOL: 'Barge POL',
  SecondDateOfDeparture: 'Second ETD',
  DeliveryCompletionDate: 'Delivery Completion Date',
  DateOfArrival: 'ETA',
  DateOfArrival2: '(Estimated Time of Arrival)ETA',
  DateOfArrival3: 'ETA',
  DateOfCreation: 'Create Date',
  CYCutOffDate2: 'CY Cut Off',
  DocCutOffDate: 'DOC Cut Off',
  DeclareCutOffDate: 'DECLARE CUT OFF',
  LoadingDate: 'Stuffing Date',
  PreAuditTime: 'Pre-audit Time',
  CallSignOfBookingShip: 'Ship Call Sign',
  MasterBLFreightTerm: 'MBL Freight Terms',
  MasterBLFreightTermTootip: 'MBL FRT Term',
  MasterBLFreightTermT: 'MBL FRT Term',
  OrderChannels: 'Shipping Order Channel',
  CargoType: 'Cargo Type',
  Shipper: 'Shipper',
  ShipperCode: 'Shipper code',
  Consignee: 'Consignee',
  ConsigneeCode: 'Consignee code',
  SONO: 'SO NO.',
  ShippingCompanyContractNo: 'Carrier S/C',
  InnerContractNo: 'Contract No',
  HBLRemarks: 'Remarks of HBL',
  quotationNum: 'Quotation Number',
  Vessel: 'Vessel',
  Voyage: 'Voyage',
  CarrierVoyage: 'Carrier Voyage',
  OperationDepartment: 'Operation Department',
  SalesDepartment: 'Sales Department',
  FLCLType: 'Loading Type',
  ExportControlledProducts: 'Export controlled products',
  LocalService: 'Local Svc',
  NotLocalService: 'Not local Svc',
  SolicitationType: 'Source Of Freight',
  SO_NO1: 'S/O No.',
  MBL_NO: 'MB/L No.',
  ServiceProduct: 'Service Product',
  WoodOrNotWood: 'Wood/Non-wood',
  HazardousGoodsOption: 'Hazardous Goods Option',
  ContractRateProperty: 'Contract Rate Come From',
  IsNac: 'Whether NAC',
  ApplicableProductName: 'Applicable Product Name',
  PleaseEnterNAC: 'Please enter NAC',
  CargoInsuranceQuantity: 'Cargo Insurance Quantity',
  CargoInsuranceUnit: 'Cargo Insurance Unit',
  ValidityStartDate: 'Validity Start Date',
  ValidityEndDate: 'Validity End Date',
  PleaseEnterTheShippingCompanyContractNumber: 'Please enter the shipping company contract number',
  CargoInsurance: 'Cargo Insurance',
  handlingInformation: 'Handling Information',
  ShutOut: 'Shut Out',
  ShutOutDate: 'Shut Out Date',
  CancelShutOut: 'Cancel Shut Out',
  ABargeOrNot: 'WithFeederOrNot',
  yes: 'yes',
  no: 'no',
  Operation: 'Operation',
  Sales: 'Sales',
  CustomerService: 'Customs Service',
  Planner: 'Planner',
  Documents: 'Documentation',
  Airline: 'Shipping Route',
  PreAuditPerson: 'Pre-audit PIC',
  Creator: 'Creator',
  Code: 'CODE',
  Accrued: 'Accrued',
  AirlineCode: 'Line Code',
  ShowRelevantBusiness: 'Relevant Job',
  CustomsBroker: 'Customs Broker',
  AdvancePayment: 'Advance Payment of Customs Duty',
  HasPrintBooking: 'Print Shipping Order?',
  PaymentTime: 'Tax Payment Time',
  CustomsDutyAmount: 'Customs Duty Amount',
  VatAmount: 'VAT Amount',
  TaxRemarks: 'Tax Payment Remarks',
  Warehouse: 'Warehouse',
  HaulageCompany: 'Trucking Company',
  CarryingCmpAdjustBlockedTip: 'Selected orders contain ones without Door Loading/Delivery ticked, the trucking company cannot be adjusted',
  AbnormalBusinessNo: 'Abnormal Business No.',
  TradeTerms2: 'Trade Terms',
  BusinessStatus: 'Status',
  StatusTracking: 'Tracking',
  AuditStatus: 'Audit Status',
  Display: 'Display',
  Query: 'Query',
  Return: 'Return',
  Prompt1: 'InputJobNoToQuery',
  ResetFilter: 'Reset',
  Tip1: 'DoubleClickPresentSOPStatus',
  TipCharge: 'Click to display basic business information',
  MBLIssueBillLading: 'MBL Bill of Lading Issuing Status',
  HBLIssueBillLading: 'HBL Bill of Lading Issuing Status',
  ConsignationRelationNumber: 'Consign RN',
  BusinessCommissionedRelationNumber: 'ToAndFromBIZRelatedNo',
  ChannelNo: 'Channel No',
  Customer: 'Customer',
  ConsignationStatus: 'Delegation Status',
  ConsignationStatusTime: 'Delegation Status Time',
  PlaceOfDelivery: 'Delivery',
  FinalPlaceOfDelivery: 'Final Delivery',
  AirlineArea: 'ShippingRoute(Area)',
  SequenceNumber: 'SN',
  Tip2: 'DataSendRecordQuery',
  View: 'View',
  Edit: 'Edit',
  Cancel: 'Cancel',
  SaveTheDefaultValues: 'SaveDefaults',
  NominatedAgent: 'Nominated Agent',
  NominatedAgentCount: 'NumberOfAgentCount',
  ActualQuantity: 'Real Qun',
  ActualWeight: 'Real WT',
  ActualVolume: 'Real Vlm',
  ChargedWeight: 'Chargeable Weight',
  VolumetricWeight: 'Volumetric Weight',
  ChargedWeightRT: 'Chargeable Weight RT',
  BookingProperty: 'Booking Method',
  IssueMethod: 'BL Mode',
  TradeMethod: 'Trade Term',
  HBLFreightClause: 'HBL Freight Terms',
  HBLFreightClauseTootip: 'HBL FRT Term',
  MBLTransportationClause: 'MBL Shipment Terms',
  MBLTransportationClauseTootip: 'MBL Trans Term',
  HBLTransportationClause: 'HBL Shipment Terms',
  HBLTransportationClauseTootip: 'HBL Trans Term',
  ContainerDescription: 'EQ Quantity',
  FeeCreationDate: 'Fee Creation Date',
  MBLSplitNo: 'MBL Split No',
  HBLSplitNo: 'HBL Split No',
  HarborDistrict: 'Terminal',
  SOPStatus: 'SOP Status',
  HDS: 'HDS',
  TEU: 'TEU',
  AirlinePerson: 'Shipping Route PIC',
  AirlinePerson2: 'Line Manager',
  AirlineOffice: 'Airline Company',
  AirlineDepartment: 'Airline Department',
  BusinessCreator: 'Creator',
  Status: 'Status',
  HblNo: 'HBL NO',
  RelevanceSoNo: 'Relevance SO NO',
  DangerousGoodsClassification: 'DG Class',
  DangerousGoodsUNNo: 'DG UN No.',
  FinalDestination: 'Final Dest.',
  HBLShipper: 'HBL Shipper',
  HBLConsignee: 'HBL Consignee',
  Add: 'Add',
  Delete: 'Delete',
  AddHbl: 'Add MBL',
  SplitHbl: 'Split HBL',
  ExportToExcel: 'Export Excel',
  OverseasAgentEDI: 'Agent EDI',
  EditSopStatus: 'ModifyStatus',
  BatchPrint: 'Batch Print',
  BatchVessel: 'BatchTransit',
  Statistics: 'Statistics',
  BatchCommit: 'Batch Submit',
  AddCharges: 'Add Charges',
  EditCharges: 'Edit Charges',
  DeleteCharges: 'Delete Charges',
  print: 'Print',
  PrintFclProfit: 'Print FCL Profit',
  PrintLclProfit: 'Print LCL Profit',
  PreSubmission: 'Pre-Submit',
  BatchPreSubmission: 'Batch Pre-Submit',
  BatchCancellation: 'Batch Cancellation',
  Submission: 'Submit',
  SubmissionDateTime: 'Submission Time ',
  AuditDateTime: 'Audit Time',
  Consignation: 'Consign',
  FreightStation: 'Freight Station',
  SignBill: 'Sign Bill',
  ConsignationSI: 'Consign SeaImport',
  CrossTenantSeToSiEtaMustNoNull: 'Please fill in the field: estimated arrival date, which is a required field in the importer!',
  ReturnAction: 'ReturnToOperation',
  PrintReturn: 'Withdraw',
  AssociationBusinessInformation: 'Association Business Info',
  AssociationBusinessInformationSI: 'Association Import Business Info',
  ShowAssociationBusinessInformationSI: 'Show Association SeaImport Business Info',
  Basic: 'Basic',
  Booking: 'Booking',
  EnterTheCabin: 'Enter the cabin',
  DataTracking: 'Data Tracking',
  AirDataTracking: 'Air Data Tracking',
  CustomsDeclaration: 'Customs',
  InsureInfo: 'Insure',
  Mbl: 'MBL',
  Hbl: 'HBL',
  HouseBillOfLading: 'HB/L',
  FormalHbl: 'Formal HBL',
  Vgm: 'VGM',
  AmsEns: 'AMS/ENS',
  Hds: 'HDS',
  CommodityInspection: 'Inspection',
  Fumigation: 'Fumigation',
  ForeignTrade: 'Trade',
  ConsignInfo: 'Order Info',
  RequiredItem: 'RequiredColumn',
  CustomerProperty: 'Customer Type',
  ContactPerson: 'Contacts.',
  CustomerContactPerson: 'Customer Contacter',
  ContactPhone: 'Cell Phone',
  ContactMobile: 'Contact Phone',
  Detail: 'Detail',
  OperationDate: 'OP Date',
  PlaceOfDelivery2: 'Place of Receipt',
  Transit: 'Transit',
  PleaseSelectShippingCompany: 'Please Select Shipping-Company',
  AdditionalInformation: 'Additional Info',
  WarehouseLoadingStorage: 'Loading',
  DoorLoadingDelivery: 'Door-to-Door',
  NotResponsibleForTruckingAndLoading: 'Self-Delivery',
  AutoDistribution: 'Auto Loading',
  ObtainTheWarehouseNo: 'Get W/H No',
  MblNo3: 'MBL No.',
  MasterBusinessNo: 'Main bill business No',
  PleaseTickCustomsDeclarationOption: 'Please tick [Customs declaration] option',
  PleaseTickDoorLoadingDeliveryOption: 'Please tick [Door Loading/Delivery] option',
  PleaseSelectWarehouse: 'Please Select Warehouse',
  PleaseCheckWarehouses: 'Please Select Warehouse',
  PlaceOfMblPayment: 'Place of Payment MBL',
  PlaceOfHblPayment: 'Place of Payment HBL',
  CargoSize: 'Dimension',
  SpecialPriceInstructions: 'Special Rate Explanation',
  DirectBusiness: 'Issue Ocean B/L',
  Transport: 'Transit',
  InBatches: 'BatchTransportation',
  SpecialPrice: 'SpecialRate',
  ContainerInfo: 'Container Info',
  QuantityConsignActual: 'Quantity',
  WeightConsignActual: 'Weight',
  WeightUnit: 'Weight Unit',
  CubageConsignActual: 'Volume',
  VolumetricWeightConsignActual: 'VolumetricWeight',
  ChargeWeightConsignActual: 'ChargeWeight',
  CubageUnit: 'Volume Unit',
  Package: 'Packing',
  Pieces: 'Pieces',
  PiecesType: 'PiecesPacking',
  Copy2: 'Copy',
  EnglishDescriptionOfGoods: 'Commodity description(EN)',
  HblEnglishDescriptionOfGoods: 'HBL Commodity description(EN)',
  Marks: 'Shipping Marks',
  NCReferenceNo: 'NC Reference No',
  SendProxyForecasts: 'Send proxy forecasts',
  SerialNumber: 'Serial Number',
  Brand: 'Brand',
  ProductiveYear: 'Productive Year',
  CustomsValue: 'Customs Value',
  ChineseName: 'Chinese Name',
  EnglishName: 'English Name',
  DeclaredValue: 'Declared Value',
  TariffRate: 'Tariff Rate(%)',
  EstimatedTariff: 'Estimated Tariff',
  CustomsDeclaration: 'Customs Declaration',
  CustomsBroker: 'Customs Broker',
  Bond: 'Bond',
  UnitType: 'Unit Type',
  DeviceType: 'Device Type',
  CountryOrigin1: 'Country Origin',
  DeviceStatus: 'Device Status',
  HsCode: 'HS Code',
  bookingNotes: 'Booking note',
  DangerousGoodsRemarks: 'Dangerous goods remarks',
  BootHelperPage: 'Boot helper page',
  ChineseDescriptionOfGoods: 'Commodity description(CN)',
  OperationInfo: 'Operation information',
  SalesCompany: 'Sales Office',
  OperationCompany: 'Operation Office',
  OperationRequirements: 'Operation requirement',
  DoubleClickToAddOperationRequirements: 'Double click to add Operation Requirements',
  OperationTips: 'Operation Tips',
  ExtraChargeClause: 'SurchargesClause',
  DoubleClickToAddExtraChargeClause: 'Double click to add surcharge Clause',
  WarehousingInfo: 'W/H Info',
  Remarks: 'Remarks',
  BasicRemarks: 'Remarks (Basic)',
  manifestInformation: 'Basic information of manifest',
  manifestChannel: 'Channel of manifest',
  CustomerDeliveryInfo: 'Customer Delivery Info',
  CodeSearching: 'Code Searching',
  CopyToSeller: 'Copy To Seller',
  CopyToBuyer: 'Copy To Buyer',
  ExpandSellerBuyer: 'Expand Seller/buyer',
  NoHouseNumber: 'No House Number',
  NotifyParty: 'Notify party',
  NotifyPartyCode: 'Notify party code',
  MblShipperLine1: 'MBL Shipper',
  MblConsigneeLine1: 'MBL Consignee',
  MblNotifyLine1: 'MBL Notify',
  DocDispatchingPlace: 'Dispatching Place',
  SecondNotifyParty: '2nd Notify',
  PleaseSelect: 'Please Select',
  Add2: 'Add',
  WhetherDeclarations: 'WhetherCustomsCleared',
  InBatchesOrNot: 'Whether batches',
  BookingInfo: 'Order Info',
  MultiJourneyAirline: 'Multi journey airline',
  NumberPasses: 'Number of Passes',
  MergingTickets: 'HouseShptsCombined',
  TicketsInfo: 'Sub-Job Info',
  TotalTickets: 'Total Sub-Jobs',
  NewTickets: 'New Sub-Job',
  EditTickets: 'Edit Sub-Job',
  AddTickets: 'Add Sub-Job',
  RemoveTickets: 'Remove Sub-Job',
  DeleteTickets: 'Delete Sub-Job',
  Etd: 'ETD',
  SoNo: 'S/O No.',
  FunctionalOperation: 'Functional operation',
  MblNo2: 'MB/L NO',
  BookingShipCallSign: 'Ship Call Sign',
  USAirlineInfo: 'USRouteInfo',
  PortInfo: 'Port Info',
  PolPortInfo: 'POL Port Info',
  AirPolPortInfo: 'Air POL Port Info',
  PodPortInfo: 'POD Port Info',
  LocalTime: '(The data is returned in local time)',
  TopLocalTime: 'Kind reminder: The time displayed is the local time',
  PodAirPortInfo: 'POD Air Port Info',
  PolPortInfoPrompt: 'The orange field supports data write back after the data service is enabled',
  CYOpeningDate: 'CY Opening',
  CYOpeningTime: 'CY Opening',
  CYCutOffDate: 'CY Cut-off',
  PortAreaCYCutOffTime: 'CY Cut-Off',
  PortAreaCYOpeningTime: 'CY Opening',
  CarrierCyCutOffTime: 'Carrier CY cut off time',
  PlannedDateOfBerthing: 'Est. Berthing',
  PlannedDateOfLeavingBerth: 'PlannedDateOfUnberthing',
  ActualDateOfBerthing: 'Act. Berthing',
  ActualDateOfLeavingBerth: 'Actual Date Of Unberthing',
  PlannedDockingBerths: 'PlannedBerth',
  EstimatedArrivalTime: 'Estimated Arrival Time',
  EstimatedPortArrivalTime: 'Estimated Arrival/Port Arrival Time',
  ArrivalTime: 'RealArrivalTime',
  CustomsClearance: 'time at destination port',
  ActualCustomsReleaseTime: 'Actual customs release time',
  DeliveryTime: 'Delivery time',
  ReturnTime: 'Return time',
  DeliveryTime2: 'Delivery time',
  DeliveryDate: 'Delivery Date',
  TheActualDockingBerths: 'ActualBerth',
  ActualTimeOfArrivalThePort: 'Actual Gate-in',
  EquipmentEstimatedReturnTime: 'EQ Est. R/T',
  EquipmentEstimatedReturnTimeTootip: 'EQ Est. Return Time',
  To: 'To',
  OtherInfo: 'Other Info',
  CyCode: 'CY Code',
  PortCodeOfDischarge: 'POD Code',
  EquipmentReceiptAddress: 'EIR Address',
  EquipmentReceiptContactPerson: 'EIR PIC',
  EquipmentReceiptContactWay: 'EIR Contact',
  CustomerCyCutOffDate: 'Customer Cut-off',
  CustomerShutOutDate: 'Customer Shut out',
  AmsEnsCyCutOffDate: 'AMS/ENS CY Cut-off Date',
  FreeDetension: 'Free Detension',
  SecondVesselInfo: 'SecondLegVSLInfo',
  AirSecondVesselInfo: 'AirSecondVesselInfo',
  SecondVoyage: 'SecondLegVSLVoYage',
  BargeInfo: 'FeederVSLInfo',
  ServiceCode: 'ShipRouteCode',
  ModulesInfo: 'ManifestInfo',
  ShippingAdviceRemark: 'Shipping Advice',
  BookingConfirmationRemarks: 'VSLAllocationNoteRemarks',
  InviteToChecktheBL: 'Invite to check the B/L',
  ConfirmChecking: 'Confirm Checking',
  IdentificationList: 'Identification list',
  ChecktheBLBySmart: 'Check the B/L by smart ',
  ViewCheckingFile: 'View Checking File',
  CheckingHistory: 'Checking History',
  UploadGuarantee: 'Upload Guarantee',
  ReceiptHistory: 'Receipt History',
  CopyTheDataBy: 'Copy By',
  CopyFromTheLastTime: 'Copy Last Time',
  CopyFromOtherBill: 'Copy Other Job',
  CopyFromHbl: 'Copy HBL',
  CompleteTheDetails: 'BL Confirm',
  Printed: 'Printed',
  Locked: 'Locked',
  ShipperLocked: 'Shipper Locked',
  BlBeReleased: 'B/L Release In 3rd Place',
  BlEdi: 'B/L EDI',
  ManifestEdi: 'Manifest EDI',
  ShowNumberOfPackagesGrossWeightAndMeasurementAfterCNTRNOSSEALNOS: 'Pkg/GW/CBM After Container SealNo',
  PrintBargeVesselAndVoyage: 'Print Feeder VSL Name Voyage',
  ConsigneeShipperAndNotifyInfo: 'Client\'s Info',
  Reset: 'Reset',
  CopyTheConsignee: 'Copy Consignee',
  CargoInfo: 'Cargo Info',
  OnlyOriginalSend: 'Original only',
  OnlyAddAndDeleteSend: 'Modifications and deletions only',
  NoSuccessAddAndDeleteNotSend: 'Failed to send, cannot resend modifications or deletions',
  NeedFillPortBeforeEnteringEU: 'Port of entry before EU must be filled',
  SyncContainerInfoTotal: 'Take the packing information body',
  SyncContainerInfoContent: 'Packing information body cover MBL, is it covered?',
  SyncContainerInfoQuantity: '件数（装箱）: {0} -----> 件数（MBL）: {1}',
  SyncContainerInfoWeight: '毛重（装箱）: {0} -----> 毛重（MBL）: {1}',
  SyncContainerInfoCubage: '体积（装箱）: {0} -----> 体积（MBL）: {1}',
  NumberOfPackagesOnBl: 'Quantity',
  Pieces2: 'Pieces',
  PiecesType2: 'Pieces Type',
  Weight: 'Weight',
  Cubage: 'Volume',
  CopyEnglishDescriptionOfGoodsFromReceipt: 'Copy Receipt Eng Name',
  CopyEnglishDescriptionOfGoodsFromHBL: 'Copy HBL Eng Name',
  CopyMarksFromHbl: 'Copy HBL Marks',
  CapitalizedNumbersOfPackages: 'Quantity in Capital',
  TransportInfo: 'Trans Info',
  VesselAndVoyage: 'V/V',
  PlaceOfReceipt: 'POR',
  PlaceOfReceiptOnBl: 'POR',
  PlaceOfReceiptCodeOnBl: 'POR(Code)',
  PlaceHolderPOR: 'Please select the POR to code',
  PlaceOfReceiptOnBlTootip: 'Place of Receipt',
  PortOfLoadingOnBl: 'POL',
  PortOfDischargeOnBl: 'POD',
  PlaceOfDeliveryOnBl: 'Place of Delivery',
  BlFinalDestination: 'Final Dest',

  MethodOfMblPayment: 'FRT Term',
  PlaceOfMblPayment2: 'Paid Place',
  TransportationClause: 'Deliv. Mode',
  NoOfOriginalBls: 'No. of Original',
  NoOfCopyBls: 'Number of copies',
  PlaceOfIssue: 'Place of Issue',
  DateOfIssue: 'Date of Issue',
  HBLDateOfIssue: 'HBL Date of Issue',
  BlRemarks: 'B/L remarks',
  BlType: 'B/L Way',
  HBLBlType: 'HBL B/L way',
  MBLBlType: 'MBL B/L way',
  MBLBlProperty: 'MBL B/L Property',
  HBLBlProperty: 'HBL B/L Property',
  LastEntryPort: 'Final port of entry',
  BlProperty: 'Kind Of B/L',
  CheckingStatus: 'B/L Confirm StatusStatus',
  BillLadingIssued: 'Bill of lading issuing status',
  HBLCheckingStatus: 'HBL B/LStatus',
  MBLCheckingStatus: 'MBL B/LStatus',
  ReleasingStatus: 'B/L Release Audit Status',
  HBLReleasingStatus: 'HBL B/L ReleaseStatus',
  MBLReleasingStatus: 'MBL B/L ReleaseStatus',
  ReleaseEligibleStatus: 'Release Eligibility',
  ReleaseEligibleYes: 'Releasable',
  ReleaseEligibleNo: 'Not Releasable',
  FormalHblReleaseType: 'Form splitting method',
  FormalHblStatus: 'Form splitting status',
  FormalHblIssuedStatus: 'Status of Form Splitting and Issuance',
  FormalHblType: 'Type of Form Splitting',
  FormalHblCombineNo: 'Form splitting and numbering',
  fields: 'fields and',
  tab: 'tab',
  hint: 'fields are inconsistent. Do you want to confirm sending？',
  Audit: 'Audit',
  Payable: 'Payable',
  CargoDetention: 'Hold The Goods',
  PaymentDate: 'Foreign Exchange Payment Date',
  PaymentDate2: 'Payment Date',
  DateOfCargoDetention: 'B/L Hold Date',
  BlReleasingNo: 'B/L Release No.',
  BlReleasingApplicationTime: 'Applied Release Date',
  BlReleasingApplicationPerson: 'Applied Release PIC',
  ParamRemark: 'Seal Remarks',
  ShippingCompanySCAC: 'SCAC',
  OverseasAgentSCAC: 'Agent SCAC',
  ShipperType: 'Shipper Type',
  ManifestDescriptionOfGoods: 'Manifest Goods Description',
  ReasonOfCargoDetention: 'Reason Of B/L Hold',
  HblNo2: 'HBL No',
  MblNo: 'MBL No',
  Quantity: 'Quantity',
  WeightKg: 'Gross weight (KG)',
  CubageCbm: 'Volume (CBM)',
  ContainerAmount: 'Container Amount',
  CNTRNOSSEALNOS: 'Cntr/Seal No.',
  BillOfLadingPackingInfo: 'CTNRPackingInfoOnB/L',
  CopyMblConsignee: 'Copy MB/L Consignee',
  CopyNominatedAgentInfo: 'Copy Nominated Agent Info',
  PrintTheOriginalBl: 'Print The Original B/L',
  TelexRelease: 'Telex release printing',
  Unlock: 'Unlock',
  AntiTerroristFormattedAddress: 'Anti-terrorist formatted address',
  BlBeReleasedElsewhereOrNot: 'B/L Released In Alloparty Or Not',
  ClauseOfNoWoodPackingMaterial: 'Clause of no-wood packing material',
  AFRTheLastBill: 'AFR The Last Bill',
  CopyEnglishDescriptionOfGoodsFromMbl: 'Copy MB/L Eng Name',
  CopyMarksFromMbl: 'Copy MB/L Marks',
  BillOfLadingNumber: 'Serial No',
  HBLBillOfLadingNumber: 'HBL Serial No',
  MethodOfHblPayment: 'FRT Term',
  PlaceOfHblPayment2: 'Paid Place',
  CheckingQuestions: 'Checking questions',
  BlType2: 'B/L Type',
  HBLBlType2: 'HBL B/L Type',
  DataSent: 'Data sent',
  V3remind: 'Please copy the attachment first',
  Completed: 'Completed',
  DateOfcompletion: 'Completion Date',
  paste: 'Paste the attachment',
  GenerationOfABillOfLading: 'Take Place To Issue B/L',
  GenerationOfABillOfLading2: 'Take Place To Issue B/L',
  ShipperContactTelNo: 'Shipper Tel.',
  ConsigneeContactTelNo: 'Consignee Tel.',
  NotifyPartyTelNo: 'Notify Tel.',
  ChargeClause: 'FreightPayableClause',
  Amount: 'Amount',
  CopyCargoDescriptionAndMarks: 'Copy Cargo Name and Marks',
  CopyMbl: 'Copy MBL',
  RelatedMbl: 'Related MBL',
  Add3: 'Add',
  Copy: 'Copy',
  ImportOrder: 'Import Order',
  ImportBusinessNo: 'Import Business No',
  SelectOrderNumber: 'select order number',
  Send: 'Send',
  CheckStatus: 'Check status',
  ImportButNotSend: 'Import',
  CapitalizedNumbersOfEquipmentWeight: 'Capitalized Numbers of Container Weight',
  AmsSplitNo: 'AMS NO',
  AmsNo: 'AMS NO',
  EManifestSplitNo: 'EManifestHouseB/LNo',
  EManifestNo: 'EManifest No',
  BlSplitList: 'HouseB/LsTabulation',
  sendStatusAMS: 'Send Status OF AMS',
  sendStatusISF: 'Send Status OF ISF',
  sendStatus: 'Send Status',
  SealNoChangeAdfterInspection: 'Check&Modify Seal No.',
  AutoAllocation: 'Auto Loading',
  AutoAllocationContract: 'Auto Loading(Contract)',
  CleanOutTheLoadingRecord: 'Clear Record',
  DeleteTheLoadingRecord: 'Delete Record',
  CargoQuantityDescription: 'Cargo quantity description',
  TotalNumberOfPackages: 'Total Quantity',
  ContainerSize: 'Container Size',
  ContainerType: 'Container Type',
  ContainerWeight: 'Container Weight',
  SealNo: 'Seal No',
  GetContainerNo: 'Get EQ No',
  TotalWeight: 'Total Weight',
  TotalCubage: 'Total Volume',
  Soc: 'SOC',
  Inspection: 'Examination',
  ApproachDate: 'IntoCYTime',
  PlayDate: 'OutOfCYTime',
  LoadingPort: 'Loading port',
  TheArrivalOfPacketsSent: 'ArrivalMessageSendTime',
  CustomsClearanceInfo: 'Customs Clearance Info',
  DataTrackingBlHasNotContainer: 'If the bill of lading number is {0}, please go to the Packing Information tab to use the data comparison function and it will be linked. This tab will display the box details.',
  WharfReleaseInfo: 'Wharf Release Info',
  ContainerAscription: 'Container Ascription',
  PlateNumber: 'Tractor Number',
  plateApproachDate: 'CTNREntryCYTime',
  platePlayDate: 'CTNROutOfCYTime',
  PackageType: 'Package Type',
  NumberOfVotes: 'NumberOfShipments',
  EmptyContainerWeight: 'Empty Container Weight',
  VgmWeight: 'VGM weight',
  VgmWeighingMethod: 'VGM Weighing Method',
  VgmWeighingTime: 'VGM Weighing Time',
  WeightTime: 'Weighing Time',
  VgmWeighingPlace: 'VGM Weighing Place',
  WeighingPartyAddress: 'Weighing Party Address',
  StationStatus: 'Station Status',
  CargosGrossWeight: 'Cargo G.W.',
  VgmContactPerson: 'VGM Contacter',
  VgmContactEmailAddress: 'VGM E-mail',
  VgmContactWay: 'VGM Tel No.',
  VgmResponsiblePerson: 'VGMPIC',
  ContactEmailAddress: 'E-mail',
  ContactWay: 'Tel No.',
  ContactAddress: 'Address',
  ResponsiblePerson: 'PersonInCharge',
  Name: 'Name',
  Warehouse2: 'Warehouse',
  WarehouseLoading: 'Warehouse',
  LoadingCharge: 'CTNRVanningCharge',
  LoadingCharge2: 'Loading Charge',
  RmbNumberOfDamagedAndDamp: 'PKGENumberOfDamageAndMoisture',
  RmbNumberOfDamagedAndDamp2: 'Number of damaged and damp pieces',
  Tel: 'Tel',
  CargosExpectedArrivalDate: 'Expected Arrival Date',
  WarehouseAddress: 'Warehouse Address',
  LoadingRemarks: 'Loading Remarks',
  DoorToDoorLoading: 'Door to Door Loading',
  MultiDoors: 'Multi-Doors',
  HaulageNo: 'Truck Order number',
  HaulageCharge: 'Haulage Charge',
  AuditMoney: 'Confirmation amount',
  AuditState: 'Cost status',
  HaulageContactPerson: 'Contacts',
  Door: 'Door',
  AddDoor: 'Add Door',
  DestinationGatewayCity: 'Destination gateway city',
  DoorContactPerson: 'Door Contact Person',
  DoorAddress: 'Door Address',
  DispatchVehiclesAtDestinationDoorAddress: 'Door address of dispatch vehicles at destination',
  DoorCity: 'Gateway City',
  Driver: 'driver',
  ComprehensiveLogisticsOrderType: 'Order Type',
  ComprehensiveLogisticsTransportationType: 'Comprehensive logistics transportation type',
  TransportType: 'Transport Type',
  DestinationGatePoint: 'Destination gate point',
  DepartureGatePoint: 'Departure gate point',
  AddressOfDestinationGatePoint: 'Address of destination gate point',
  DestinationGateCity: 'Destination gate city',
  EstimatedPackingDate: 'Estimated loading date',
  ActualPackingDate: 'Actual Loading date',
  EstPackingDate: 'Est packing (arrival) date',
  ActPackingDate: 'Act packing (arrival) date',
  ExpectedArrivalDate2: 'Expected arrival date',
  ActualArrivalDate: 'Actual arrival date',
  GatheringTrailer: 'Gathering trailer',
  WholeVehicleLessThanCarload: 'Vehicle less than carload',
  TruckCustomerService: 'Trucking Customs Service',
  DtdDTWWTD: 'Door to door/door to bin/bin to door',
  DoorToDoor: 'Door to door',
  DoorToWarehouse: 'Door to warehouse',
  WarehouseToDoor: 'Warehouse to door',
  AdditionalNotes: 'Additional Notes',
  AssociatedPackingInfo: 'Associated Packing Info',
  RemoveAssociations: 'Remove Associations',
  DispatchTuckOrder: 'Dispatch Truck Order',
  ModifyTuckOrder: 'Modify Tuck Order',
  TuckStatusDescription: 'Description',
  ManualDistribution: 'Manual Distribution',
  Unlock2: 'Unlock',
  Size: 'Size',
  WhetherOrNotBroken: 'Whether Broken',
  BrokenDesc: 'Broken Desc',
  BangPic: 'Bang Pic',
  WareHouseName: 'Warehouse Name',
  WarehouseSupplier: 'Warehouse Supplier',
  WareHouseMarks: 'Warehouse Marks',
  CustomsDeclarationInfo: 'Customs Declaration Info',
  OnwardInfo: 'LegsAfterwardInfo',
  TheActualFlight: 'Actual Flight',
  NewCustomsDeclaration: 'New Customs',
  EditCustomsDeclaration: 'Edit Customs',
  DeleteCustomsDeclaration: 'Delete Customs',
  BlNo: 'B/L No',
  OperatingCompany: 'Shipper',
  CustomsCode: 'Customs Code',
  DateOfCustomsDeclaration: 'Customs Date',
  StatusOfCustomsDeclaration: 'Customs Status',
  CommodityInspectionOrNot: 'Inspection',
  CustomsInspectionOrNot: 'Examination',
  UploadFile: 'Upload File',
  CustomsFile: 'Customs File',
  Chargeback: 'ReturnedDOCFromCustoms',
  TemplateDownload: 'Template Download',
  ExcelImport: 'Import',
  ExcelExport: 'Export',
  OrderNo: 'ORDER NO',
  CaseNo: 'CASE NO',
  Item: 'CustomsCommodityCode',
  Sub: 'LotNumber',
  Size2: 'Size',
  CommodityClassification: 'Collation Name',
  Qty: 'QTY',
  BillingQTY: 'Billing amount',
  UnitOfMeasurement: 'Measuring Unit',
  NetWeight: 'Net Weight',
  CustomsDutyRate: 'Customs Duty Rate',
  CustomsDuties: 'Customs Duty',
  IncrementValueDutyRate: 'VATRate',
  IncrementValueDuty: 'VAT',
  ConsumptionDutyRate: 'Consumption Duty Rate',
  ConsumptionDuty: 'Consumption Duty',
  ConsolidatedTax: 'GeneralTax',
  Currency: 'Currency',
  ExchangeRate: 'Exchange Rate',
  CargoPrice: 'ValueOfGoods',
  Tax: 'Tax',
  TaxRate: 'Tax Rate',
  BigBagNo: 'Big Bag No',
  BigBagWeight: 'Big Bag Weight',
  BigBagWeightUnit: 'Big Bag Weight Unit',
  BigBagLength: 'Big Bag Lenght',
  BigBagWidth: 'Big Bag Width',
  BigBagHeight: 'Big Bag Height',
  BigBagDimensionUnit: 'Big Bag DimensionUnit',
  BigBagGoodsType: 'Big Bag GoodsType',
  FulfillmentLabel: 'Fulfilment Label',
  LandingPort: 'Landing Port',
  PackageQuantity: 'Package Quantity',
  ExpectPickupStartTime: 'Expected Collection Start Time',
  ExpectPickupEndTime: 'Expected Collection End Time',
  PreviousCarrierCode: 'Previous Carrier Code',
  PreviousResourceCode: 'Previous Resource Code',
  NextCarrierCode: 'Next Carrier Code',
  NextResourceCode: 'Next Resource Code',
  SortCode: 'Sort Code',
  BuyerRegion: 'Buyer Region',
  AddressL0: 'Address L0',
  AddressL1: 'Address L1',
  AddressL2: 'Address L2',
  AddressL3: 'Address L3',
  AddressL4: 'Address L4',
  DetailsAddress: 'Details Address',
  DetailsAddressMore: 'Details Address More',
  PickupFirstName: 'Pickup First Name',
  PickupLastName: 'Pickup Last Name',
  PickupCompany: 'Pickup Company',
  PickupZip: 'Pickup Zip',
  PickupPhone: 'Pickup Phone',
  TtOrderCode: 'TT Order Code',
  MwbNo: 'Service Provider Track No',
  Export9610File: 'Export 9610 file',
  BatchChangeCompany: 'Batch Change Of Company',
  OnlyCheckOneData: 'Only one piece of data is allowed to be selected',
  NoteUseNumLast: 'Note: After changing companies, the tracking number will not be regenerated and the existing tracking number will still be used.',
  OrderNo2: 'Order No',
  SupportSales: 'Sales Support',
  OrderAmount: 'Order Amount',
  ServiceFeeDiscountRate: 'Service Fee Discount Rate',
  OperatingInstructions: 'Operating Instructions',
  OrderCurrency: 'Order Currency',
  TheAmountOfWriteOffs: 'Amount of Write Offs',
  TheFirstBusinessOrNot: 'First Business Or Not',
  Salesman: 'Salesman',
  OrderExchangeRate: 'Order Exchange Rate',
  Difference: 'Difference',
  FrameContractNumber: 'Frame Contract No.',
  PaymentNo: 'ForeignExchangePaymentNo',
  PaymentAmount: 'ForeignExchangePaymentAmount',
  ThePrePayment: 'ForeignExchangeAdvancePaymentColumn',
  PaymentExchangeRate: 'ForeignExchangePaymentRate',
  ActualPaymentAmount: 'ActualForeignExchangeAmount',
  ServiceCharge: 'Service Charge',
  PostalCharges: 'Postal Charges',
  AcceptanceFee: 'Acceptance Fee',
  RetreatMoreFillLessAmount: 'AmountAtCost',
  Total: 'Total',
  UnpaidAmount: 'ForeignExchangeUnpaidAmount',
  No: 'No',
  Yes: 'Yes',
  New: 'New',
  Clone: 'Copy',
  Send2: 'Send',
  Back: 'Fetch',
  ExpressInfo: 'Express Info',
  PrintReceipt: 'Print Receipt',
  FileType: 'File Type',
  FileType2: 'Type',
  FileCategory: 'File Category',
  CustomsNo: 'Customs No',
  SendingDate: 'Sending Date',
  SendingExpressNumber: 'Sending Express Number',
  ReceivingDate: 'Receiving Date',
  Receiver: 'Receiver',
  ReturnDate: 'Return Date',
  ReturnExpressNumber: 'Return Express Number',
  DateOfDeclaration: 'Declaration Date',
  FileStatus: 'File Status',
  TenBitCode: 'Ten Bit Code',
  ReceiverCompanyName: 'Receiver',
  Receiver2: 'Receiver',
  CustomsDeclarationPages: 'Customs Pages',
  CustomsTransitOrNot: 'Customs Transit Or Not',
  TakeByCustomsBroker: 'By Customs Broker',
  ExpressAddress: 'Express Address',
  PrintChargebackList: 'Print',
  ViewFile: 'View File',
  ChargebackFile: 'Chargeback File',
  CheckPreRecordedCustomsDeclaration: 'Query Pre-recorded',
  CheckStatusOfCustomsDeclaration: 'Query Status',
  All: 'All',
  GeneralTrade: 'General Trade',
  Processing: 'ProcessingImporter\'sMaterials',
  FeedingCounterparts: 'Feeding Counterparts',
  SamplesOfAdvertisingProducts: 'Samples of Advertising Products',
  OtherImportsFree: 'Other Imports Free',
  CustomerName: 'Customer Name',
  CustomerAddress: 'Customer Address',
  Confirm: 'Confirm',
  DangerousGoods: 'Dangerous Goods',
  DangerousGoodsRequired: 'The email address and fax number of the contact person for dangerous goods are required',
  DangerousGoodsLabel: 'Dangerous Goods Label',
  MedicalEmergencyGuideNo: 'Medical Emergency Guide No',
  SetTemperature: 'Set Temp',
  MinimumTemperature: 'Minimum Temp',
  MaximumTemperature: 'Maximum Temp',
  PortForReturningContainer: 'Port For Returning Container',
  NonStandardContainer: 'Non-Standard Container',
  OverFront: 'Over Front',
  OverBack: 'Over Back',
  OverHeight: 'Over Height',
  OverLeft: 'Over Left',
  OverRight: 'Over Right',
  EditionStatus: 'Edition Status',
  UpdateExternalState: 'Update External State',
  Refresh: 'Refresh',
  Save: 'Save',
  ShowAllPoints: 'Show All Points',
  SopStateNote: '*Note: Nodes that have been shut down will no longer send node alerts and SOP status change notifications',
  PaymentInformationImport: 'Payment Info Import',
  Invalid: 'Invalid',
  QueryContainerInfo: 'Query Container Info',
  Hbl2: 'HBL',
  Mbl2: 'MBL',
  PortOfLoadingAgent: 'POL Agent',
  TheFirstVessel: 'First Vessel',
  CustomerReferenceNumber: 'Customer Reference',
  BusinessType: 'Business Type',
  BillExchange: 'Delivery Order',
  Storage: 'Storage',
  Devanning: 'Devanning',
  DeliveryToDoor: 'Delivery to Door',
  MblNo4: 'MBL No',
  InternationalTransport: 'International Transport',
  ActualNotifyParty: 'Actual Notify',
  ActualNotifyPartyHeader: 'Actual Notify Header',
  ConsignationCompanyHeader: 'Consign Cmp Header',
  Fax: 'Fax',
  BillExchangeAgent: 'Delivery Agent',
  CustomsHblNo: 'Manifest No.',
  SecondCheck: 'SecondLeg',
  SecondVessel: 'Second Vessel',
  AutoRetrieve: 'Auto Retrieve',
  AccordingToVesselVoyageGets: 'Get By Vessel',
  ActualDateOfArrival: 'Actual ETA',
  ActualDateOfArrival2: '(Acture Time of Arrival)ATA',
  AtaImport: 'ATA(Import)',
  DateOfDelivery: 'Date Of Delivery',
  DateOfArrivalTheWarehouse: 'To Warehouse Date',
  Code2: 'Code',
  Region: 'Zip Code',
  CountryOrigin: 'Country Of Origin',
  PartyIDType: 'Certificate Type',
  PartyID: 'Certificate Number',
  BillsOfLadingDoubleClickEject: 'Bills of Lading - double - click eject',
  TradeTerms: 'INCO Terms',
  PreCollection: 'Pre-Collection',
  HblCargoReleaseWay: 'HBL Cargo Release Way',
  MblCargoReleaseWay: 'MBL Cargo Release Way',
  VesselCode: 'Vessel Code',
  BillExchangeDate: 'D/O Date',
  Department: 'Department',
  PolOperation: 'POL OP',
  PodOperation: 'POD OP',
  VesselOfChineseName: 'Vessel Of Chinese Name',
  TotalWeight2: 'Total Weight',
  TotalWeightUnit: 'Total Weight Unit',
  NumberOfDamagedAndDamp: 'PackageNoOfDamageAndMoisture',
  EstimatedDateOfArrivalTheWarehouse: 'Target Finished Date',
  EstimatedDateOfPickingUpTheContainer: 'Expected Date of The Suitcase',
  DateOfReturningTheContainer: 'Date of Returning Container',
  SanitaryAndPhytosanitaryStandard: 'Sanitary and Phytosanitary Standard',
  PriceCalculation: 'SellingRateCalculation',
  Down: 'Down',
  Up: 'Up',
  Total2: 'Total',
  PrintBooking: 'Print Booking',
  FirstLegNo: 'First Leg No',
  FirstLegNoTips: 'A key identifier used in international air freight logistics for managing domestic transportation and pre-export operations',
  OperateType: 'Operate Type',
  CustomsDeclarationWay: 'Customs Way',
  CustomsDeclarationType: 'Customs Type',
  AirlineCompany: 'Airline Company',
  Flight: 'Flight',
  FlightNo: 'Flight No',
  PortOfHub: 'Port of HUB',
  CommissionedNumberOfPackages: 'DelegatedNoOfPKGES',
  CommissionedGrossWeight: 'DelegatedGrossWeight',
  CommissionedVolume: 'DelegatedCBM',
  ActualChargedWeight: 'ActualChargeableWeight',
  PrintingPlatePhotos: 'CargoPalletizePhoto',
  ProtocolType: 'AgreementType',
  FieldOperation: 'Spot Operation',
  OverseaOperation: 'Oversea Operation',
  Auditor: 'Auditor',
  preverifyDate: 'Preverify Date',
  OtherWarehouseNotes: 'Other Warehouse Notes',
  JobNo: 'Job No',
  NominatedAgent2: 'Nominated Agent',
  AirFreighMode: 'Air Freigh mode',
  WarehouseNo2: 'Warehouse No',
  PleaseInputJobNo: 'Please input jobNo',
  PrintProfitAnalysis: 'Print Profit Analysis',
  SendToBranchCompany: 'Send to branch company',
  EnterTransitInfo: 'Enter transit information',
  ArrivalForTheSecondJourney: 'Arrival for the second journey',
  LeaveForTheSecondJourney: 'Leave the second journey',
  PreAlertOperation: 'Pre-alert Operation',
  Actual: 'Actual',
  Frontcabin: 'Front cabin',
  FrontCabinActual: 'Front Cabin (Actual)',
  Documentation: 'Documentation',
  Select: 'Select',
  Join: 'Join',
  Separate: 'Separate',
  pbProportion: 'Pb Proportion',
  pbProportion2: 'Pb Proportion',
  SpaceRquirement: 'Space Requirement',
  OnBoardRequirements: 'Palletizing Requirements',
  DocumentationRequirements: 'Documentation Requirements',
  SellingPrice: 'SellingRate',
  BuyingPrice: 'BuyingRate',
  SalesBranchCompany: 'Sales Branch CMP',
  CopyFromOtherBill2: 'Copy From Other Bill',
  CodeSearching2: 'Code Searching',
  ResetInitialValue: 'Reset Initial Value',
  CopyTheMbl: 'Copy the MBL',
  InputWarehouseData: 'Input warehouse data',
  EditWarehouseData: 'Edit warehouse data',
  DeleteWarehouseData: 'Delete warehouse data',
  CancelInvalid: 'Cancel Invalid',
  MblInfo: 'MBL Info',
  AirOperation: 'Air Operation',
  CustomerSpecialRequirements: 'Customer Special Requirements',
  AirportHandlingAgent: 'Airport Handling Agent',
  CustomsTenBitCode: 'Customs Ten Bit Code',
  InspectionTenBitCode: 'Inspection Ten Bit Code',
  TradeDetail: 'Cargo Details',
  TradeCommission: 'Trade Commission',
  HblInfo: 'HBL Info',
  MBLInfo: 'MBL Info',
  Charge: 'Charge',
  InternalBillInfo: 'Domestic Bill',
  OverseaBillInfo: 'International Bill',
  AdvanceChargeInfo: 'Collection And Advance Payment',
  DocumentCirculation: 'Document Circulation',
  FileHistory: 'File History',
  ImportToPDF: 'Import To PDF',
  Trucking: 'Door-to-Door',
  ImportOperation: 'Import Operation',
  CustomsDeclarationOnward: 'Customs Declaration/Onward',
  WarehouseDoorLoading: 'Warehouse Door Loading',
  GrossWeight: 'Gross Weight',
  CustomJobType: 'Customized BIZ Type',
  TaxNature: 'Tax nature',
  ContainerInfo2: 'Container&Cargo Info',
  ContainerIdentification: 'Container identification',
  CopyConsignationDescriptionAndMarks: 'Copy Consignation Description and Marks',
  SelecteAll: 'Selecte All',
  ConsigneeShipperAndNotifyAddress: 'Consignee Shipper and Notify Address',
  ShipperId: 'Shipper Id',
  ConsigneeId: 'Consignee Id',
  NotifyId: 'Notify Id',
  ShipperInfo: 'Shipper Info',
  ConsigneeInfo: 'Consignee Info',
  NotifyInfo: 'Notify Info',
  CopyShipper: 'Copy Shipper',
  CopyConsignee: 'Copy Consignee',
  CopyNotify: 'Copy Notify',
  CopyManifestShipper: 'Copy Manifest Shipper',
  CopyManifestConsignee: 'Copy Manifest Consignee',
  CopyManifestNotify: 'Copy Manifest Notify',
  CopyAll: 'Copy All',
  FillInQuantityOfVotes: 'FillInQuantityOfShipments',
  QueryLCLJobOrder: 'AddWorkflowNoteQuery',
  QueryLCLJobOrder2: 'Add Split Work Order Query',
  QuantityOfSelectedOrder: 'SelectedQuantityOfShipments',
  NoDisplay: 'No Display',
  Number: 'NumberOfShipments',
  SelectSoNo: 'Select S/O No',
  MBLHBR: 'Combined MB/L No',
  AgentInfo: 'Agent',
  HBLHBR: 'CombinedHB/LNo',
  ChargeItem: 'ExpenseName',
  Close: 'Close',
  SearchJobNo: 'Search JobNo',
  SerialNo: 'Serial No',
  Search: 'Search',
  VolumeOnBl: 'Volume On Bl',
  MethodOfPayment: 'Method Of Payment',
  PortOfFinalDestination: 'Port of Final Destination',
  SelectContainerInfo: 'Select Container Information',
  SearchTheWarehouseRecords: 'Search the warehouse Records',
  ReceiptNo: 'Receipt No',
  warehouseOp: 'Warehouse OP',
  deliveryCMP: 'Delivery CMP',
  inDate: 'In Date',
  DamagedAndDamp: 'Damaged and Damp',
  EntryCustomsInformation: 'Entry customs information',
  Recorded: 'Recorded',
  ListPulled: 'List Pulled',
  AtReception: 'At Reception',
  CustomsDeclared: 'Customs Declared',
  Undeclared: 'Undeclared',
  CustomsExamination: 'Customs Examination',
  InspectionExamination: 'Inspection Examination',
  ExamedWithoutReleasing: 'Examed without releasing',
  AmendDeclaration: 'Amend Declaration',
  NotifyToDeclare: 'HoldToDeclare',
  CustomsExamed: 'HasProblemWithCustomsInspection',
  PreNumber: 'Pre_Number',
  ContainerNo2: 'CTNRTypeNumber',
  UnknownState: 'Unknown State',
  ProductName: 'ProgrammeName',
  Carrier: 'Carrier',
  RecordCount: 'Count',
  Autowire: 'AutoMatching',
  SchemaName: 'Schema Name',
  Receivable: 'ReceiptAndPayment',
  PartnerType: 'SettlementCurrencyType',
  Account: 'FixedSettlementUnit',
  MeasureCurrency: 'Measure Currency',
  MeasureUnit: 'Measure Unit',
  UnitRate: 'Unit Rate',
  MiniMum: 'MiniMum',
  FCLFreightTariff: 'FCL Freight Tariff',
  PleaseInputTariffSheet: 'Please input tariff sheet.',
  CostLeave: 'FreightRateTier',
  ValidFrom: 'Valid From',
  ValidTo: 'Valid To',
  MON: 'MON',
  TUE: 'TUE',
  WED: 'WED',
  THU: 'THU',
  FRI: 'FRI',
  SAT: 'SAT',
  SUN: 'SUN',
  GetCostsByTheCabinet: 'Lay Out Costs Acc To CTNR Type',
  ShippingFeesAreALLINTHEWAYImport: 'Import Ocean Freight Acc To ALL IN Or Not',
  PriceNo: 'FreightRateNumber',
  BranchCMP: 'Branch_CMP',
  IsDirect: 'Direct',
  PriceState: 'StowageStatus',
  Trend: 'Trend',
  Share: 'ShippingSpaceComeFrom',
  ContractNo: 'Contract No',
  PriceFrom: 'FreightRateComeFrom',
  SailingDate: 'Frequency',
  Voyage2: 'TransitTime',
  Cargo: 'Cargo',
  Box: 'Box',
  Dock: 'CallingPort',
  LCLFreightTariff: 'LCL Freight Tariff',
  ImportCostsByPeers: 'ImportExpenseAccToColoader',
  PriceState2: 'FreightRateStatus',
  CostValue: 'CostRate',
  PeerPrice: 'ColoaderRate',
  DirectPrice: 'DirectCustomerRate',
  MarketPrice: 'Marketrate',
  ClosingDay: 'CustomsCutOffDate',
  ShareCarrier: 'SpaceSharedShippingCompany',
  VerificationSchedule: 'WriteOffDetailsList',
  Cash: 'Cash',
  Check: 'Check',
  Transfer: 'Transfer',
  ClearingDate: 'WriteOffDate',
  PayReceiveDate: 'Pay peceive Date',
  VerificationBy: 'WriteOffBy',
  ClearCurrency: 'WriteOffCurrency',
  ClearRate: 'WriteOffExchangeRate',
  ClearAmount: 'WriteOffAmount',
  VoucherNo: 'Voucher No',
  OurBank: 'Our Bank',
  AddBillCharge: 'Add Bill Charge',
  RemoveBillCharge: 'Remove Bill Charge',
  ShowBillDetail: 'PresentIncoiceInfo',
  OverseasBillingMaintenance: 'Overseas Billing Maintenance',
  MainOffice: 'BillTitleCompany',
  BillType: 'Bill Type',
  BillAmount: 'TaxAmount',
  AccountObject: 'Account',
  Bank: 'Bank',
  BankAccount: 'Bank Account',
  CounterPartyBillingNo: 'AgentBillNo',
  InputDate: 'BillingDate',
  RevenueTotalGroup: 'TotalInEachCurrency',
  IncludingTaxAmount: 'PriceInclusiveTax',
  ExcludingTaxAmount: 'PriceExclusiveTax',
  WhetherCollectingAdvance: 'Whether collecting advance',
  Unit: 'Unit',
  Quantity2: 'Quantity',
  ShowLcl: 'PresentHouseShipmentExpense',
  AgentIntoBills: 'AgentProfitshareBill',
  Office: 'BillTitleBranchCompany',
  Percentage: 'ProfitshareProportion',
  IsPercentage: 'Proportion',
  ChargeEnglishName: 'Charge English Name',
  ChangeSchema: 'Change Schema',
  SendEMail: 'Send E-Mail',
  LocalAgent: 'Local Agent',
  placeholderVal: 'Please select mail template first and then select template',
  UpDestAgent: 'POL/PODAgent',
  Haulage: 'Fleet',
  CompanyName: 'Company Name',
  GroupCode: 'Company Code',
  CompanyAddress: 'CompanyAddress',
  Contact: 'Contact',
  OtherInformation: 'OtherInformation',
  BlTitle: 'BlTitle',
  BlAddress: 'BlAddress',
  BlContact: 'BlContact',
  MscBlAddress: 'MscBlAddress',
  PleaseChooseItem: 'Please Choose Item',
  WhetherDelete: 'Confirm To Delete ?',
  IsEmptyPleaseEnter: 'Is Empty, Please Fill Content.',
  Cc: 'CC',
  MailContent: 'Mail content',
  SystemEmail: 'System E-mail',
  CompanyMail: 'Company mail',
  PersonalMailbox: 'Personal mailbox',
  emailSubject: 'Email subject',
  mailTemplate: 'Mail template',
  SaveTheDefaultCC: 'Save the default CC',
  Title: 'Title',
  Content: 'Content',
  operationalMotion: 'operational motion',
  operationTime: 'operation time',
  receiptStatus: 'Customs receipt status',
  returnTime: 'return time',
  source: 'Source',
  PreCommitUser: 'Withholding person',
  PreCommitDate: 'Pre submission time',
  SubmissionDate: 'Submission time',
  CommitUser: 'submitter',
  RelatedSubmissionDate: 'Related submission time',
  RelatedCommitUser: 'Related submitter',
  RelatedPreCommitUser: 'Related pre submitter',
  RelatedPreCommitDate: 'Related pre submission time',
  FcAuditDate: 'Audit time',
  FcAuditUser: 'Reviewed by',
  LockJobDate: 'Order locking time',
  LockJobUser: 'Lockman',
  FileUpload: 'File Upload',
  FileName: 'File Name',
  FileSize: 'File Size',
  UploadProgress: 'Upload Progress',
  DocumentType: 'Document Type',
  SelectFile: 'Select file',
  DeleteFile: 'Delete file',
  Upload: 'Upload',
  Transit2: 'VIA',
  AuditDate: 'Adjust Date',
  PlsSeeEIR: 'PleaseSeeEquipmentReceipt',
  SelectCopyContent: 'Select Copy Vontent',
  DuplicateContent: 'Duplicate Content',
  BasicInfo: 'Basic Info',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAsk: 'Copy Acc To This Choice Onward No Need Ask Again. If you need to reset the conditions, you can click the Settings button in Settings and Tools——Page Personalization in the upper right corner',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskLeft: 'Set the content of this setting as the default copy, and will not remind you next time.',
  ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskRight: 'To set the copy content, please go to the Menu-Settings and Tools-Page personalization, click the settings button',
  Slaves: 'No Of House Shipments',
  Master: 'No Of Master Shipments',
  CustomerCount: 'Number Of Customers',
  SingleWeight: 'Single piece weight',
  Weight2: 'Weight',
  ReceivableType: 'Income And ExpensesType',
  AccountType: 'Settlement Currency Type',
  Account2: 'Settlement Object',
  Oversea: 'Domestic Overseas',
  Remove: 'Remove',
  SourceAmount: 'Original Amount',
  NewAmount: 'New Amount',
  IsUpdate: 'Is Update',
  ExportLog: 'Export Log',
  Role: 'Function',
  Mobile: 'Mobile',
  Email: 'E-mail',
  SOPOperatingState: 'SOP operation status',
  KG: 'KG',
  CBM: 'CBM',
  Tons: 'T',
  SelectOpRequirement: 'OPRequireToSelect',
  PleaseInputAKeyword: 'InputKeyWordSearching',
  contentDescription: 'Content',
  chargeItem: 'Charge Item',
  LCLLastBillOfLading: 'LCLUltimateB/L',
  Addr: 'Addr',
  HouseNumber: 'House Number',
  Country: 'Country',
  Province: 'Province',
  City: 'City',
  ZIP: 'ZIP',
  SelectCharge: 'Select Charge',
  First: 'First',
  Pre: 'Pre',
  Page: 'Page',
  AllPage1: 'Total',
  Next: 'Next',
  Last: 'Last',
  ShowFromTo1: 'From',
  ShowFromTo2: 'to',
  AllRecord1: 'Total',
  Convert: 'Convert',
  Received: 'Received',
  Paid: 'Paid',
  AllPositions: 'All Positions',
  DestinationAgent: 'Dest. Agent',
  Accessible: 'Accessible',
  IsDisplay: 'Is Display',
  Uncertain: 'Uncertain',
  DestinationAgent1: 'Overseas Agency',
  PassAudit: 'Pass The Audit',
  Refuse: 'Refuse',
  Bl: 'BL',
  Original: 'Original',
  LateOriginal: 'Late application',
  Correct: 'Correct',
  Message: 'Message',
  DeleteCustoms: 'Delete (customs delete, tradetech retains)',
  DeleteAll: 'Delete (deleted by tradetech Customs)',
  send: 'Send',
  change: 'Change single',
  deleteSingle: 'Delete single',
  cancelBill: 'cancel Bill',
  OverseasAgeFore: 'Overseas Agency Forecast',
  JclForecast: 'JCL forecast',
  AnnPackingList: 'Ann packing list',
  PreShippingBill: 'PreloadingManifest',
  PreShippingBillPperation: 'PreloadingManifest operation',
  ShippingBill: 'Manifest',
  Anti_terrorismShipping: 'AMS',
  CleanShipping: 'Clean Manifest',
  Suitcase: 'ContainerDrawing',
  DelSuitcase: 'CancelCTNRDrawing',
  ViewHistory: 'View History',
  ElectronicPackingList: '99 Electronic Packing List',
  SendHistory: 'Send History',
  ShippingSchedule: 'Shipping Schedule',
  PortOfLoadingArea: 'Port Of Loading Area',
  PortOfDestinationArea: 'Port Of Destination Area',
  ShipsCallSign: 'EDI Shipscallsign',
  ImportTheVoyage: 'Import The Voyage',
  IncreaseThePort: 'Increase The Port',
  DeletePorts: 'Delete Ports',
  AutomaticallyImportVoyage: 'Automatically Import Voyage',
  CountryOfRegistration: 'Country Of Registration',
  AddShippingCompany: 'Add Shipping Company',
  DelShippingCompany: 'Del Shipping Company',
  DepartureTime: 'Departure Time',
  DateOfOrder: 'Date Of Order',
  ProjectReceivedBy: 'Project Received By',
  dateOfFiling: 'Date Of Filing',
  ArchivePeople: 'FilePerson',
  ReturnOrderExpressNumber: 'ReturnOrderExpressNumber',
  StateOfTheWithdrawal: 'State Of The Withdrawal',
  EmptyTheList: 'ToCleanList',
  BatchStateTransition: 'Batch State Transition',
  CollectFormation: 'Collection Information',
  RetreatASingle: 'ReturnDOCList',
  BatchSaving: 'Batch Saving',
  AppendQueryRecord: 'Append Query Record',
  StateHisCase: 'CTNRDrawingStatus',
  BoxStatus: 'Box status (Shanghai port only)',
  StatusOfAnti_TerrorismManifest: 'StatusOfAnti-TerrorismManifest',
  ManifestStatus: 'ManifestStatus',
  AdvanceManifestStatus: 'PreloadingManifestEDIStatus',
  InstallPackingListStatus: 'PackingListEDIStatus',
  StateOfTheBillOfLading: 'B/LEDIStatus',
  BookingStatus: 'BookingStatus',
  reset: 'Reset',
  PrintStatus: 'Print Status',
  TeamContact: 'Team Contact',
  ContactNumber: 'Contact Number',
  DoorContact: 'Door Contact',
  DoorContactNumber: 'Door Contact Number',
  PleaseScanTheBarcodeOrInputDirectly: 'Please scan the barcode or input directly',
  CollectionSituation: 'CollectionSituation',
  DocumentDate: 'DocumentDate',
  checkbox: '[checkbox]',
  RefundDate: 'RefundDate',
  RefundPerson: 'RefundPerson',
  AutomaticallyRefresh: 'AutomaticallyRefresh',
  Piece: 'Piece',
  Volume: 'Volume',
  CartonQuantity: 'CTNRTypeQuantity',
  ClientsRequirement: 'ClientsRequirement',
  LandCarriage: 'RoadTransport',
  BatchUpdateType: 'BatchModifyContainerType',
  ShippingCmp: 'Carrier',
  CarrierSpecificCode: 'Shipping Company Specific Code',
  PortOfLoadingAI: 'POL',
  Synchronization: 'Synchronization',
  RiverCarrier: 'FeederCarrier',
  BatchShutOut: 'Batch Shut Out',
  OverseaCustomerService: 'Oversea Customs Service',
  CargoFeature: 'Cargo Feature',
  CustomerLevel: 'CustomerTier',
  ContractStatus: 'Contract Status',
  HBLNotifier: 'HBL Notifier',
  ExportWithSOPToExcel: 'ExportFromExcelInclSOPDetails',
  ManagerSubmission: 'Manager Submit',
  CustomerSelfRelease: 'B/L Issued By Customer',
  CompanySelfRelease: 'B/L Issued By Company',
  ManageAuditStatus: 'ProfitReviewStatus',
  QuantitySize: 'QuantitySize',
  isShutOut: 'Is Shut Out',
  EquipmentEstimatedReturnTimeFrom: 'EQ Est. R/T From',
  EquipmentEstimatedReturnTimeTo: 'EQ Est. R/T To',
  copyDGStuffing: 'Copy',
  pasteDGStuffing: 'Paste',
  viewDGStuffing: 'View',
  copyAndAddPoItems: 'Copy And Add',
  SynchroHBLInfo: 'Synchro HBL Info',
  Cubage2: 'VolumeM³',
  AMSLog: 'Log',
  AMSReceiptInfo: 'View Receipt Info',
  ViewAssociatedBusiness: 'View Associated Business',
  RevokeTuckOrder: 'Revoke Tuck Order',
  SearchTuckOrder: 'Search Tuck Order',
  ShowTuckOrderLog: 'Show Tuck Order Log',
  TuckStatus: 'Status',
  DriverNameHL: 'HL Driver Name',
  DriverPhoneHL: 'HL Driver Phone',
  TruckNoHL: 'HL Truck No',
  TmsNoHL: 'Truck Dispatch No',
  ContainerSerialNo: 'Container Serial No',
  ContainerNoDiff: 'Discrepancy Notice',
  isRelated: 'Is Related',
  CommissionedChargedWeight: 'DelegatedChargeableWeight',
  CustomsHasCheck: 'InspectedByCustomsAlready',
  CustomsOneRelease: 'OneRelease',
  CustomsRelease2: 'Release',
  PartnerShortType: 'Partner Type',
  DgconsignParty: 'DGCONSIGN',
  ElseInvoiceParty: 'ELSEINVOICE',
  ShowPODAgency: 'ShowPODAgency',
  FnlTm: 'InlandTransitMode',
  InvokeLocalMailClient: 'Local Mail',
  preview: 'Generate the attachment',
  attachment: 'attachment：',
  AddPackingInfo: 'Associated Packing Info',
  RemovePackingInfo: 'Remove Packing Info',
  sendJdy: 'Send to JDY',
  sendFailInfo: 'Successfully sent {0} messages, failed {1} messages',
  batchSendJdy: 'Batch send to JYD',
  batchUnlockGoodsDetails: 'Batch unlock goods details',
  IdentifyPackingList: 'Identify Packing List',
  BoxListRecognition: 'AI- container list recognition',
  SupportingUploadFormat: 'Uploading format pdf/xls/xlsx/doc/docx/jpg/gif/png is supported, and a single file does not exceed 4MB.',
  UploadedFile: 'Uploaded File',
  Parsing: 'Parsing',
  SpecialCharactersNotAllow: 'Special characters are not allowed in file names.',
  MaterialInformation: 'Material information',
  MaterialNumber: 'Material number',
  HsCode2: 'HS CODE',
  NetWeightKg: 'Net weight (KG)',
  PONumber: 'PO number',
  FilePreview: 'File Preview',
  MultiCabinets: 'Multi-Cabinets',
  CopyDoorPoint: 'Copy Door-to-Door Data',
  SelectCabinetData: 'Select cabinet making information',
  ExportPackingInfo: 'Export Packing Info',
  ImportPackingInfo: 'Import Packing Info',
  ContainerId: 'EQ ID',
  ContainerSeqNo: 'EQ Serial Number',
  TrailerRemark: 'Trailer Remarks',
  RemarkItems: 'Remark Items',
  DriverId: 'ID Card',
  DriverName: 'DriverName',
  DriverPhone: 'DriverPhone',
  TruckNo: 'TruckNo',
  EstimatArrivalTime: 'Estimated Arrival Time',
  DownloadImportResults: 'Download import result',
  ImportSuccess: 'Import Success',
  ImportFaildAndDownFile: 'There are data sets failed to import, please download the import results to view!',
  SendBack: 'Send Back',
  MSC: 'MSC',
  CompanyInfo: 'Company Information',
  LadingBillInfo: 'B/LInformation',
  HV: 'HV',
  RefNo: 'Ref.No.',
  DgStuffing: 'DG Stuffing',
  HSCODE: 'HSCODE',
  CustomsCommodity: 'Customs Declaration Items',
  TradeShortName: 'CommodityNameInShort',
  Code3: 'Code',
  TradeDescription: 'Commodity Description',
  ShippingMark: 'Shipping Marks',
  ZipCode: 'ZIP',
  EmailAddress: 'E-mail',
  VipCode: 'VIP Code',
  InttraCode: 'INTTRA Code',
  MscCode: 'MSC Code',
  CompanyCode: 'Company Code',
  LadingBillTitle: 'B/LTitle',
  LadingBillAddress: 'B/LAddress',
  LadingBillContactInfo: 'B/LContactDetails',
  MstBooking: 'MST BOOKING',
  SplitType: 'Split Type',
  RelatedOrderNo: 'Related Order Number',
  SignedType: 'ContractRateMode',
  FreightTerm: 'FreightClause',
  PlaceOfPayment: 'FreightPayableAt',
  ProductionInstallationPlace: 'PlaceOfReceipt',
  ProductionInstallationPlaceStation: 'PlaceOfReceiptCY',
  ProductionInstallationModeOfTransportation: 'PlaceOfReceiptShippingMode',
  PortOfLoadingWharf: 'Port Of Loading Wharf',
  PortOfDischargeWharf: 'Port Of Discharge Wharf',
  PortOfDischargeRequire: 'Port Of Discharge Require',
  Destination: 'Destination',
  DestinationStation: 'Station Of Destination',
  DestinationTransportWay: 'DestinationTransitMode',
  TransferCountry: 'TransitCountry',
  BlNumber: 'BL NUMBER',
  FreightBL: 'Freight BL',
  PODAgency: 'POD Agency',
  MscServiceCode: 'Service Code',
  ToOrderType: 'TO ORDER TYPE',
  DestinationZipCode: 'Destination Zip Code',
  CopyCompany: 'Copy Company Info',
  ChargeImport: 'Charge Import',
  customerLevel: 'CustomerTier',
  isSignContract: 'ContractSignedOrNot',
  RemovePacking: 'Remove Packing',
  LastContainerDescription: 'FinalCommodityDescription',
  SelectLocation: 'Select Location',
  BillingOfLadingRecordManager: 'B/L Journal',
  ApplyForARelease: 'Apply for a release',
  RequestReleaseBy: 'Placing a single applicant',
  TicketHasSplit: 'This ticket has been split, please submit an application in the split order',
  TicketHasMerged: 'This ticket has been merged, please submit your application in the merged ticket',
  RequestReleaseDate: 'Date of application',
  RequestReleaseState: 'The status of the request for issuance',
  MblRequestReleaseState: 'MBL Release Request Status',
  HblRequestReleaseState: 'HBL Release Request Status',
  NotApplying: 'Not Applying',
  NoGuarantee: 'No guarantee',
  InEffect: 'In Effect',
  Expired: 'Expired',
  Uploaded: 'Uploaded',
  NotUploaded: 'Not Uploaded',
  NoUploadRequired: 'No Upload Required',
  NotUploadedYetPlease: 'Not uploaded yet, please',
  LongTermGuaranteeState: 'Long Term Guarantee State',
  SingleTicketGuaranteeState: 'Single Ticket Guarantee State',
  Requested: 'Requested',
  WithdrawTheRequestForRelease: 'Withdraw the request for release',
  NoRequestReleaseData: 'There is no data that needs to be applied for',
  NoCancelRequestReleaseData: 'There is no data that needs to be withdrawn from the request for release',
  GetBack: 'Fetch',
  CancelGetBack: 'WithdrawFetch',
  Releasing: 'Releasing',
  CancelReleasing: 'Releasing Canceling',
  StatusModefySuccessfully: 'Status Modefy Successfully',
  ReleasingDate: 'Release Date',
  mblReleasingDate: 'MBL Release Date',
  receiptDate: 'Receipt Date',
  receiptContent: 'Receipt Content',
  receiptCode: 'Receipt Code',
  createdDate: 'Date',
  createdBy: 'Operator',
  content: 'Content',
  consignorCode: 'Consignor Code',
  codeAbbreviation: 'Code Abbreviation',
  enterpriseCode: 'Enterprise Code',
  consignorName: 'Consignor Name',
  consignorDetailAddress: 'Consignor Detail Address',
  consignorPhone: 'Consignor Phone',
  consignorEmail: 'Consignor Email',
  consignorRelexNumber: 'Consignor Relex Number',
  cityName: 'City Name',
  consignorCityName: 'Shipper City Name',
  provinceCode: 'Province Code',
  provinceName: 'Province Name',
  postalCode: 'Postal Code',
  countryCode: 'Country Code',
  aeoEnterpriseCode: 'AEO Enterprise Code',
  formatSynchronizeToOrder: 'Format Synchronize To Order',
  ladingBill: 'ToOrderB/L',
  consigneeCode: 'Consignee Code',
  consigneeCodeAbbreviation: 'Consignee Code Abbreviation',
  consigneeEnterpriseCode: 'Consignee Enterprise Code',
  consigneeName: 'Consignee Name',
  consigneeDetailAddress: 'Consignee Detail Address',
  consigneePhone: 'Consignee Phone',
  consigneeEmail: 'Consignee Email',
  consigneeRelexNumber: 'Consignee Relex Number',
  consigneeCityName: 'Consignee City Name',
  consigneeProvinceCode: 'Consignee Province Code',
  consigneeProvinceName: 'Consignee Province Name',
  consigneePostalCode: 'Consignee Postal Code',
  consigneeCountryCode: 'Consignee Country Code',
  consigneeAeoEnterpriseCode: 'Consignee AEO Enterprise Code',
  specificContactName: 'Specific Contact Name',
  specificContactPhone: 'Specific Contact Phone',
  specificContactAddress: 'Specific Contact Address',
  specificContactRelexNumber: 'Specific Contact RelexNumber',
  notifyingCode: 'Notifying Code',
  notifyingCodeAbbreviation: 'Notifying Code Abbreviation',
  notifyingEnterpriseCode: 'Notifying Enterprise Code',
  notifyingName: 'Notifying Name',
  notifyingDetailAddress: 'Notifying Detail Address',
  notifyingPhone: 'Notifying Phone',
  notifyingEmail: 'Notifying Email',
  notifyingRelexNumber: 'Notifying Relex Number',
  notifyingCityName: 'Notifying City Name',
  notifyingProvinceCode: 'Notifying Province Code',
  notifyingProvinceName: 'Notifying Province Name',
  notifyingPostalCode: 'Notifying Postal Code',
  notifyingCountryCode: 'Notifying CountryCode',
  notifyingAeoEnterpriseCode: 'Notifying AEO Enterprise Code',
  formatManifestInformation: 'Format Manifest Information',
  copyManifestLink: 'Copy Manifest Link',
  inviteSupplementManifest: 'Invite Supplement Manifest',
  freightChargesInfo: 'Freight Charges Info',
  freightChargesUSDTotal: 'Freight Charges USD Total:',
  tips: 'Tips',
  checkNominatedAgent: 'NominatedAgent Can\'t be Null!',
  checkActualNotifyParty: 'ActualNotifyParty Can\'t be Null!',
  checkConsignationCompany: 'ConsignationCompany Can\'t be Null!',
  checkLoadingPort: 'LoadingPort Can\'t be Null!',
  checkLoadingPort2: 'LoadingPort Can\'t be Null!',
  checkPortOfDischarge: 'PortOfDischarge Can\'t be Null!',
  checkPlaceOfDelivery: 'PlaceOfDelivery Can\'t be Null!',
  checkFinalDestination: 'Final Destination Can\'t be Null!',
  checkDateOfDepartureAndDateOfArrival: 'Date Of Departure  Can\'t be later than Date Of Arrival!',
  checkSales: 'Salers Can\'t be Null!',
  checkDept: 'Dept Can\'t be Null!',
  searchInfo: 'Don\'t Input Search Information!',
  checkVslVoy: 'Please input Vsl/Voy.',
  prePlanBooking: 'Preload Manifest',
  VgmInfo: 'VGMInfo',
  ChooseSoNoInfoToCopy: 'Please select the customs clearance information to copy~',
  ChooseContainerInfoToCopy: 'Please select box information for copying~',
  manifestLinkCopy: 'Manifest Link Copy',
  manifestInviteSupplement: 'InviteSupplement',
  manifestQueryLog: 'Query Log',
  manifestCfmStateLog: 'CfmState',
  manifestByPreShipping: 'PreloadingManifest',
  manifestByClearBooking: 'ClearBooking',
  manifestCfmButton: 'Confirm',
  manifestUnLockButton: 'UnLock',
  HBLWeight: 'HBL Weight',
  HBLQuantity: 'HBL Quantity',
  BillPortOfLoading: 'BillPOL',
  BillPortOfDischarge: 'BillPOD',
  BillPlaceOfDelivery: 'Bill Place of Delivery',
  UserDefinedField1: 'Content 1',
  UserDefinedField2: 'Content 2',
  UserDefinedField3: 'Content 3',
  UserDefinedArea: 'Customized Info',
  PleaseAddConsigneeFirst: 'Please Add CONSIGNEE First',
  CopyConsigneeToNotify1: 'Copy CONSIGNEE',
  OnlyOne: 'Only Select One',
  CopyPoItemInfo: 'CopyCTNRCargoInfo',
  CopySuccess: 'Copy Success',
  CopyFaild: 'Copy Faild',
  PaseteSuccess: 'Pasete Success',
  NoPasetePoItemInfo: 'NoCopyPoItemInfo Please Select PoItem',
  IsOrNotSpelling: 'AddNewLcLShipmentOrNot',
  Insure: 'Insure',
  billPaymentNo: 'ApplicationNumberForPayment',
  confirmUser: 'Confirm User',
  ediFeedBackState: 'ReceiptLog',
  receiptPrompt: 'Prompt: The system will automatically get the receipt of the data within 20 days after sending the manifest.',
  loadingManifestReceipt: 'Loading manifest receipt',
  customsReceipt: 'General Administration of Customs manifest',
  receiving: 'Receiving',
  receiptFailed: 'Receipt failed',
  receiptSucceeded: 'Receipt succeeded',
  customCode: 'Customs code',
  transportation: 'type of shipping',
  receiptBillType: 'Bill of lading type',
  transportationName: 'Name of means of transport',
  receiptVoyage: 'Flight/voyage',
  importArrivalSignal: 'Import arrival confirmation mark',
  receiptBillNumber: 'Construction order',
  entryDepatureDate: 'Entry date',
  itemCount: 'number',
  kilogram: 'kg',
  receiptWeight: 'quantity',
  tallyStatus: 'Tally status',
  exportArrivalStatus: 'Export arrival status',
  sendLog: 'Send Log',
  ediStatus: 'EDI Status',
  ManifestDeliveryStatus: 'Manifest delivery status',
  chooseShipper: 'Choose Shipper',
  chooseConsignee: 'Choose Consignee',
  chooseNotify: 'Choose Notify',
  bulkReplication: 'BatchCopyPaste',
  PlannedDepartureTime: 'Planned departure time',
  ActualDepartureTime: 'Actual departure time',
  PlannedArrivalTimeAtTheFactory: 'Planned arrival time at the factory',
  RealTimeOfArrivalAtTheFactory: 'Real time of arrival at the factory',
  PlannedTimeToLeaveTheFactory: 'Planned time to leave the factory',
  ActualTimeToLeaveTheFactory: 'Actual departure time',
  PlannedArrivalTime: 'Planned arrival time',
  ActualArrivalTime: 'Actual arrival time',
  currentLocation: 'current location',
  ViewExceptions: 'View exceptions',
  travelTime: 'On Road Time',
  DriverIDCard: 'Driver ID card No.',
  Hour: 'Hour',
  Minute: 'Minute',
  salesOffice: 'Sales CMP',
  opOffice: 'OP CMP',
  BookingAgentIsNull: 'Booking agent is null',
  PortOfDepartureAgentSOPReceiver: 'Port of departure agent SOP Receiver',
  DesignatedFreightAgentSOPReceiver: 'Designated Freight Agent SOP Receiver',
  PortOfDestinationAgency: 'Port of destination agency SOP Receiver',
  PrincipalUnitSOPReceiver: 'Principal Unit SOP Receiver',
  Collectioninformation: 'Collection Information',
  Appendqueryrecord: 'AddToQueryRecords',
  SalesOfGoods: 'Sales for Order.',
  BatchProcessing: 'Batch Processing',
  ClickSpaceToDropDownOptions: 'Click space to drop down options',
  PleaseMaintainTheCorrespondingSalesInThePartner: 'Please maintain the corresponding sales in the partner',
  CheckRecordedCustomsDeclaration: 'Query recorded',
  ClearPacking: 'Clear Container',
  CopyMarksFromReceipt: 'CopyMarksFromReceipt',
  PODCountry: 'POD Country',
  Details: 'Details',
  import: 'Import',
  DangerousClass: 'Dangerous Class',
  DangerousGoodsContact: 'Dangerous goods contact',
  DangerousGoodsContactPhoneNumber: 'Dangerous goods contact phone number',
  emptyBox: 'Empty Box',
  Email2: 'Email',
  PreverifyStatus: 'Preverify Status',
  ShipperByCompany: 'Shipper By Company',
  ConsigneeByCompany: 'Consignee By Company',
  ChangeCommit: 'Change Charge Commit',
  ConfirmChangeCommit: 'Confirm Change Charge Commit?',
  UserDefinedField4: 'Content 4',
  BoardSales: 'Board System Sales',
  BoardCsr: 'Board System Csr',
  BoardSite: 'Board System Site',
  ArrivalMethod: 'Arrival Method',
  FlightLabel: 'Flight Label',
  bargePOL: 'Barge POL',
  SalesRequire: 'Sales Require',
  OnlyDisplayTicket: 'Show Only Tickets That Meet The Conditions',
  batchImportCharge: 'Batch Import Charge',
  importCharge: 'Import Charge',
  historyLogQuery: 'History Log Query',
  noRule: 'No Rule',
  MBLNO: 'MBL NO',
  importSetting: 'Import Setting',
  receivable: 'Receivable',
  payable: 'Payable',
  importFile: 'Import File',
  confirmImport: 'Confirm Import',
  checkLines: 'The number of lines cannot exceed 1000',
  checkLines200: 'The number of lines cannot exceed 200',
  checkChargeInfo: 'Please input the related information of expense and import again!',
  internal: 'Domestic',
  overseas: 'Overseas',
  batchOperate: 'Batch Operate',
  batchImport: 'Batch Import',
  activity: 'activity',
  JobInfo: 'Job Info',
  Service: 'Service',
  Supplier: 'Supplier',
  InnerInfo: 'Inner Info',
  Defined: 'Defined',
  MoreInfo: 'More Info',
  unDisplayInfo: 'un Display Info',
  GeneralInfo: 'HouseShptsInfo',
  BatchModifiedState: 'Batch Modified State',
  SplitTicketsInfo: 'Split Tickets Info',
  destinationStation: 'Destination Station',
  departureStation: 'Departure Station',
  transitStation: 'Transit Station',
  destinationStationRailport: 'Destination Station Railport',
  departureStationRailport: 'Departure Station Railport',
  transitStationRailPort: 'Transit Station Railport',
  CommonInfo: 'Common Info',
  settlementAgent: 'Settlement Agent',
  Dimension: 'DimensionCM(length*width*Height)',
  PaymentType: 'PaymentType',
  ToPay: 'ToPay',
  PrePay: 'PrePay',
  PickUpGoods: 'Pick Up Goods',
  DocumentationNumberOfPackages: 'Documentation Number Of Packages',
  DocumentationGrossWeight: 'Documentation Gross Weight',
  DocumentationVolume: 'Documentation Volume',
  DocumentationChargedWeight: 'Documentation Charged Weight',
  CustomerQuantity: 'Customer Quantity',
  CustomerGrossWeight: 'Customer Gross Weight',
  CustomerVolume: 'Customer Volume',
  CustomerChargedWeight: 'Customer Charged Weight',
  ImportTime: 'ImportTime',
  descr: 'descr',
  logFile: 'logFile',
  VerifyReviewThrough: 'Verify Review Through',
  VerifyReviewRefusal: 'Verify Review Refusal',
  ChargeBranchId: 'Charge CMP',
  DateCreated: 'Input Date',
  ProfitOwner: 'Profit Owner',
  ScfiDeclare: 'SCFI Declare',
  ScfiPrice: 'SCFI Price',
  Copy: 'Copy',
  needInvoice: 'Need Invoice',
  InvoiceNo: 'Tax No',
  ArrivalTime2: 'Date of arrival',
  ProjectName: 'Project Name',
  ProjectBatch: 'Project Batch',
  CargosExpectedArrivalDateByTrucking: 'Expected Arrival Date(Trucking)',
  CargosExpectedArrivalDateWarehouseLoading: 'Expected Arrival Date(Warehouse Loading)',
  CargosExpectedArrivalDatePacking: 'Expected Packing Date',
  EstimatedPackTheCabinetTime: 'Estimated Pack The Cabinet Time',
  MaintainJobNoRule: 'Please maintain work number coding rules!',
  SelectCodeRule: 'Please select coding rule',
  CodeRuleDesc: 'Description of coding rules',
  SpecifyAgentNumber: 'Specify the number of agents',
  CustomsClearanceChargeRelatedEdit: 'Only fee related changes can be made when there is a fee for customs clearance',
  CustomsClearanceNoChargeNoChange: 'No charge for customs clearance, no change(All fees will be deleted)',
  ClearFeeNoChargeCustomsClearance: "No fee exit if you don't clear the confirmed fee, you can't exit without fee.",
  VotesPreSubmission: ' votes for pre submission?',
  AllNotPositiveOperationStatus: 'All the selected data records are in non positive operation status',
  AllNotToVerifyStatus: 'All the selected data records are in non to verify status',
  ContainerLoadTypeNotCorrect: ' the whole consolidation type of the ticket business is not self consolidation, buyer console or entrusted consolidation',
  RecordNotPositiveOperationStatus: ' the ticket business is not in "operation" status',
  RailwayCheckLob: 'The selected job has different business types. Please select the same business type and try again.',
  TheTicketIsMain: ' the ticket business is the main ticket',
  TheTicketAssociatedMain: ' the ticket business has been associated with the main ticket',
  TheTicketAssociatedContainerInfo: ' the ticket business has been associated with packing information',
  ContainerLoadTypeIs: ' the whole spelling type has been changed to ',
  NoneModified: ' no modification required',
  ContainerLoadTypeBatchModifySuccess: 'Batch modification of whole spell type succeeded:',
  NoDataProcessed: 'No data processed',
  CustomsInformation: 'Customs information',
  AddFile: 'Add file',
  CustomsReceiptFile: 'Customs receipt file',
  CustomsReceiptState: 'Customs receipt state',
  CloneCabinBerth: 'Clone Cabin Berth',
  BackFillCabinBerth: 'BackFill Cabin Berth',
  GenerateBusiness: 'Generate Business',
  ReturnCabin: 'Return Cabin',
  CheckBeforeEntrust: 'The {0} you entrust does not maintain the SCAC code of {1} and other relevant information. Please check with the other party before entrusting!',
  CheckPortBeforeEntrust: 'The [{0}] you entrusted does not maintain the [{1}] port, please check with the other party before entrusting!',
  CheckPackBeforeEntrust: 'The [{0}] you entrusted does not maintain the [{1}] pack, please check with the other party before entrusting!',
  PortDataPushLog: 'Port data push log',
  EdiStatusChangeLog: 'Edi status change log ',
  BookingReceiptLog: 'Booking receipt operation log',
  MergeAndSingle: 'Merge and single',
  OuJianDeclaration: 'Ou Jian declaration',
  AirportPort: 'Port of the airport',
  Airport: 'airport',
  GoodsStoragePlace: 'Place where goods are stored',
  ExchangeServiceAi: 'Do I need to draw an order',
  DataPushChangeLog: 'Data push change record',
  SendBookingData: 'Send booking data',
  SelectAction: 'Select Action',
  IsGroupBranch: 'Group branch or not',
  SmtpServerError: 'Smtp server error ',
  NotConnectSmtpServer: 'Unable to connect to SMTP server',
  NotFindFile: 'The system cannot find the specified file',
  SendFileError: 'Error sending file',
  AttachTemplateError: 'Attachment template error',
  MailSentSuccess: 'Mail sent successfully',
  PleaseSelectAction: 'Please select an action',
  PleaseSelectCategory: 'Please select the category of goods',
  PleaseSelectOpDep: 'Please select the operating department',
  SeaExportLetter: 'Letter of authorization for ocean export freight',
  DataPush: 'Data push',
  MasterTicketSync: 'Master ticket synchronization',
  BookingDataSentSuccess: 'Booking data sent successfully!',
  CostSettlementObjectBlocked: 'The settlement object [{0}] of the expense has been blocked and may be at risk. Do you want to continue saving?',
  ConsigneeRequired: 'Please input the send and receive information of Hb / L interface!',
  OverseaCustomerUpdate: 'The original overseas customer service [{0}] is invalid. Update to new overseas customer service [{1}]',
  ConatainerNoRemoveRelation: 'All data with case number {0} will be removed. Do you want to continue',
  EDIContainers: 'Packing Information EDI',
  ContainersLog: 'Packing information receipt log',
  PleaseSelect2: 'Please select the business to send!！',
  MingShen: 'Minsheng',
  MingShenCompany: 'Minsheng International Shipping Agency Co., Ltd',
  EDIBooking: 'EDI Booking',
  EDIDoc: 'EDI Doc',
  RoundPaymentAmountExchangeRate: 'Round (payment amount * payment exchange rate)',
  VGMIsEmpty: 'VGM is empty!',
  VGMRaw: 'VGM raw',
  VGMCorrection: 'VGM correction',
  FileOnlyXlsXlsx: 'Upload file can only be XLS, xlsx format!',
  FileOnlyXlsx: 'Upload file can only be xlsx format!',
  stayTuned: 'Stay Tuned',
  UploadImageFormatWrong: 'The uploaded image format is wrong. At present, the image formats we support are PNG, JPG and JPEG. Please transcode or change the image',
  ItIsEmpty: 'It is empty',
  AdvancePayment_ActualAmount_HandlingCharge_PostTelecommunicationCharge_AcceptanceHandlingCharge: 'Advance payment in foreign exchange (RMB) - actual amount of foreign exchange payment (RMB) - handling charge (RMB) - post and telecommunication charge (RMB) - Acceptance handling charge (RMB)',
  RelatedBusinessNoSpecial: 'There is no special cargo information for related business',
  ReceiptImportFailed: 'Receipt import failed!',
  ReceiptImportedSuccessfully: 'Receipt imported successfully!',
  ReceiptImport: 'Receipt import',
  CopyLinkPublic: 'Copy link (public)',
  CopyLinkPromissoryNote: 'Copy link (promissory note)',
  RepeatBoxType: 'There are two records of the same box type and box type',
  RepeatUldType: 'A record of the same container code already exists!',
  RealDepartureTime: 'Actual departure time',
  RealDeparture: 'Actual departure',
  ActualBerthingTime: 'Actual berthing time',
  ImportFailedContactAdministrator: 'Import failed, please contact administrator.',
  ContractPeriod: 'Partner: ${0} has a valid contract, please go to [Contract Management] to adjust the corresponding credit account.',
  HasBeenSelected: 'Has been selected',
  HasExceeded: 'Has exceeded!',
  HasExceededCannotEDI: 'Has exceeded, cannot EDI!',
  UnloadingPortNotMaintain: 'Currently, the "unloading port" of the "entrusting company" does not maintain the corresponding agent. Do you want to clear the selected designated freight agent and sales information?',
  EnYuanHuaXiaKu: 'EN Yuan Hua Xia Ku',
  EnyuanYangyuanKu: 'Enyuan yangyuanku',
  EnyuanGaoxiangku: 'Enyuan gaoxiangku',
  NotInsuranceOperationPermission: 'You do not have [insurance] operation permission!',
  CorrectionBillOfLading: 'Correction of bill of lading',
  ConfirmationBillOfLading: 'Confirmation of bill of lading',
  Tips: 'Tips!',
  PickUpTypeDifferentSmallTicket: 'Pick up type is different from small ticket. Are you sure you want to save it?',
  OperationDepartmentCannotBeEmpty: 'Operation department cannot be empty',
  FileContentIsEmpty: 'The file content is empty',
  FileContentWrong: 'The content of the document is wrong',
  FileSizeCannotLargerThan2MB: 'The file size cannot be larger than 2MB',
  NoData: 'No data',
  NoBusinessSelected: 'No business selected',
  OriginalNormal: 'original',
  NoImportEDI: 'There is no EDI to import for this order',
  PackingDataNotCconsistent: 'The packing data of this work order is not consistent with the actual data, please check the packing information!',
  CreditControlTheClient: 'Credit control of the client',
  SaveBusinessBeforeEnterMultiGate: 'Note: please save the business before entering multi gate',
  SaveBusinessBeforeEnterMultiGate2: 'Note: Please save the business before entering multiple doors or counters',
  BookingWorkspace_PrePlan_ImportExcel: 'Shipping booking Express Edition - pre configuration information - import to excel',
  SpecialCargoNumber: 'Special cargo number',
  RelevantTicketsResetAndUpdated: 'After confirmation, the relevant tickets will be reset and updated. Do you want to synchronize?',
  ManifestConfirmed: 'Manifest confirmed!',
  ManifestDataIsEmpty: 'Manifest data is empty!',
  ManifestConfirmationFailed: 'Manifest confirmation failed!',
  NodeTriggerFailed: 'Node trigger failed!',
  LoadingOfPackingInformationFailed: 'Loading of packing information failed.',
  PlanDepartureTime: 'Planned departure time',
  PlannedBerthingTime: 'Planned berthing time',
  OriginalPlanDepartureTime: 'Original planned departure time',
  OriginalPlannedBerthingTime: 'Original planned berthing time',
  NowPlanDepartureTime: 'Current planned departure time',
  NowPlannedBerthingTime: 'Current planned berthing time',
  CurrentETA: 'Current ETA',
  OriginalETA: 'Original ETA',
  CurrentETA1: 'Current ETA (estimated time of arrival)',
  OriginalETA1: 'Original estimated time of arrival (ETA)',
  ShippingScheduleNew: 'Shipping Schedule Import Template (New Version)',
  ShippingScheduleold: 'Shipping schedule import template (old version)',
  ImportNew: 'Import (New Version)',
  ImportOld: 'Import (old Version)',
  PlannedBerthing: 'Planned berthing',
  PlanDeparture: 'Planned departure',
  BookingEDI: 'Booking EDI',
  BookingCorrection: 'Booking correction',
  PortMaintainedDesignatedFreightForwarder: 'The port has maintained the corresponding designated freight forwarder. Do you want to use the designated freight forwarder maintained by the port?',
  MBLStatusNotIsUnStart: 'The MBL status of the ticket is not not not started and cannot be imported.',
  PrimaryOrderNotSameReceipt: 'The primary order number of the bill is inconsistent with that of the receipt. Do you want to continue importing?',
  RequestSuccessful: 'Request successful!',
  SpecialCharacters: 'Special characters exist, unable to initiate subscription to port or shipping company data',
  EnterReleaseNumber: 'Please enter the release number',
  SelectAPieceOfData: 'Please select a piece of data!',
  SelectARecord: 'Please select a record!',
  ChooseDesignatedAgent: 'Please choose the designated agent!',
  ChooseSpecialGoods: 'Please choose special goods!',
  CargoInformationIsEmpty: 'Cargo information is empty',
  InviteSupplementaryLinksPublic: 'Invite supplementary links (public)',
  InviteSupplementaryLinkPromissoryNote: 'Invite supplementary link (promissory note)',
  DownloadCWTemplate: 'Download CargoWare Template',
  DownloadCWTemplateJC: 'Download CargoWare Template (JC)',
  DownloadSeaHouseTemplate: 'Download Sea House Template',
  DownloadWseTemplate: 'Download CargoWare Template (QingDao)',
  DownloadWseTemplateSh: 'Download CargoWare Template (ShangHai)',
  ExportSinO56TemplateNb: 'Export the SINO56 template(NingBo)',
  DownloadWseTemplateVgm: 'Download Wse Template',
  SendingChannelVgm: 'Sending channel',
  MailSendingFailed: 'Mail sending failed!',
  DistributionFailed: 'Distribution failed',
  SalesAndOperationAreSame: 'Sales and operation are the same. Are you sure you want to save?',
  PreConfiguredManifestAPI: 'Pre configured manifest API',
  PreConfiguredManifestDeletion: 'Pre configured manifest deletion',
  PreConfiguredManifestIsEmpty: 'The deletion object of pre configured manifest is empty, please refresh the page and try again',
  CorrectionOfPreAllocatedManifest: 'Correction of pre allocated manifest',
  OperationFailed: 'Operation failed!',
  RedOffsetCannotModified: 'Red offset fee or red offset fee cannot be modified again. Please select Add adjustment',
  RedOffsetCannotDeleted: 'Red charge or red charge cannot be deleted. Please select again',
  MaintainNodeDetailCode: 'Please maintain the node detail code',
  DeleteNumRecord: 'Are you sure you want to delete this {0} record?',
  DeleteNumFile: 'Are you sure you want to batch delete these {0} files?',
  ClickYesRetrievedToReturnedStatus: 'Click "yes" to jump to the print page and change the "retrieved" document to "returned" status.',
  ClickYesToReturnedStatus: 'Click "yes" to jump to the print page and modify the document to "returned" status.',
  FileNotAllowedView: 'No one is allowed to view or download the {0} file',
  NoPermissionToView: 'You do not have permission to view or download [{0}] files',
  UploadFailed: 'Upload failed!',
  UploadSuccess: 'Upload success!',
  UploadSuccessNoOrder: 'Upload success, no related order found!',
  UploadedFileNotMatch: 'The type of the uploaded file does not match, please check!',
  UploadType: 'Upload type',
  FileSource: 'File Source',
  ReceiptType: 'Receipt Type',
  SendAisle: 'EDI Aisle',
  BusinessNotSubmitted: 'Business not submitted, cannot refund',
  BusinessNotBeenApproved: 'The business has not been approved. Are you sure you want to return it?',
  NoPermissionToViewOrprinted: "You don't have permission to view files uploaded or printed by others",
  DocumentDelivery: 'Document delivery',
  SameStatusCanBePrinted: 'Only documents with the same status can be printed!',
  ReceiptContent: 'Receipt content',
  ReceiptTime: 'Receipt time',
  PrintCommonControls: 'Print common controls',
  CustomsBrokerOthers: 'Customs broker / others',
  ReceiveReceiptTime: 'Receipt time',
  ReceivingAddress: 'Receiving address',
  bookingParty: 'booking party ',
  BusinessIsLocked: 'The business is locked and cannot be refunded',
  ConfirmUploadFileType: 'Please confirm the type of upload file, continue to upload?',
  InputCustomerName: 'Please input customer name!',
  InputExpressNumber: 'Please input the express number!',
  InputExpressAddress: 'Please input the express address!',
  InputRecipient: 'Please enter the recipient!',
  InputRecipientName: 'Please enter the recipient name!',
  InputReceivingcompany: 'Please enter the receiving company!',
  InputReceivingAddress: 'Please input the receiving address!',
  InputContactNumber: 'Please input contact number!',
  InputContactNumberMark: 'Please input contact number!',
  InputReturnExpressNumber: 'Please enter the return express number!',
  ReturnInformation: 'Return information',
  ReturnDateGreaterThanRetrieveDate: 'Return date must be greater than retrieve date!',
  dateModified: 'Date Modified',
  OperationCannotBeEmpty: 'Operation Can not Be Empty.',
  OperationCompanyCannotBeEmpty: 'Operation Company Cannot Be Empty.',
  BookingAudit: 'Booking Audit',
  UseThisNo: 'Use This No',
  WarehousingFee: 'Warehousing Fee',
  BookingSuccess: 'Booking Success',
  ToBeConfirmed: 'To Be Confirmed',
  BookingFail: 'Booking Fail',
  CabinState: 'Cabin State',
  CostGenerationMethod: 'Cost generation method',
  SettlementInPriginalCurrency: 'Settlement in original currency',
  SettlementInBillCurrency: 'Settlement in bill currency',
  ShowDetails: 'Show details',
  ImportResultLog: 'Import Result Log',
  ImportComplete: 'Import Complete',
  SuccessItemFailedItem: 'success【{0}】number，fail【{1}】number。',
  ContinueImporting: 'Continue Importing',
  DownloadResultLog: 'Download Result Log',
  PONo: 'PO NO.',
  VoyageOnlyNum: 'Only numbers or letters can be entered for voyage.',
  UpdateSuccess: 'Update Success.',
  ShippingSpace: 'Shipping Space',
  RejectTips: 'Are you sure you want to reject {0} for approval? Please enter the reason for rejection:',
  GenerateBusinessTips: 'Are you sure to generate business? (cannot be revoked after generation)',
  ReturnedShipping: 'Are you sure that the flight has been returned? (record is irrevocable after returning)',
  ReturnedShippingSuccess: 'Successfully disembarked',
  ShippingCompanyAndBookingAgent: 'Please enter the corresponding shipping company and booking agent',
  CabinCopySuccess: 'Cabin copied successfully: the new business number is:',
  CheckShippingCompanyAndBookingAgent: 'Shipping company and booking agent cannot fill in only one item',
  ReviewRejectedSuccess: 'Review rejected successfully',
  ReviewSuccess: 'Review successfully',
  BatchReviewSuccess: 'Batch Review successfully',
  CheckBatchReview: 'Batch review business can not exceed 50!',
  RefuseSuccess: 'Refuse success',
  BatchAuditSuccess: 'Batch audit succeeded',
  AuditSuccess: 'Audit succeeded',
  CheckCreditTipOne: 'The client of the following business has exceeded credit control and cannot be approved',
  CheckCreditTipTwo: 'The client of the following business has exceeded credit control. Are you sure you want to pass the audit?',
  BatchAuditBusinessTip: 'Batch audit business cannot exceed 50!',
  CheckCreditSaveTip: 'Due to the over control of the credit, the promissory note has been locked, it will not be able to print or EDI. Please contact the superior to unlock if necessary!',
  CabinCopy: 'Cabin Copy',
  EnterShippingCompany: 'Please enter the shipping company in [space {0}]',
  EnterBookingAgent: 'Please enter the booking agent in [space {0}]',
  EnterEtd: 'Please enter the departure date in [space {0}]',
  CheckEnterShippingCompanyBookingAgentEtd: 'Please input the shipping company, booking agent and sailing date corresponding to the class',
  UnreviewedBusinessNumber: 'Unreviewed business number:{0}',
  UnreviewedBusinessNumber2: 'Unreviewed business number',
  DateOfCreation2: 'Create Time',
  plateNumberAndMblCannotBeEmpty: 'License plate number and bill of lading number cannot be empty.',
  ActualDateOfDeparture: 'ATD',
  ActualDateOfDeparture2: '(Acture Time of Departure)ATD',
  nameOfVesselCannotBeEmpty: 'Name of vessel cannot be empty!',
  voyageNumberCannotBeEmpty: 'Voyage number cannot be empty!',
  shippingCompanyCannotBeEmpty: 'Shipping company cannot be empty!',
  MasterShippingCompanyCannotBeEmpty: 'Master shipping company cannot be empty',
  hasBeanSend: 'Has Bean Send',
  notSend: 'Not Send',
  UpdateTime: 'Update Time',
  CategoryOfGoods: 'Category of goods',
  ShipperLine1: 'Shipper Line1',
  ConsigneeLine1: 'Consignee Line1',
  NotifyPartyLine1: 'NotifyParty Line1',
  CargoDocShipperLine1: 'BL Shipper First Line',
  CargoDocConsigneeLine1: 'BL Consignee First Line',
  CargoDocShipper: 'BL Shipper',
  CargoDocConsignee: 'BL Consignee',
  CargoDocNotify: 'BL Notify',
  CargoDocNotifyPartyLine1: 'BL Notify First Line',
  MBLBillOfLadingNum: 'MBL Serial No',
  HBLBillOfLadingNum: 'HBL Serial No',
  RegularBusiness: 'Regular Business',
  InputDate2: 'Input Date',
  ExpectedArrivalDate: 'Expected Arrival Date',
  ExportAllToExcel: 'Export All To Excel',
  FlightAndTime: 'Flight/Time',
  PleaseChooseEtdStartDate: 'Please Choose ETD Start Date.',
  PleaseChooseEtdEndDate: 'Please Choose ETD End Date.',
  VOYAGE_NUMBER_ALERT: 'Voyage number is required.',
  voyageNumberRepeat: 'Voyage number can not repeat.',
  DirectOrderOrNot: 'Direct Order Or Not',
  EDICode: 'EDI code',
  MSCVesselImport: 'Import MSC',
  MSCEDIExport: 'MSC Vessel CODE',
  pleaseDelEmptyCarrierRecord: 'The shipping company record cannot be empty.',
  CannotBeTheSame: 'Co owned shipping companies cannot be the same as the main shipping company',
  PortNotNull: 'There is data with empty ports, and all ports for all voyages cannot be empty',
  PortDuplication: 'Ports cannot be duplicated',
  EtdAndEtaNotNull: 'Original ETA and Original ETD cannot both be empty',
  shipNameCannotBeEmpty: 'The Chinese or English name of the ship\'s name cannot be empty.',
  alreadyExistsShipNameAndContinueToSave: 'The same name (Chinese or English name) already exists and whether it will continue to be kept?',
  exportThisPageEdi: 'Export this page Edi',
  ExportAgentList: 'Export Agent List',
  ContinueToExport: 'Continue To Export',
  OnlyMainTicketAndFCLServicesCanBeExported: 'Only main ticket and FCL services can be exported. The selected services cannot be exported',
  IgnoresNonExportableServices: 'Only main ticket and FCL services can be exported. The system automatically ignores non-exportable services. Do you want to continue exporting services?',
  ExportSuccess: 'Export Success',
  voyageShippingCompanyCanNotNull: 'Voyage‘s Shipping Company Can not Be Empty',
  PleaseSelectShippingName: 'Please Select Shipping Name',
  DownloadTemplate: 'Download Template',
  BLForm: 'B/L Form',
  FreeDetention: 'Free Detention',
  FreeDemurrage: 'Free Demurrage',
  CustomsAreaApplication: 'CustomsAreaApplication',
  SettlementCompanyNotEmpty: 'Settlement department cannot be blank!',
  StartMbl: 'MBL Prefix',
  EndMbl: 'END MBL',
  BillOfLading: 'Bill of lading',
  CartonQuantityCannotBeZero: 'Carton quantity cannot be null!',
  DistributionNo: 'Distribution number',
  DistributionWarehouse: 'Distribution warehouse',
  PreDateOfCustomsDeclaration: 'Pre Customs Date',
  sendFailed: 'Send failed.',
  SelfDeclaration: 'Self-declaration',
  ExchangeService: 'Exchange service',
  SpecialRelationshipOfBuyer: 'Special relationship between buyer and seller',
  IncludeRoyalty: 'Include royalty',
  AffectPrice: 'Affect price',
  WoodPacking: 'wood packing',
  FilingType: 'Filing type',
  emailAccount: 'Email Account',
  secondGeneration: 'second Generation Note: the second generation must fill in the Canada Customs record number',
  CanadianCustomsRecordNumber: 'Canada Customs Record Number',
  Combination: 'Combination',
  Split: 'Split',
  FinalStepSync: 'Final Step Sync',
  FinalStepSyncBtn: 'Final Step Sync',
  Synced: 'Synced',
  NotSynced: 'Not Synced',
  PleaseSelectSyncOrder: 'Please select the orders to sync',
  PleaseFillLastMilePlanner: 'Please fill in the Last Mile Business Leader',
  PleaseSelectNotSyncedOrder: 'Please select unsynchronized orders',
  FinalStepSyncSuccess: 'Successfully synced {0} order(s)',
  CombinationJob: 'Portfolio Business',
  ReceivableChargeLockedStatus: 'Accounts Receivable Locked status',
  PayableChargeLockedStatus: 'Payable Locked Status',
  NotLocked: 'Not Locked',
  ChargeLocked: 'Accounts receivable or accounts payable have been locked and cannot be operated!',
  ArChargeLocked: 'Accounts receivable have been locked and cannot be operated!',
  ApChargeLocked: 'Accounts payable have been locked and cannot be operated!',
  LockedStatus: 'Locked Status',
  LockedDate: 'Locked Date',
  LockAr: 'Lock Ar',
  UnLockAr: 'Cancel locking Ar',
  LockAp: 'Lock Ap',
  UnLockAp: 'Cancel lock Ap',
  importExpenseStatus: 'Expense status after import',
  accountingDate: 'Financial date after import',
  BatchReturnSubmit: 'BatchReturnSubmit',
  BatchReturnPreSubmission: 'Batch return pre submission',
  BatchUnlockReceivableExpenses: 'Batch unlock receivable expenses',
  BatchUnlockPayableFees: 'Batch unlock payable fees',
  UnlockApplyBtn: 'Apply for Unlock',
  UnlockApplyTitle: 'Charge Unlock Application',
  UnlockApplyJobCount: 'Number of jobs in this application: {0}',
  UnlockApplyCountLimitTip: 'up to 200 jobs per application',
  UnlockApplyReason: 'Unlock Reason',
  UnlockApplyReasonPlaceholder: 'Please enter the unlock reason',
  UnlockApplyReasonRequired: 'Please enter the unlock reason',
  UnlockApplyReasonOverLength: 'The unlock reason cannot exceed 500 characters',
  DeclaredProfitImpact: 'Declared Profit Impact Amount',
  UnlockApplyAmountRequired: 'Please enter the declared profit impact amount',
  UnlockApplySubmit: 'Submit',
  UnlockApplyPrecheckFailed: 'Precheck failed. The following jobs cannot apply, please adjust and retry:',
  UnlockApplyFailureReason: 'Failure Reason',
  UnlockApplyOnlySeaExport: 'Only Sea Export jobs can initiate the application',
  UnlockApplyOverLimit: 'A single operation cannot exceed 200 jobs',
  UnlockApplyChargeNotLocked: 'Neither receivable nor payable charges are locked. No unlock application is required.',
  UnlockApplyJobNotLocked: 'The order is not locked. Unlock application is not allowed!',
  UnlockApplyJobStateInvalid: 'Some selected orders are not in Verified status. Please check!',
  UnlockApplySubmitted: 'Application submitted, batch No.: {0}',
  UnlockApplyApproving: 'Unlock approval in progress',
  UnlockApplyUnlocking: 'Unlocking',
  UnlockApplyUnlockedBanner: 'The charges of this job have been unlocked for editing and will be automatically re-locked at 01:00 in 3 days',
  BatchLockingReceivableExpenses: 'Batch locking receivable expenses',
  BatchLockingPayableFees: 'Batch locking payable fees',
  ReplaceSOPTemplatesInBatches: 'Replace SOP Templates In Batches',
  BatchUpdateScNo: 'BatchUpdateScNo',
  BatchUpdateScNoSuccess: 'Batch modification of appointment number succeeded:{0}',
  BatchUpdateScNoCheck: 'You can only batch change the list being operated.',
  BatchReturnSubmitCheck: 'Only docs in submitted status can be cancelled.',
  MasterChargeIsShare: 'Whether to share the cost of the master ticket',
  PackageDisplayName: 'Package Display Name',
  ChargeSource: 'Data Source',
  AddressOfContact: 'Contact Address',
  FinancialExamineDate: 'Financial Review Date',
  ReceiptStatus: 'Receipt Status',
  TransitInformation: 'Transit Information',
  ThreeWay: 'Three Way',
  BatchUpdateCustomJobType: 'Batch Update CustomJobType',
  CustomJobTypeBatchModifySuccess: 'Batch modification of custom job type succeeded:',
  BatchManagerSubmission: 'Batch Manager Submit',
  BatchManagerSubmissionTips: 'The supervisor can only submit the business of positive operation and pre submission in batch!',
  BatchManagerSubmissionSuccessfully: 'Batch supervisor submitted successfully:',
  VotesManagerSubmission: 'votes for Manager Submission',
  CopyEnglishDescriptionOfGoodsFromMergeJob: 'Take the English product name added to the list',
  CopyMarkFromMergeJob: 'Take and add the shipping mark of the bill',
  SyncToSmallTicket: 'Sync To Small Ticket',
  externalBusinessStatus: 'External Business Status',
  SoNo1: 'S/O No.',
  NaturalPerson: 'Natural person',
  LegalPerson: 'Legal person',
  IndividualAssociation: 'Individual association',
  TelSeparate: 'Please separate the area code with "-"',
  EnsNo: 'ENS number',
  ShippingCompanyEORI: 'Shipping company EORI',
  DeclarantEORI: 'Declarant EORI',
  Memberstate: 'The first country entering the EU',
  ENumber: 'ENS number',
  EnsHsCodeNotMatch: 'The item information serial number does not match the box information',
  EnsCorrelativeNoRepeat: 'The serial number of the goods information is duplicated',
  LinkedCargoInformationNoNotNull: 'The packing information associated with the goods information serial number cannot be empty',
  maxLength: 'The length cannot exceed {0} characters',
  PleaseEnterLength: 'Please enter {0} characters',
  FreightTermConflict: 'There is a conflict between the selection of unloading port and delivery location information',
  FreightTermConflict2: 'There is a conflict between the selection of loading port and receiving location information',
  NeedPrefix: 'Declaration with prefix required, tracking number prefix: {0}',
  RemoveThePrefix: 'Need to remove prefix: {0}',
  PhoneTooLong: 'The area code cannot be greater than 4 characters, and the phone number cannot be greater than 20 characters',
  SaveOnly: 'Save only',
  Only6: 'Only supports 6-digit numbers',
  ChargesPaymentMethod: 'Charges payment method',
  CopyConsignor: 'Copy consignor',
  CopConsignee: 'Copy consignee',
  BuyerAndSellerInformation: 'Buyer and seller information',
  StreetNumber: 'Street number',
  WaitingForReceipt: 'Last time it was sent successfully and we have not received a receipt yet. Please wait for the receipt before sending again',
  DirectlyRepresenting: 'Directly representing',
  IndirectRepresentation: 'Indirect representation',
  NeedOne: 'Just need to add one piece of data',
  ContainShutOutJob: 'Including customs clearance business',
  BatchEditJobNo: 'Batch Modify Business Number',
  IncludingSCFIFreightRate: 'Including SCFI freight rate',
  SCFIDesignatedBoxType: 'SCFI designated box type',
  JingyiSystemForecast: 'Jingyi system forecast',
  OriginalAHR: 'Original AHR',
  AddChr: 'Add Chr',
  CorrectAFR: 'Correct AFR',
  NonRepeatingNumbers: 'Non repeating numbers',
  AddressFormatting: 'Address formatting',
  SendToGoFreight: 'Send to go freight',
  ViewSendLog: 'View send log',
  BookingFreightRate: 'Booking freight rate',
  SelectedDataDeclaration: 'Selected data declaration',
  EmptySubmissionDeclaration: 'Empty submission declaration',
  SettlementFreightRate: 'Settlement freight rate',
  DeclarationRecord: 'Declaration record',
  ImNotHavePermissionDetails: 'I\'m sorry! You do not have permission to view details',
  ActionOptionsNotCaptured: 'Action options not captured!',
  BatchNotSupportedPleaseAgain: 'Batch sending is not supported, please select again!',
  ItFreightAndRepeatedAllowed: 'It has been sent to go freight, and repeated sending is not allowed',
  SentSuccessfully: 'Sent successfully',
  CheckTheSendingLog: 'Check the sending log',
  OnlyToViewTheSelect: 'Only one service can be selected to view the sending log, please re select!',
  ItUpTo50Businesses: 'It can handle up to 50 businesses',
  Business: 'Business:',
  NonIntegralType: 'Non integral type',
  SendComplete: 'Send complete',
  PackingList: 'Packing list',
  PleaseContainerBusinessForOperation: 'Please select full container business for operation!',
  EmptyInterfaceSendingPleaseWait: 'Empty container data interface sending, please wait',
  VerificationOfDeclarationData: 'Verification of declaration data',
  DataCheckTheDataAgain: 'Data validation failed. Please check the data and try again.',
  PleaseWhetherToSubmitThis: 'Please confirm whether to submit this',
  TicketData: 'Ticket data?',
  DataDeclarationSucceeded: 'Data declaration succeeded',
  EmptySubmittedSuccessfully: 'Empty submitted successfully',
  NotData: 'No data',
  ThereElectronicPackingListData: 'There is no electronic packing list data',
  SendFailed: 'Send failed:',
  Empty: 'Empty',
  PleaseOfDepartureMustPort: 'Please confirm that the port of departure must be Shanghai port.',
  PleaseMustBeTheExchange: 'Please confirm that the port of discharge must be the port designated by the air exchange.',
  PleaseOfGoodsMustGoods: 'Please confirm that the type of goods must be ordinary goods.',
  PleaseOfTheMainCY: 'Please confirm that the transportation terms of the main document must be "CY-CY".',
  PleaseTradeTermsMustCIF: 'Please confirm that the trade terms must be "CIF".',
  PleaseBoxQuantityInformationCorrect: 'Please confirm whether the box quantity information is correct.',
  TheAmountReceivableIncludesUSD: 'The amount receivable includes USD.',
  NoBillOfLadingInformation: 'No HBL bill of lading information',
  ResponseDataIsEmpty: 'Response data is empty',
  PleaseToViewTheLog: 'Please select the business to view the sending log!',
  ExportEDI: 'Export EDI?',
  LandTransportationDetailsEditing: 'Land transportation details editing',
  PreviewOfBookingFileParsing: 'Preview of booking file parsing',
  GenerateOrder: 'Generate order',
  HangInTheAir: 'hang in the air',
  Completed: 'Completed',
  Dustbin: 'dustbin',
  PictureLoadingFailed: 'Picture loading failed',
  ResolutionCompletionTime: 'Resolution completion time',
  ViewParsingResults: 'View parsing results',
  ViewOrder: 'View order',
  AreYouWantToDelete: 'Are you sure you want to delete?',
  BusinessNumber: 'Business number',
  LCL: 'LCL',
  NearlyAWeek: 'Nearly a week',
  NearlyAMonth: 'Nearly a month',
  NearlyThreeMonths: 'Nearly three months',
  DragUploadTheFileIdentified: 'Drag the file here to upload the file to be identified',
  SupportUploadFormat: 'Support upload format',
  ParsingFailed: 'Parsing failed',
  ParsingComplete: 'Parsing complete',
  OrderGenerated: 'Order generated',
  UploadCompletedParsing: 'Upload completed, parsing',
  Second: 'second',
  ReviewRejectedBusinessNumber: 'Review rejected business number',
  RejectedBusinessNumber: 'Rejected business number',
  TheNotExceed5Lines: 'The maximum can not exceed 5 lines!',
  Interface: 'Interface',
  Sinotrans: 'Sinotrans',
  SinotransEastChinaCoLtd: 'Sinotrans East China Co., Ltd',
  NingboEPort: 'Ningbo E-port',
  SeaHousekeeper: 'Sea housekeeper',
  Wse: 'Wse',
  CargoWare: 'Cargoware send',
  EDISend: 'EDI send',
  OtherChannel: 'Other Channel',
  Ningbo99Road: 'Ningbo 99 Road',
  DeclarationHistory: 'Declaration history',
  CredentialNumber: 'Credential number',
  ResponseCode: 'Response code',
  ElectronicBoxListSendingHistory: 'Electronic box list sending history',
  PrintTime: 'Print time',
  PrintingTimes: 'Printing times',
  BookingDataFeedback: 'Booking data feedback',
  QuerySendingLog: 'Query sending log',
  SendDataInformation: 'Send data information',
  ExportAllEDI: 'Export all EDI',
  UploadThisPageEDI: 'Upload this page EDI',
  UploadAllEDI: 'Upload all EDI',
  EmailUploadEDI: 'Email upload EDI',
  IsExportEDI: 'Export EDI?',
  UploadEDI: 'Upload EDI?',
  IsUploadAllEDI: 'Upload all EDI?',
  MailSending: 'Mail sending',
  UploadEDISucceeded: 'Upload EDI succeeded',
  FailedToUploadEDI: 'Failed to upload EDI',
  CurrentNetworkChannelUnstable: 'Due to the current unstable network of the channel, should we switch to the backend sending queue?',
  EdiTips: 'EDI sending prompt',
  HasBillExist: '[{0}] The bill of lading number is already in the system\'s sending queue. Please be patient and there is no need to resend.',
  MultiSegmentNumberRuleConfiguration: 'Multi segment number rule configuration',
  StartNumber: 'Start number',
  IncrementalRule: 'Incremental rule',
  DirectExport: 'Direct export',
  Plus1: 'Plus 1',
  Plus10: 'Plus 10',
  TheNumberCannotBeEmpty: 'The starting number cannot be empty',
  IllegalNumberEntry: 'Illegal number entry',
  TheMustBeGreaterZero: 'The number of copies must be greater than zero',
  IncrementRuleIsNotSelected: 'Increment rule is not selected',
  PleaseBusinessNumberSearchCriteria: 'Please enter business number search criteria',
  UploadCompletedProcessing: 'Upload completed, processing',
  SuccessfulProcessing: 'Successful processing',
  ProcessingFailed: 'Processing failed',
  ExportTime: 'Export time',
  UnitPriceCannotBe0: 'Unit price cannot be 0',
  ExchangeRateCannotBe0: 'Exchange rate cannot be 0',
  CustomsNoCannotBeBlank: 'Customs clearance No. cannot be blank!',
  ShipperCityCannotBeBlank: 'Please enter the shipper’s city name',
  PrimaryCustomsNo: 'Primary customs No',
  GetPackingInformation: 'Get packing information',
  GetGoodsInformation: 'Obtain cargo information',
  GetGoodsInformationTip: 'Obtain the size of the warehouse entry record associated with the [Goods Information] tab',
  SynchronizeMainTicketPackingInformation: 'Synchronize main ticket packing information',
  CaseNumberCannotBeEmpty: 'Case number cannot be empty',
  InvalidCaseNumber: 'Invalid case number',
  TheSealNumberCannotBeEmpty: 'The seal number cannot be empty',
  BoxTypeCannotBeEmpty: 'Box type cannot be empty',
  EnglishNameCannotBeEmpty: 'English product name cannot be empty',
  TheMarkCannotBeEmpty: 'The shipping mark cannot be empty',
  HscodeCannotBeEmpty: 'Hscode cannot be empty',
  EqCodeMatchError: 'Box type and type do not match. Please select again',
  ThePackageCannotBeEmpty: 'The package cannot be empty',
  ThePiecesCannotBeEmpty: 'The number of pieces cannot be empty',
  GrossWeightCannotBeEmpty: 'Gross weight cannot be empty',
  VolumeCannotBeEmpty: 'Volume cannot be empty',
  DanUNNoCannotBeEmpty: 'Dangerous goods are required and range 0001-9999',
  DanClassNoCannotBeEmpty: 'Dangerous goods are required, range: 1-9.9',
  DangerousGoodsContactCannotBeEmpty: 'Dangerous goods contact cannot be empty',
  DangerousGoodsContactPhoneNumberCannotBeEmpty: 'Dangerous goods contact phone number cannot be empty',
  TherePleaseEnterItTab: 'There is no information to import. Please enter it in the "packing information" tab',
  NoMasterTicketInformationYet: 'No master ticket information yet!',
  WeighingMethod: 'Weighing method',
  VGMLLC: 'VGM LLC',
  VGMWeightAddress: 'VGM Weight Address',
  VGMSignature: 'VGM signature',
  TareWeight: 'Tare weight',
  TareWeightUnit: 'Tare weight Unit',
  WeighingAddress: 'Weighing address',
  WeighingMethodCannotBeEmpty: 'Weighing method cannot be empty',
  TheWeightCannotBeEmpty: 'The total weight cannot be empty',
  VGMCompanyCannotBeEmpty: 'VGM liability company cannot be empty',
  VGMSignatureCannotBeEmpty: 'VGM signature cannot be empty',
  MailboxCannotBeEmpty: 'Mailbox cannot be empty',
  PhoneNumberCannotBeEmpty: 'Phone number cannot be empty',
  WeighingAddressCannotBeEmpty: 'Weighing address cannot be empty',
  NotifierCodeCannotBeEmpty: 'Notifier enterprise code cannot be empty',
  ContactNotifierCannotBeBlank: 'Contact information of notifier cannot be blank',
  ImportTallyInformation: 'Import tally information',
  PTImport: 'PT import',
  SelectTime: 'Select time',
  CaseNoSealNo: 'Case No. - seal No',
  CopySmallTicketCost: 'Copy small ticket cost',
  PleaseCostToBeCopied: 'Please select the cost to be copied',
  CrossTenantDelegationHistory: 'Cross tenant delegation history',
  Operator: 'operator',
  OperationTime: 'Operation time',
  DelegationStatusHistory: 'Delegation status history',
  GeneratePrimaryDocNo: 'Generate MBL No.',
  PleasePrimaryOrderNumberRule: 'Please select the primary order number rule',
  PleaseCodeOfTheNo: 'Please select the service code of the main order No',
  SendOnlineManifestInvitationEmail: 'Send online manifest invitation email',
  PleaseConfirmEmailAddress: 'Please confirm email address:',
  ShippingPreConfigurationInformationManifest: 'Shipping booking Express Edition - pre configuration information - invite online manifest',
  TheSentToTheIt: 'The invitation link has been sent to the email, please check it!',
  TotalCustomsNo: 'Total customs No',
  TotalNumberOfPieces: 'Total number of pieces',
  TotalGrossWeight: 'Total gross weight',
  TotalVolume: 'Total volume',
  CustomsNoNotImported: 'Customs No. not imported:',
  ImportDate: 'Import date',
  ImportUser: 'Import users',
  SendUser: 'Send user',
  ManifestImportUser: 'Manifest import user',
  SendTag: 'Send tag',
  SubtotalOfCustomsOrderNo: 'Subtotal of Customs Order No',
  ConfirmToVoid: 'Confirm to void?',
  MBNOCannotBeEmpty: 'MB / L NO cannot be empty!',
  ShipNameCannotBeEmpty: 'Ship name cannot be empty!',
  EnglishShipNameCannotBeEmpty: 'The English ship name cannot be empty',
  VoyageCannotBeEmpty: 'Voyage cannot be empty!',
  ShippingCompanyCannotBeEmpty: 'Shipping company cannot be empty!',
  ShippingAgentCannotBeEmpty: 'Shipping agent cannot be empty!',
  DestinationPortCannotBeEmpty: 'Destination port cannot be empty!',
  GoodsTypeCannotBeEmpty: 'Goods type cannot be empty!',
  TransportationTermsCannotBeBlank: 'Transportation terms cannot be blank!',
  FreightTermsCannotBeBlank: 'Freight terms cannot be blank!',
  BillTypeCannotBeEmpty: 'Bill of lading type cannot be empty!',
  PaymentPlaceCannotBeEmpty: 'Payment place cannot be empty!',
  MattersNeedingAttention: 'matters needing attention',
  DontRemindMeAgain: 'Don\'t remind me again',
  CloseSpace: 'close',
  TheBeenSentToSending: 'The customs clearance No. [{0}] in this manifest has been sent to EDI. Do you want to continue sending?',
  SelectToSendPreManifest: 'Select the channel to send pre configured manifest',
  SelectCorrectConfiguredManifestChannel: 'Select correct pre configured manifest channel',
  SelectDeleteConfiguredManifestChannel: 'Select Delete pre configured manifest channel',
  ThePleaseRefreshTheAgain: 'The cleaning manifest object is empty, please refresh the page and try again',
  CustomsClearanceNo: 'Customs clearance No',
  ShippingCompanyOperation: 'Shipping company operation',
  CustomsRestAssured: 'Customs rest assured',
  PlanType: 'Plan type',
  AcceptanceTime: 'Acceptance time',
  ScheduledStartTime: 'Scheduled start time',
  PlannedEndTime: 'Planned end time',
  DepartureTime2: 'Departure time:',
  PortCutOffTime: 'Port cut-off time:',
  ActualBerthingTimeColon: 'Actual berthing time:',
  ActualDepartureTimeColon: 'Actual departure time:',
  ClickToViewTheTrailer: 'Click to view the trailer',
  DisplayPortArea: 'The following data shows the port area/shipping company data',
  DetailedData: 'Detailed data',
  manualPrompt: 'Orange data: data services',
  thirdPartyPrompt: 'Light blue data: Enter the data manually',
  promptNo: 'Grey data: No data is available',
  promptNoData: 'No data is available',
  ArrivalReportStatus: 'Arrival report status',
  CustomsClearanceSheetStatus: 'Customs clearance sheet status',
  PlanDetails: 'Plan details',
  PutInTheBox: 'Put in the box',
  EmptyBox: 'Empty box',
  Arrival: 'arrival',
  EstimatedCYOpening: 'Estimated CY Opening',
  PortDocCutOff: 'Port doc cutOff',
  ActualBerthing: 'Actual berthing',
  ActualDeparture: 'Actual departure',
  customsClearance: 'Customs clearance',
  DockRelease: 'Dock release',
  CancelCustomsClearance: 'Cancel Customs Clearance',
  CancelDockRelease: 'Cancel Dock Release',
  AllocateVehiclesToTransportSth: 'allocate vehicles to transport sth.',
  Sail: 'sail',
  Departure: 'Departure',
  Pickup: 'Pick up',
  BusinessFunction: 'Business function',
  ClickTheButton: 'Click the button',
  ReturnAddress: 'Return address',
  DepartureTime3: 'Departure time',
  ArrivalWharf: 'Arrival Wharf',
  departureTime: 'Departure time',
  StowageTime: 'Stowage time',
  AbnormalCause: 'Abnormal cause',
  StackingTime: 'Stacking time',
  StackingState: 'Stacking state',
  SeaReleaseTime: 'Sea release time',
  SeaReleaseDescription: 'Sea release instructions',
  SeaReleaseState: 'Sea release state',
  arrivalTime: 'Arrival time',
  TrailerFollow: 'Trailer follow',
  SuitcaseLocation: 'Suitcase location',
  BoxReleaseTime: 'Box release time',
  EstimatedPickUpPoint: 'Estimated pick-up point',
  Wharf: 'wharf',
  NameNumberOfImportedVessels: 'Name and number of imported vessels',
  FieldBoxPosition: 'Field box position',
  NameNumberOfExportVessel: 'Name and number of export vessel',
  containerWeight: 'Container weight',
  VGMWharfWeighing: 'VGM wharf weighing',
  ContainerHolder: 'Container holder(Shanghai Port only)',
  LeadSeal: 'Lead seal',
  TransshipmentPort: 'Transshipment port',
  VGMMessageReceiving: 'VGM message receiving',
  ApproachMode: 'Approach mode',
  ArrivalMessageTime: 'Arrival message time',
  AppearanceMode: 'Appearance mode',
  ReeferTemperatureRequired: 'Reefer-Temperature required ',
  ReceivedTheReleaseTime: 'Received the release time',
  NationalInspectionRelease: 'National inspection release',
  OverrunCode: 'Overrun code',
  WharfStowage: 'Wharf stowage',
  EmptyContainerRelease: 'Empty container release',
  Front: 'front',
  After: 'after',
  SuperLong: 'Super long',
  FlowTo: 'flow to',
  Left: 'Left',
  Right: 'right',
  UltraWide: 'Ultra wide',
  MaritimeReleaseException: 'Maritime release exception',
  SuperHigh: 'super high',
  QuantityOfBoxesAndPieces: 'Quantity of boxes and pieces:',
  GreaterActualNumberOfPieces: 'Greater than the actual number of pieces:',
  BoxWeight: 'Box weight:',
  GreaterThanActualWeight: 'Greater than actual weight:',
  BoxVolume: 'Box volume:',
  LargerThanActualVolume: 'Larger than actual volume:',
  JobNoColon: 'Job No:',
  AddSpellCustomsOrderNo: 'Add S/O No.',
  PleaseForAddingAndForm: 'Please select the number rule for adding and spelling customs clearance form',
  PleaseSelectSuffixSeparator: 'Please select suffix separator',
  PleaseCustomsDeclarationNoSpelled: 'Please enter the quantity of customs declaration No. to be spelled',
  DirectToCanada: 'Direct to Canada',
  ToInlandWarehouse: 'To inland warehouse',
  TransitClearancePullToStates: 'Transit in Canada, no customs clearance, pull to the United States',
  TheThroughTheUnitedStates: 'The goods pass through the United States',
  PleaseSelectAnAccount: 'Please select an account',
  PleaseOfYourCurrentFirst: 'Please maintain the code of your current department first!',
  ItServiceProviderOfHouse: 'It has become a service provider of "wolian house"',
  YouHisPartnerAndService: 'You can apply online to become his partner and enjoy the online ordering service.',
  PleaseSelectTheEntrustingCompany: 'Please select the entrusting company!',
  PleaseSelectDestinationAgent: 'Please select destination agent!',
  UncheckedSmallTicket: 'Unchecked small ticket',
  CustomerInformation: 'Customer information',
  CodeCannotBeEmpty: 'Code cannot be empty',
  TheNameCannotBeEmpty: 'The name cannot be empty',
  CertificateTypeCannotBeBlank: 'Certificate type cannot be blank',
  IDNumberCannotBeEmpty: 'ID number cannot be empty',
  AddressCannotBeEmpty: 'Address cannot be empty',
  CityCannotBeEmpty: 'City cannot be empty',
  CountryCannotBeEmpty: 'Country cannot be empty',
  ThisSuccessfullyInsuredRepeatedAllowed: 'This ticket business has been successfully insured. Repeated insurance is not allowed',
  Seller: 'seller',
  Manufacturer: 'Manufacturer ',
  Consolidator: 'consolidator ',
  OriginalBookingParty: 'Original booking party',
  GoodsReceiver: 'Goods receiver',
  PackingPoint: 'Packing point',
  Importer: 'importer',
  AMSNoCannotBeBlank: 'AMS sub doc No. cannot be blank',
  SCACCompanyCannotBeEmpty: 'SCAC of shipping company cannot be empty',
  TheDischargeCannotBeEmpty: 'The port of discharge cannot be empty',
  TheDeliveryCountryCannotBeEmpty: 'The country of delivery cannot be empty',
  TheDeliveryCannotBeEmpty: 'The place of delivery cannot be empty',
  CorrectionOfBillOfLading: 'Correction of bill of lading',
  OriginalBillOfLading: 'Original bill of lading',
  TheBillOfLadingEmpty: 'The place of shipment of bill of lading cannot be empty',
  SailingDateEmpty: 'Sailing date cannot be empty',
  TransceiverSelection: 'Transceiver selection',
  YouServiceOfTheManifest: 'You can click the icon to consult the customer service of the sea housekeeper for the pre configured manifest.',
  OriginalCleaningManifest: 'Original cleaning manifest',
  Correction1: 'Correction 1',
  CorrectCleaningManifest: 'Correct cleaning manifest',
  SendPreConfiguredManifest: 'Send pre configured manifest',
  CorrectionOfPreAllocationManifest: 'Correction of pre allocation manifest',
  DeletePreConfiguredManifest: 'Delete pre configured manifest',
  CancelPreConfiguredManifest: 'Cancel Pre Configured Manifest',
  OriginalPreAllocatedManifest: 'Original pre allocated manifest',
  CleanManifestAPI: 'Clean manifest API',
  OriginalVGM: 'Original VGM',
  HscodeConfigurationInformationCannotEmpty: 'Hscode of pre configuration information cannot be empty',
  HscodeInformationMustBeDigits: 'Hscode of pre configuration information must be 6 digits',
  PleaseTickTheBoxForTheCargoInformationYouWantToAmendTheManifest: 'Please tick the box for the cargo information you want to amend the manifest',
  PleaseConfirmThatTheCustomsInformationYouSelectedHasNotBeenModified: 'Please confirm that the customs information you selected has not been modified',
  PleaseSelectAllSeaHouseUpdateData: 'If you modify the content of the [Basic Manifest Information] & [Customer Shipping Information] module, you need to select all the customs order information that has been sent and send it together',
  SendingSucceeded: 'Sending succeeded!',
  TheTheReceiptLogInformation: 'The original manifest has been sent. Click the receipt log to view the manifest receipt information.',
  UpdateSucceeded: 'Update succeeded!',
  PleaseSuccessfullyIfNotFirst: 'Please confirm whether the original manifest is sent successfully. If not, please send the original manifest first.',
  DeleteSucceeded: 'Delete succeeded!',
  WseModifyReasonNotEmpty: 'Please select the reason for order change',
  WseModifyRemarkNotEmpty: 'Please add instructions for changing the order',
  WseDeleteReasonNotEmpty: 'Please select the reason for deleting the order',
  WseDeleteRemarkNotEmpty: 'Please add instructions for deleting orders',
  BrandNew: 'brand new',
  SecondHand: 'second-hand',
  Unknown: 'Unknown',
  ReImportAfterModification: 'Re import after modification',
  FailedToDownloadData: 'Failed to download data',
  ClickVehiclePositioningAndTrack: 'Click the button to query vehicle positioning and vehicle driving track.',
  VehiclePositioningTrack: 'Vehicle positioning track',
  IfToTheCurrentIt: 'If the expense status of the changed company is not synchronized to the current payable tab, do you want to continue to delete it?',
  VehicleTrajectory: 'Vehicle trajectory',
  DistributionCustomsNo: 'Distribution customs No',
  BookingReceipt: 'Booking receipt',
  InMailOfThePrevail: 'In the internal survey stage, the mail of the ship owner shall prevail',
  CorrectBooking: 'Correct Booking',
  OriginalBooking: 'Original booking',
  TheBeVoidedAndThis: 'The primary doc No. has been generated. If it is generated again, the original doc No. will be voided and a new doc No. will be generated. Are you sure you want to do this?',
  BasicTab: 'Basic tab',
  TheHairBodyCannotEmpty: 'The actual part hair body cannot be empty',
  PackageCannotBeEmpty: 'Package cannot be empty',
  MBLTab: 'MBL tab',
  ShipperCannotBeBlank: 'Shipper cannot be blank',
  ConsigneeCannotBeEmpty: 'Consignee cannot be empty',
  NotifierCannotBeBlank: 'Notifier cannot be blank',
  TheEmptyPleaseRefreshAgain: 'The pre configured manifest object is empty. Please refresh the page and try again',
  TheIsEmptyPleaseAgain: 'The object of pre configured manifest correction is empty. Please refresh the page and try again',
  VGMRefreshThePageAgain: 'VGM object is empty, please refresh the page and try again',
  TheCleaningIsEmptyPleaseAgain: 'The object of pre configured cleaning manifest is empty. Please refresh the page and try again',
  TheNoCannotBeBlank: 'The customs clearance No. cannot be blank',
  MBLNoCannotEmpty: 'MB / L NO cannot be empty',
  NewGoods: 'Add Cargo',
  DeleteGoods: 'Delete Cargo',
  TotalOfThisBox: 'Total of this box:',
  DataComparison: 'Data comparison',
  UpdatePortAreaData: 'Update Port Data',
  NoPortDataHasBeenObtained: 'No port data has been obtained',
  SynchronizePortData: 'Synchronize port data',
  NotVerified: 'Not verified',
  SystemVerification: 'System verification',
  ManualVerification: 'Manual verification',
  ToBeConfirmed2: 'To be confirmed',
  TheInThePortOpened: 'The push service of container cargo data in the port area has not been opened',
  TheDirectlyImportTheCall: 'The port container data service can help you verify whether the container information is correct, or directly import the port container data into the business. To open, please contact online customer service or call:',
  HarbourNotInServiceNoOpen: 'The corresponding port has not opened the data comparison service yet, so the data comparison function cannot be provided. At present, it supports data comparison in other ports. If you need to open it, please contact online customer service or call the contact number：',
  HarbourInServiceNoOpen: 'The container data service in the port area can help you check whether the container information is correct or not. It can also directly import the container data in the port area to realize easy data entry. If you need to call customer service online：',
  HarbourNotInServiceOpen: 'Currently, push and comparison of data in this port area are not supported.',
  ThisActionCannotBeUndone: 'This action cannot be undone',
  DoYouWantToContinue: 'Do you want to continue?',
  ItPortDataAndVerified: 'It does not match the port data and cannot be verified',
  TheNotContainTheData: 'The current data does not contain the following port data',
  PortInformationVerification: 'Port information verification',
  SIsMissingAndVerified: 'S / O no is missing and cannot be verified',
  PleaseNoForTheFirst: 'Please fill in S / O no for the current small ticket first',
  TheOverwriteTheCurrentData: 'The function will overwrite the current data',
  OperationSucceeded: 'Operation succeeded!',
  OrderNumber: 'Order Number',
  TotalPacking: 'Total Packing',
  ContainerList: 'Container info list',
  UpdateStatus: 'Update Status',
  ClearThePackingInformation: 'Clear The Packing Information',
  ExportThePackingPlan: 'Export The Packing Plan',
  checkGoods: 'Check Goods',
  checkPackages: 'Check Packages',
  NumberOfPackages: 'Number Of Packages',
  AskForPositionTime: 'Ask For Position Time',
  EstimatedPositionTime: 'Estimated Position Time',
  CheckTheDetailsOfTheGoods: 'Check The Details Of The Goods',
  UnableToRemove: 'Unable to remove, container is locked or boxed.',
  removeOrderTips: 'Are you sure you want to remove this order?',
  removeOrder: 'Remove orders',
  NO: 'NO.',
  PackageNo: 'Package No',
  NumberOfPackagesAnticipateOrReality: 'Number Of Packages(Anticipate/Reality)',
  Code4: 'Code',
  LengthAnticipateOrReality: 'Length(Anticipate/Reality)',
  WidthAnticipateOrReality: 'Width(Anticipate/Reality)',
  HighAnticipateOrReality: 'High(Anticipate/Reality)',
  UnitVolumeAnticipateOrReality: 'Unit Volume(Anticipate/Reality)',
  GrossWeightAnticipateOrReality: 'Gross Weight(Anticipate/Reality)',
  Considerations: 'Considerations',
  Anufacturer: 'Anufacturer',
  EstimateLoadingTime: 'Estimate Loading Time',
  ActualWarehousingTime: 'Actual Warehousing Time',
  NoCorrespondingFile: 'No corresponding file has been obtained!',
  ChooseState: 'Choose State',
  ActualPackingTime: 'Actual packing time',
  ChooseActualPackingTime: 'Choose Actual PackingTime',
  updateContainerStateTip: 'Update failed, there are orders for this box that have not been put into warehouse.',
  firstCleanedContainer: 'Please select the container to be cleaned first.',
  containerBeCleared: 'The container of cannot be cleared.',
  removeSelectedContainer: 'Are you sure you want to remove all orders under the selected container?',
  ClearContainerInformation: 'Clear container information',
  goodsOperateTips: 'Please save the single number information before you operate the goods.',
  removeGoodsTips: 'Please select the goods to remove.',
  NumberOfCartons: 'Number Of Cartons',
  importGoodsTips: 'Please select the goods to import.',
  ChooseGoods: 'Choose Goods',
  RemoveTheGoods: 'Remove The Goods',
  Source: 'Source',
  PrintListTip: 'Please select a list you want to print.',
  CargoActArrivalDatePacking: 'Actual Packing Date',
  releaseStowageState: 'Release stowage status',
  ChangeHistory: 'Change history',
  SynchronizationInformation: 'Synchronization Information',
  SyncChargeToEas: 'Synchronization cost to EAS',
  NoEasCharge: 'There is no need to synchronize to EAS.',
  CheckEasChargeState: 'There is no need to synchronize to EAS,Please check the EAS expense status.',
  CheckBusinessUuid: 'Business UUID cannot be empty!',
  KingDeeChargePush: 'KingDee Push Charge',
  ExternalSerialNumber: 'External Serial Number',
  EmptyCabinetDate: 'Incoming time of empty cabinet',
  RealArrivalsDate: 'Actual arrival time',
  ActualLiftingDate: 'Pick up date',
  DeliveryDoneDate: 'Delivery completion time',
  CleaningDate: 'Cleaning time',
  ReturnBoxDate: 'Return time',
  DestinationDeliveryTime: 'Delivery time of destination port',
  UnloadingTime: 'Unloading time',
  LiftingTime: 'Lifting time',
  DestinationReturnTime: 'Empty return date',
  PortDischargeTime: 'Port discharge time',
  EstimatedPortDischargeTime: 'Estimated Port discharge time',
  RailwayDepartureTime: 'Railway departure time',
  RailwayDischargeTime: 'Railway discharge time',
  EstimatedRailwayDepartureTime: 'Estimated Railway departure time',
  EstimatedRailwayDischargeTime: 'Estimated Railway discharge time',
  EstimatedTimeOfArrivalAtThePlaceOfDelivery: 'Estimated time of arrival at the place of delivery',
  Arrived: 'Arrived',
  Acquire: 'Acquire',
  TheActualTimeOfArrivalAtThePlaceOfDelivery: 'The actual time of arrival at the place of delivery',
  EstimatedCustomsReleaseTime: 'Estimated customs release time',
  EstimatedPickupTime: 'Estimated pick up time',
  ActualPickUpTime: 'Actual pick up time',
  EstimatedDeliveryToWarehouseTime: 'Estimated delivery to warehouse time',
  EstimatedReturnTime: 'Estimated return time',
  ActualReturnTime: 'Actual return time',
  PODDeliveryInformation: 'POD delivery information',
  ActualDeliveryToWarehouseTime: 'Actual delivery to warehouse time',
  EstimatedDeliveryToCustomersWarehouseTime: 'Estimated delivery to customers\' warehouse time',
  ActualDeliveryToCustomersWarehouseTime: 'Actual delivery to customers\' warehouse time',
  PickupMessage: 'CY-DOOR, from the port area to the full container warehouse / LCL unpacking warehouse',
  DeliveryToWarehouseMessage: 'Time of delivery to the warehouse at the port of destination after weight lifting',
  EstimatedDeliveryToCustomersWarehouseMessage: 'From LCL warehouse to customer warehouse (B2B) / delivery from the last kilometer of delivery warehouse (B2C)',
  ActualDeliveryToCustomersWarehouseMessage: 'Delivery from LCL warehouse to customer warehouse / the last kilometer from delivery warehouse',
  CargoReadyDate: 'Cargo ready date',
  BackUpWarehouse: 'Forward Warehouse',
  PleaseSelectBackUpWarehouse: 'Please Select Forward Warehouse!',
  HeavyContainerMobilization: 'Heavy container mobilization',
  checkLines100: 'The number of selected lines cannot exceed 100 lines!',
  estimatedDeliveryTime: 'Estimated delivery time',
  estimatedArrivalTime: 'Estimated arrival time',
  EmailGroup: 'Email group',
  EmailTemplate: 'Email template',
  CargoAllocationList: 'Cargo allocation list',
  CheckApproved: 'Please check the business to be approved!',
  StateVerifyingReview: 'Approved (pending review)',
  VotesSubmission: ' votes for submission?',
  BatchSubmitCheckOperate: 'Only the operating list can be submitted in batch!',
  BatchSubmitCheckPre: 'Only the pre-submitted list can be submitted in batch!',
  CancelFormalHblTips: 'Formal document splitting already exists. Please remove it and uncheck it!',
  BatchSend: 'Batch send',
  BatchSendCheck: 'Please check the EAS fee to be sent.',
  BatchSendTip: 'Only unapproved expenses can be synchronized. Please check the expense status.',
  PleaseSelectRemovedContainer: 'Please select the packing information to be removed!',
  PleaseRemovedSplitOrder: 'Please first remove the form of splitting associated with the current splitting order!',
  ThereAreTheFollowingExceptionsInTheImportDataPleaseCheckTheDataInTheForm: 'There are the following exceptions in the import data. Please check the data in the form.',
  NoPrimaryTicketIsAssociatedSoTheContainerDataCannotBeImported: 'No primary ticket is associated, so the container data cannot be imported',
  ImportContainerInformation: 'Import container information?',
  SecondLoadingTime: 'loading time of discharge port',
  SecondDepartureTime: 'departure time of discharge port',
  SecondArrivalTime: 'arrival time of discharge port',
  SecondUnloadingTime: 'discharge time of discharge port',
  TransferModeAtTransferPoint: 'Transfer mode at transfer point',
  DispatchVehiclesAtDestination: 'Dispatch vehicles at destination',
  PortOfDestinationServices: 'Port of destination services',
  Manifest: 'Manifest',
  Other: 'Other',
  Temperature: 'temperature',
  OpenVentilation: 'Open ventilation',
  VentilationQuantity: 'ventilation quantity',
  VentilationUnit: 'Ventilation unit',
  FlashPointUnit: 'Flash Point Unit',
  HazardForm: 'Hazard Form',
  AutoSpecialGoods: 'Automatically obtain the packing information of special goods',
  HaveMaintainedSpecialInfo: 'It is detected that you have maintained special cargo information. Do you want to automatically obtain packing information according to English product name and HS code?',
  PackingInformation: 'Successfully obtained packing information.',
  NoPackingInformation: 'No packing information was obtained.',
  Humidity: 'humidity%',
  OverSize: 'over size',
  ZYQHG: 'Left/right/front/back/superb(CM)',
  PortOfDestinationCustomsClearance: 'Customs clearance at the port of destination',
  DestPortCustomsClearanceInfo: 'Customs Clearance Info',
  PortOfDestinationCustomsData: 'Destination port customs data',
  ProductName: 'Product Name',
  DeleteThisProduct: 'Delete this product',
  CustomsTariff: 'Customs Tariff',
  AddMultipleProductArea: 'Add Multiple Product Area',
  PleaseSelectData: 'Please select the specified data',
  PlateNumberAndBillLadingNumberCannotEmpty: 'License plate number and bill of lading number cannot be empty',
  LineXQuantityMustGreaterThanZero: 'The quantity in line {rowNum} must be greater than 0',
  LineXQuantityExceedsMaxValue: 'The quantity {quantity} in line {rowNum} exceeds the maximum value {maxValue}',
  LineXWeightMustGreaterThanZero: 'The weight in line {rowNum} must be greater than 0',
  LineXWeightExceedsMaxValue: 'The weight {weight} in line {rowNum} exceeds the maximum value {maxValue}',
  LineXCubageMustGreaterThanZero: 'The cubage in line {rowNum} must be greater than 0',
  LineXCubageExceedsMaxValue: 'The cubage {cubage} in line {rowNum} exceeds the maximum value {maxValue}',
  HasExport: 'Exported',
  DelegatedAssociatedBusinessStatus: 'Delegated associated business status',
  TransactionRelatedBusinessStatus: 'Transaction related business status',
  SecondarySynchronization: 'Secondary synchronization',
  NumberOfCustomsOrders: 'Number of customs orders',
  CustomerClosingTime: 'Customer closing time',
  AddToMainTicket: 'Add to main ticket',
  CustomsDeclarationRemark: 'Customs remark',
  OperationGuide: 'Operation Guide',
  ServiceInformation: 'Service Information',
  ScopeServices: 'Scope of Services',
  DeletionGuide: 'Shanghai Port Deletion Guide',
  BusinessData: 'Shanghai Port Business data',
  SecondVesselInformation: '2nd Routing Foreign Truck information',
  vesselText: 'The arrival name: ${1}, voyage: ${2} obtained from the container cargo data in the port area are not consistent with the ship name: ${3}, voyage: ${4} on the booking page. Do you want to write the ship name and voyage obtained from the bill of lading and clear the acquired ship date data?',
  importEmpty: 'Import and empty',
  importNotEmpty: 'Import does not empty',
  ignore: 'ignore',
  empty: 'null',
  salveNoDcToKeepMaster: 'The entrusting company does not maintain the corresponding document personnel. Do you want to keep the main document personnel?',
  CustomersCollectByBubble: 'Customers collect by bubble',
  CollectionBySupplier: 'Collection by supplier',
  Slac: 'ShipperLoadAndCount',
  BookingShutOut: 'Booking shut out',
  tip: 'Tips',
  ShippingCompanyDialogModifyText: 'You have modified the shipping company. Do you want to clear the existing destination port information? If you open the shipping company cargo tracking service, you will re-subscribe to the destination port information on the booking tab.',
  ShippingCompanyDialogDeleteText: 'You have deleted the shipping company. Do you want to clear the existing destination port information?',
  emptyDestinationInformation: 'empty',
  noEmptyDestinationInformation: "Don't empty",
  BatchModifyBusiness: 'Batch Modify Business',
  DataAdjustment: 'Data adjustment',
  OriginalData: 'Original data:',
  AfterAdjustment: 'After adjustment:',
  inputContainerNo: 'Please fill in the Container No',
  inputSealNo: 'Please fill in the Seal No',
  BoxType: 'Box type',
  BusinessPeopleType: 'Business people',
  clearConfirm: 'The selected business [{0}] [{1}] data will be cleared. Are you sure?',
  clearCategoryConfirm: 'The business [{0}] has been checked and the data will be cleared. Are you sure?',
  changeTwoConfirm: 'The selected business【{0}】【{1}】data will be replaced. Are you sure?',
  changeOneConfirm: 'The selected business【{0}】data will be replaced. Are you sure?',
  hasRefreshCharge: 'The booking agent already has charges, refresh charges?',
  SuccessTip: 'Success {0} items',
  successTipAlreadyNotEditCharge: 'Success {0} items, <br/> description: <br/> {1} already has non-editable charges, please handle promptly!',
  hasOneAtleast: 'Please select at least one option and try again!',
  hasOneNoAtleast: 'Please fill in at least one field and try again!',
  maxSelectBusiness: 'The selected business exceeds {0}, please re-select and try again!',
  requireAllSelect: 'Please select the modified {0} and {1} and try again',
  hasOneCategoryAtleast: 'Please select the data you need to write!',
  adjustedDestinationAgent: 'Enter adjusted destination agent!',
  whetherCoverMBLReceiver: 'Selected destination agent data will be replaced. Overwrite MBL receiver with new agent info?',
  lclSlavesJobCannotModify: 'This field cannot be modified on the receipt！',
  BusinessNotSameOpAndSalesOffice: 'Business {0} operation branch is inconsistent with sales branch',
  SuccessfullyClearXPieces: 'Successfully cleared {0} pieces of {1} data',
  PartSuccessClearXPieces: 'Successfully cleared {0} pieces of {1} data, failed to clear {2} pieces, failure reason:',
  DataAdjustmentSame: '{0} The data before and after the adjustment are consistent, and no changes have been made this time',
  DataAdjustmentAgainConfirm: 'The checked business {0} data will be replaced. Are you sure?',
  SuccessfullyReplacedXPieces: 'Successfully replaced {0} pieces of {1} data',
  NotReplacedXPieces: 'No eligible {0} is found, 0 items are replaced this time',
  PartSuccessReplacedXPieces: 'Successfully replaced {0} pieces of {1} data, failed {2} pieces, failure reason:',
  BusinessisNotPositiveOperation: 'The business {0} is not a positive operation',
  BusinessisBlocked: 'The business {0} is locked',
  BusinessisHblLock: 'Business {0} HBL Locked Doc',
  BusinessisInvalidLoadType: 'The LCL type of business {0} is not consignment LCL',
  BusinessisContainerExist: 'Business {0} already has an adjusted box type',
  BusinessPicecNotMatch: 'The business {0} is no box type corresponding to the original data',
  BusinessisMblHblContainerExist: 'Business {0} has joined MBL split/HBL split/formal split',
  BusinessisContainerSealNoExist: 'Business {0} has filled in the box seal number',
  BusinessisTruckingContainerExist: 'Service {0} has been associated with gateway information',
  BusinessisDischarginTruckingExist: 'Business {0} has been associated with destination delivery',
  BusinessisAmsContainerExist: 'Business {0} has been associated with anti-terrorism manifest',
  CopyFailedBusinessNumber: 'One-click copy failed business number',
  HLID: 'Interconnection ID',
  truckingPlaceDep: 'Container lifting yard',
  truckingPlaceDest: 'Container return yard',
  PackagingCategoryOfDangerousGoods: 'Packaging category of dangerous goods',
  CargoReleaseWay: 'Cargo release way',
  WarehouseLoadingRemarks: 'Warehouse loading remarks',
  CheckStatuses: 'Check status:',
  ClearStatuses: 'Clear status:',
  SelectAtLeastOneAdjustment: 'Please select at least one adjustment content and try again!',
  ClearStateComfirm: "The checked status of the selected business' {0} 'will be cleared. Are you sure?",
  CheckStateComfirm: "The checked status of the selected business' {0} 'will be selected. Are you sure?",
  SuccessfullyCancelXPieces: 'Successfully cancelled {0} pieces of data',
  SuccessfullyCheckXPieces: 'Successfully checked {0} pieces of data',
  PartSuccessClearXThePieces: 'Successfully clear {0} pieces of data, failed {1} pieces, failure reason:',
  PartSuccessCheckXThePieces: 'Successfully check {0} pieces of data, failed {1} pieces, failure reason:',
  BusinessisCargoDocLock: 'Business {0} Locked Doc',
  DataCategoryProcessingFailed: 'Data category processing failed',
  PleaseSelectATemplate: 'Please select a template',
  PleaseSelectANode: 'Please select a node',
  PleaseSelectAState: 'Please select a state',
  SuccessModifiedXBusinessState: 'Successfully modified {0} business statuses',
  SuccessWithdraw: '{0} items have been withdrawn',
  PleaseSpecificTemplateFilePreview: 'Please select a specific template file for preview !!!',
  CopyLast: 'Copy last',
  WaybillNumberCopy: 'Waybill number copy',
  CargoInformation: 'Cargo information',
  BillOfLadingQuantity: 'Bill of lading quantity',
  Packing: 'Packing',
  PleaseChoose: '--Please choose--',
  CustomerType: 'Customer type',
  HTSCode: 'HTS code',
  EnglishCommodityName: 'English commodity name',
  TransportationInformation: 'Transportation information',
  MBLNumber: 'MB/L number',
  HBLNumber: 'HB/L number',
  CCNNumber: 'CCN number',
  ShipName: 'Ship name',
  ShipNumber: 'Ship number',
  PortArrivalDate: 'Port arrival date',
  CountryOfOrigin: 'Country of origin',
  BillLadingPlaceOfDispatch: 'Bill of lading place of dispatch',
  BillLadingPortOfDeparture: 'Bill of lading port of departure',
  BillLadingPortOfDischarge: 'Bill of lading port of discharge',
  BillLadingPlaceOfDelivery: 'Bill of lading place of delivery',
  LastOverseasPort: 'Last overseas port',
  HtsCode: 'HTS CODE',
  FirstPortOfCall: 'First port of call',
  SynchronizeHBLInformation: 'Synchronize HBL information',
  addHbl: 'add HBL',
  NonVesselCarrierSCAC: 'Non-vessel carrier SCAC',
  DeclarationAccount: 'Declaration account',
  DeclarationType: 'Declaration type',
  DirectToTheUnitedStates: 'Direct to the United States',
  ToTheInlandWarehouse: 'To the inland warehouse',
  TransferClearancePullToStates: 'Transfer in Canada without customs clearance, pull to the United States',
  CargoThroughTheUnitedStates: 'Cargo passing through the United States',
  ContainerInformation: 'Container information',
  AddContainerInformation: 'Add container information',
  RemoveContainerInformation: 'Remove container information',
  BoxSpecies: 'Box species',
  BoxHeight: 'Box height',
  ContainerNumber: 'Container number',
  SealNumber: 'Seal number',
  CommodityName: 'Commodity name',
  PleaseEnterTheCommodityNameOrHSCode: 'Please enter the commodity name or HS Code',
  ShippingCompanyContractNoRequired: 'Shipping company contract number cannot be empty',
  ApplicableRoutesNoRequired: 'Applicable routes cannot be empty',
  ShippingCompanyNoRequired: 'Shipping company cannot be empty',
  ValidityNoRequired: 'Validity period cannot be empty',
  ShippingCompanyAndBaseDifferent: 'The shipping company for this agreement does not match the information entered in the base tab. Confirm overwrite?',
  GiveUp: 'Give up',
  BackFillToRoute: 'Multiple applicable routes are maintained under this agreement number. Please select the route to backfill to the base tab.',
  MultipleApplicableRoutesDifferent: 'Multiple applicable routes are maintained under this agreement number, and all differ from the base tab input. Please select the route to backfill to the base tab.',
  ApplicableRoutesDifferent: 'All applicable routes for this agreement number differ from the base tab input. Confirm overwrite?',
  ShippingCompanyDifferent: 'The shipping company you selected does not match the applicable shipping company of the chosen contract. Confirm overwrite?<br/><span style=\'color:red\'>{0}</span>',
  AirlineDifferent: 'The route of the port you selected does not match the applicable route of the chosen contract. Confirm overwrite?<br/><span style=\'color:red\'>{0}</span>',
  EtdDifferentValidityPeriod: 'The ETD you selected does not comply with the contract validity period. Confirm overwrite?<br/><span style=\'color:red\'>{0}</span>',
  ValidityPeriodCannotCoverETD: 'The validity period of the selected contract cannot cover the ETD. Confirm overwrite?<br/><span style=\'color:red\'>{0}</span>',
  DoNotBackFill: 'Do not backfill',
  ValidPeriodMessage: 'Agreement validity period: {0}',
  ValidPeriodEtdMessage: 'Agreement validity period: {0}, ETD: {1}',
  NumberApplicableToShippingCompany: 'Agreement applicable shipping company: {0}',
  NumberApplicableToAirline: 'Agreement applicable route: {0}',
  PleaseToDeleteTheContract: 'Are you sure you want to delete the selected {0} appointment number(s)? This action cannot be undone',
  ScNoIsUsed: 'This appointment number is already in use and cannot be deleted',
  BeginDateNotLessThanEndDate: 'The validity start date cannot be later than the end date',
  ConfirmEnableTips: 'After activation, users will be able to select this appointment number on the order details page. Confirm activation?',
  EnableTips: 'You can only activate when all selected appointment numbers are in the disabled state.',
  DisEnableTips: 'After disabling, this appointment number will no longer be selectable in the order details. Confirm disabling?',
  ConfirmDisEnableTips: 'You can only disable when all selected appointment numbers are in the active state.',
  ContractRatePropertyRequired: 'Contract rate property cannot be empty',
  NACRequired: 'NAC cannot be empty',
  CommodityNameRequired: 'Commodity name cannot be empty',
  ContractNumberRequired: 'Shipping company contract number already exists',
  PleaseSelectAirLine: 'Please select shipping route (multiple selection allowed)',
  PleaseInputNumber: 'Please enter a number',
  CargoInsuranceQuantityRequired: 'Cargo insurance quantity cannot be empty',
  CargoInsuranceUnitRequired: 'Cargo insurance unit cannot be empty',
  SendingStatus: 'Sending status',
  SendingStatusUpdateTime: 'Sending status update time',
  CancellationStatus: 'Cancellation status',
  Notifier: 'Notifier',
  SecondNotifier: 'Second notifier',
  ShippingAndReceivingInformation: 'Shipping and receiving information',
  ShipperName: 'Shipper name',
  CompanyTitle: 'Company Title',
  Address: 'Address',
  Phone: 'Phone',
  Optional: 'Optional',
  ConsigneeName: 'Consignee name',
  NotifierName: 'Notifier name',
  SecondNotifierName: 'Second notifier name',
  BatchModifyDestinationPortInformation: 'Batch modify destination port information',
  OverseasWarehouseNonAmazonWarehouse: 'Overseas transit warehouse non-Amazon warehouse',
  SelectedBePositivePleaseSelect: 'Selected operation must be positive, please re-select!',
  DomesticWarehouse: 'Domestic warehouse',
  OverseasWarehouse: 'Overseas warehouse',
  ContainerNumber2: 'Container number:',
  ContainerNumberContainerNoNull: 'Container number: containerNoNull',
  Exceeded: 'Exceeded',
  CancelCustomsReturn: 'Cancel customs return',
  AttachmentContentTooLarge: 'Attachment content too large',
  LockedPleaseContactSupervisorUnlock: 'Locked, unable to print, please contact supervisor to unlock!',
  FCLProfitPrinting: 'FCL Profit Printing',
  LCLProfitPrinting: 'LCL Profit Printing',
  DueToPrintOrUnlock: 'Due to credit control exceeded, this bill is locked, unable to print or EDI, please contact supervisor when needed to unlock!',
  FeeName: 'Fee name',
  BatchFeeScheme: 'Batch fee scheme',
  NoCostCanBeTranscribed: 'No cost can be transcribed.',
  ThisBeenSentEDIAllowed: 'This manifest information has been sent EDI, deletion not allowed.',
  TheVoidedAndCannotAgain: 'The manifest has been voided and cannot be voided again.',
  ShanghaiManifestShippingCompany: 'Shanghai manifest Shipping company:',
  NoResultsFound: 'No results found',
  ExportClearanceNewRegulation: 'Export clearance new regulation',
  ShanghaiAfterClearanceManifestContinuing: 'Shanghai Customs No.172 order switches clearance conditions, loading manifest receipt is used to transmit sea clearance information to terminal, please check loading manifest status after customs declaration is completed and contact customer service if there\'s any abnormal situation. Redundant manifest not timely deleted, late delivery, irregular additions after clearance, manifest data change failures, mixed loading, bill of lading number reused within two years will affect shipment. After receiving normal receipt of loading manifest, if any pre-stow manifest needs to be amended, deleted or added, please contact the shipping agent to delete the loading manifest before continuing.',
  YangshanDistrictNovember152021: 'Yangshan Customs District: November 15, 2021',
  WaigaoqiaoDistrictNovember222021: 'Waigaoqiao Customs District: November 22, 2021',
  GarbageManifest: 'Garbage manifest',
  N1YourGoodsAreManifest: '1. Garbage manifest strictly prohibited by customs! According to customs regulations, each pre-stow manifest must correspond to an actual shipment. If your goods are not shipped after sending manifest (missed the ship, shipment plan changed, etc.), it will be considered as a garbage manifest.',
  N2StowManifestMustSent: '2. Examples of garbage manifest: After the ship is re-stowed, the original pre-stow manifest must be deleted, and then the new pre-stow manifest can be sent!',
  N3OnTheFreightManifest: '3. Consequences of not deleting garbage manifest: It will not only affect shipment, but also customs may impose a fine of up to 50,000 yuan on the freight forwarder and revoke the customs declaration qualification! If garbage manifest occurs, please contact customer service in time to assist with deleting the garbage manifest!',
  BusinessNotSelected: 'Business not selected',
  DoNotImportAndSend: 'Do not import and send',
  ViewReceipt: 'View receipt',
  ImportEXCEL: 'Import EXCEL',
  Receipt: 'Receipt',
  ReceiptNumber: 'Receipt number',
  Time: 'Time',
  PleaseSelectAccount: 'Please select account',
  MappingValueNotEmpty: '{0} cannot be empty, please configure the mapping code for {1} in mapping management',
  AfrFieldNotEmpty: '{0} cannot be empty',
  AfrEfreightDgTip: 'Dangerous goods cannot be shipped via direct mode. Please switch back to indirect mode. Also, please supplement the dangerous goods information in YiFei.',
  AfrFieldNotAccess: 'Cannot exceed {0} characters',
  CustomerNumberCannotBeEmpty: '【Customer Information】AMS HBL number cannot be empty.',
  CustomerNOCannotBeEmpty: '【Customer Information】MB/L NO cannot be empty.',
  CustomerPortCannotBeEmpty: '【Customer Information】Discharge port cannot be empty.',
  CustomerDeliveryCannotBeEmpty: '【Customer Information】Place of delivery cannot be empty.',
  AMSNumber: 'AMS number',
  AFRNumber: 'AFR number',
  ACINumber: 'ACI number',
  EManifestNumber: 'eManifest number',
  SendSucceeded: 'Send succeeded',
  NotSent: 'Not sent',
  ServiceChannel: 'Service channel',
  ExpectedAmazonWarehouseEntryTime: 'Expected Amazon warehouse entry time',
  DestinationDeliveryMethod: 'Destination delivery method',
  CourierCompany: 'Courier company',
  TrackingNumber: 'Tracking number',
  POoriginalNumber: 'PO (original number)',
  CustomsDeclarationMethod: 'Customs declaration method',
  CustomsClearanceMethod: 'Customs clearance method',
  EORIEnterpriseNumber: 'EORI enterprise number',
  VATTaxNumber: 'VAT/Tax number',
  VATRegistrationCountry: 'VAT registration country',
  VATRegistrationAddress: 'VAT registration address',
  VATCompanyEnglishName: 'VAT company English name',
  WithPower: 'With power',
  WithMagnet: 'With magnet',
  Powder: 'Powder',
  Liquid: 'Liquid',
  EstimatedWarehouseEntrygoodArrivalTime: 'Estimated warehouse entry/good arrival time',
  RemoteWarehouse: 'Remote warehouse',
  OceanFreight: 'Ocean Freight',
  ServiceChannel2: 'Service Channel:',
  FeeType: 'Fee Type:',
  EstimatedAmount: 'Estimated Amount:',
  Equivalent: 'Equivalent',
  FreightRateLevel: 'Freight Rate Level:',
  BillingWeight: 'Billing Weight:',
  CalculationMethod: 'Calculation Method:',
  EstimatedTimeCannotBeEmpty: 'Estimated warehouse/ready goods time cannot be empty!',
  DestinationCannotBeEmpty: 'Destination cannot be empty!',
  DestinationCountryCannotBeEmpty: 'Destination country cannot be empty!',
  ZipCodeCannotBeEmpty: 'Zip code cannot be empty!',
  CannotBeEmpty: 'Cannot be empty!',
  PleaseTheConsignorUnitFirst: 'Please select the consignor unit first.',
  DearAndThenCarryOperation: 'Dear, please save the business first, and then carry out the automatic distribution operation.',
  ClearanceMethod: 'Clearance Method',
  EstimatedStorageReadyGoodsTime: 'Estimated Storage/Ready Goods Time',
  ForeignWarehouse: 'Foreign Warehouse',
  WithElectricity: 'With Electricity',
  WithMagnetism: 'With Magnetism',
  YourPieceWeightAndTo: 'Your cargo has participated in data comparison, and automatic packing will update the piece weight and volume information of this ticket and the main ticket it belongs to.',
  Prompt: 'Prompt',
  GotIt: 'Got It',
  DocumentNumber: 'Document Number',
  Origin: 'Origin',
  AreaCode: 'Area Code',
  BoxAndCargoInformationFunction: 'Box and cargo information is inconsistent, please confirm whether the information is correct? You can modify the box and cargo information in the basic tab or match the box and cargo information through the data comparison function.',
  InconsistencyBetweenPortAreaDataAndPackingInformationTips: 'Note: When the port data is inconsistent with the packing information, it may result in not pushing warning reminders or SOP settings related reminders',
  TheComparisonFunctionToPossible: 'We have obtained the latest port area container cargo information. Please use [Update Port Area Data] as soon as possible to select the container cargo data you want.',
  DetectionOfBasicTab: 'Detection of basic tab',
  InconsistentThePortAreaReturn: 'Inconsistent with the port area return',
  PleaseTheOperationIsCorrect: 'inconsistent',
  YouBoxAndCargoTab: 'Please go to 【 Packing Information 】 immediately to check.',
  BoxNum: 'boxes',
  GoCheck: 'Go check.',
  BoxQuantity: 'Box Quantity',
  BoxModel: 'Box Model',
  CutOffDate: 'Cut-off Date',
  PortOpeningTime: 'Port Opening Time',
  PortOpeningDate: 'Port Opening Date',
  ScheduledBerthingTime: 'Scheduled Berthing Time',
  ScheduledDepartureTime: 'Scheduled Departure Time',
  ActualUnloadingTime: 'Actual Unloading Time',
  ActualHeavyLiftingTime: 'Actual Heavy Lifting Time',
  ActualEmptyReturnTime: 'Actual Empty Return Time',
  PleasePackingInformationToRemoved: 'Please select the packing information to be removed!',
  BillOfLadingType: 'Bill of Lading Type',
  ArrivalDate: 'Arrival Date',
  ShippingType: 'Shipping Type',
  DischargingPort: 'Discharging Port',
  DeliveryPlace: 'Delivery Place',
  CustomerShippingInformation: 'Customer Shipping Information',
  CargoReceiver: 'Cargo Receiver',
  Buyer: 'Buyer',
  Modify: 'Modify',
  PleaseSelectABox: 'Please select a box',
  ReleaseOrderNumber: 'Release Order Number:',
  ExportReleaseNewRegulation: 'Export Release New Regulation',
  WechatPrompt: 'Please go to Settings and Tools - Personal Information to enable WeChat message push authorization and follow the official account.',
  YangshanAreaNovember152021: 'Yangshan Customs Area: November 15, 2021',
  WaigaoqiaoAreaNovember222021: 'Waigaoqiao Customs Area: November 22, 2021',
  GarbageCargoManifest: 'Garbage Cargo Manifest',
  N1ActuallyShippedIfGarbage: '1. Garbage cargo manifest is strictly prohibited by customs! According to customs regulations, each pre-booking manifest must correspond to a cargo that is actually shipped. If your cargo is not shipped after sending the manifest (missed the boat, shipping plan changed, etc.), the manifest is considered garbage!',
  N2ManifestMustBeDeletion: '2. Example of garbage manifest: After the ship is modified, the original pre-allocated manifest must be deleted, and the new pre-allocated manifest can be sent after deletion!',
  N3YuanOnTheManifest: '3. Consequences of not deleting garbage manifest: Not only will it affect loading, but the customs can also impose a fine of up to 50,000 yuan on the freight forwarder and cancel the declaration qualification! When garbage manifest appears, please contact customer service in time to assist in deleting the garbage manifest!',
  DetailsOfSeaExportGoods: 'Details of sea export goods',
  PleaseSelectTheSpecifiedData: 'Please select the specified data',
  LicenseOfLadingNumberEmpty: 'License plate number and bill of lading number cannot be empty',
  NoRelevantInformation: 'No relevant information',
  EstimatedDeliveryTime: 'Estimated delivery time',
  ActualDeliveryTime: 'Actual delivery time',
  ObtainedContainerAndGoodsData: 'The ship name and voyage you entered',
  Sailing: 'Sailing:',
  WithBookingTab: 'Ship name and voyage obtained from the port area',
  InconsistentFromTheBillData: 'Inconsistent, do you want to write the ship name and sailing obtained from the bill of lading and clear the already obtained sailing schedule data?',
  InconsistentFromTheBillDataTips: 'Attention: If the ship name and voyage are incorrect, it may result in obtaining the corresponding incorrect ship schedule time (planned departure and berthing time, departure and interception time, actual departure and berthing time)',
  TheTicketIsNotImport: 'The MBL status of this ticket is not unstarted, unable to import.',
  Correction: 'Correction',
  ThisItIs1Again: 'This job {0} has successfully sent EDI booking before,<br>This time it is {1}-{2},<br>Please confirm whether you need to send it again?',
  PleaseOnePieceOfData: 'Please select one piece of data!',
  BatchImport: 'Batch import',
  GoodsInformationImport: 'Goods information import',
  SeaFreight: 'Sea freight',
  AirFreight: 'Air freight',
  Freight: 'Freight',
  BatchCostScheme: 'Batch cost scheme',
  Shanghai: 'Shanghai',
  Qingdao: 'Qingdao',
  SeaguardianSupportsSM2WeighingMethod: 'Seaguardian channel only supports SM2 weighing method.',
  ContainerNumberSealNumber: 'Container number-Seal number',
  DueCannotBePrintedNeeded: 'Due to credit control exceeded, this ticket has been locked and cannot be printed or EDI. Please contact the superior to unlock when needed!',
  LockedContactTheSuperiorUnlock: 'Locked, unable to print, please contact the superior manager to unlock!',
  ModificationSuccessful: 'Modification successful',
  StatusConversionSuccessful: 'Status conversion successful.',
  NoDeclarationFormCreated: 'No declaration form created',
  Cleared: 'Cleared',
  Uncleared: 'Uncleared',
  SentOut: 'Sent out',
  TakenOver: 'Taken over',
  Filed: 'Filed',
  TaxRefunded: 'Tax refunded',
  ReturnedbyOurCompany: 'Returned (by our company)',
  ReturnedtoTheCustomer: 'Returned (to the customer)',
  WithdrawalOfDocumentStatus: 'Withdrawal of document status',
  DocumentStatus: 'Document status',
  SendOut: 'Send out',
  Archive: 'Archive',
  RefundTax: 'Refund tax',
  RetrieveourCompany: 'Retrieve (our company)',
  Returncustomer: 'Return (customer)',
  StateNotSelected: 'State not selected.',
  DateNotSelected: 'Date not selected.',
  WithdrawalSuccessful: 'Withdrawal successful.',
  NoDataSelected: 'No data selected.',
  PleaseANewDeclarationForm: 'Please create a new declaration form.',
  NoDataModified: 'No data modified',
  SavedSuccessfully: 'Saved successfully.',
  BatchIsInconsistentPleaseSelect: 'Batch print status is inconsistent, please re-select.',
  NoDataAvailableForPrinting: 'No data available for printing.',
  Document: 'Document',
  Date: 'Date',
  NoFilesAvailable: 'No files available',
  Takeover: 'Takeover',
  Retrieve: 'Retrieve',
  FileNotSelected: 'File not selected.',
  NoTemplateFound: 'No template found',
  ForTheCorrespondingPrint: 'for the corresponding print',
  BookingAPI: 'Booking API',
  BillOfLadingAPI: 'Bill of Lading API',
  PleaseTheBusinessToSend: 'Please select the business to send!',
  ContainerQuantity: 'Container Num',
  BookingEdiSendingChannel: 'Booking EDI channel',
  BookingEdiSendingTime: 'Booking EDI time',
  EdiStateQuery: 'EDI State query',
  JiLianStar: 'Ji lian new',
  NotBeSent: '(Note: This line will not be sent)',
  FullyStored: 'Fully stored',
  CancelFullWarehousing: 'Cancel full warehousing',
  StoredTipOne: 'There are a total of {1} warehouse receipts with business number {0}',
  StoredTipTwo: 'Confirm that the operation is {0}?',
  StoredTipThree: 'Please select data with inbound status [{0}]',
  StoredTipFour: 'The warehouse receipt for this transaction has been fully stocked in!',
  SelectedRightData: 'Please select data that meets the criteria',
  EmptyContainerNotificationTime: 'Empty Container Notification Time',
  WaitBookingVerifyBatch: 'In the batch review, please wait, you will be reminded after the review is successful.',
  BookingVerifyBatch: 'Batch audit business cannot exceed 500!',
  Roles: 'Roles',
  ZipForCountry: 'US,CA required',
  PleaseZipForSend: 'Please select Zip to Send!',
  BL_EDI_SendChannel: 'Bill of Lading EDI sending channel',
  BL_EDI_SendTime: 'Bill of Lading EDI sending time',
  VGM_EDI_SendChannel: 'VGM EDI transmit channel',
  VGM_EDI_EDISendTime: 'VGM EDI send time',
  CleanManifest_EDI_SendChannel: 'Clean the manifest EDI sending channel',
  CleanManifest_EDI_SendTime: 'Clean manifest EDI sending time',
  Way99_EDI_SendChannel: '99-way EDI transmission channel for packing slips',
  Way99_EDI_SendTime: '99-way packing slip EDI sending time',
  AMS_EDI_SendChannel: 'AMS EDI transmit channel',
  AFR_EDI_SendChannel: 'AFR EDI sending channel',
  ACI_EDI_SendChannel: 'ACI EDI Sending Channel (CW)',
  ACI_EDI_SendTime: 'ACI EDI sending time (CW)',
  AMS_JS_STATE: 'AMS sending status',
  ACI_JS_STATE: 'ACI sending status',
  AFR_JS_STATE: 'AFR sending status',
  AMS_EDI_SendTime: 'AMS EDI send time',
  AHR_EDI_SendTime: 'AHR EDI send time',
  ENS_EDI_SendTime: 'ENS EDI send time',
  PreShippingBill_EDI_SendChannel: 'Provision the manifest EDI sending channel',
  PreShippingBill_EDI_SendTime: 'Provision manifest EDI delivery time',
  OverseaAgent_EDI_SendChannel: 'Overseas agent EDI sending channel',
  OverseaAgent_EDI_SendTime: 'Overseas agent EDI sending time',
  PortOfHubSecond: 'Port Of Hub Second',
  PortOfHubThird: 'Port Of Hub Third',
  ProvisioningStatus: 'Provisioning status',
  ArrivalInformation: 'Arrival Information',
  QuantityConsign: 'Number of pieces (commission)',
  QuantityActual: 'Number of pieces (actual)',
  WeightConsign: 'Gross weight (commission)',
  WeightActual: 'Gross weight (solid)',
  CubageConsign: 'Volume (commission)',
  CubageActual: 'Volume (solid)',
  VolumetricWeightConsign: 'Volume (commission)',
  VolumetricWeightActual: 'Volume (actual)',
  ChargeWeightConsign: 'Billable weight (commission)',
  ChargeWeightActual: 'Billable weight (actual)',
  CategoryOfGoodsName: 'Name of goods category',
  ShipperLine2: 'Shipper Line2',
  ConsigneeLine2: 'Consignee Line2',
  NotifyPartyLine2: 'NotifyParty Line2',
  ShipperLine3: 'Shipper Line3',
  ConsigneeLine3: 'Consignee Line3',
  NotifyPartyLine3: 'NotifyParty Line3',
  ShipperLine4: 'Shipper Line4',
  ConsigneeLine4: 'Consignee Line4',
  NotifyPartyLine4: 'NotifyParty Line4',
  ShipperLine5: 'Shipper Line5',
  ConsigneeLine5: 'Consignee Line5',
  NotifyPartyLine5: 'NotifyParty Line5',
  ShipperLine6: 'Shipper Line6',
  ConsigneeLine6: 'Consignee Line6',
  NotifyPartyLine6: 'NotifyParty Line6',
  ShipperLine7: 'Shipper Line7',
  ConsigneeLine7: 'Consignee Line7',
  NotifyPartyLine7: 'NotifyParty Line7',
  OperationLog: 'Operation Log',
  DimensionLength: 'DimensionCM(length)',
  DimensionWidth: 'DimensionCM(width)',
  DimensionHeight: 'DimensionCM(height)',
  SystemAdd: 'Platform Add',
  FreeContainerEndTime: 'Free Container End Time',
  FreeStorageEndTime: 'Free Storage End Time',
  QuantityConsign2: 'Number of pieces (commissioned)',
  QuantityBooking: 'Number of pieces (booking)',
  QuantityActual2: 'Number of pieces (actual)',
  QuantityDocumentation: 'Number of pieces (preparation)',
  WeightConsign2: 'Gross weight KGS (commissioned)',
  WeightBooking: 'Gross weight KGS (booking)',
  WeightActual2: 'Gross weight KGS (actual)',
  WeightDocumentation: 'Gross weight KGS (preparation)',
  CubageConsign2: 'Volume CBM (commissioned)',
  CubageBooking: 'Volume CBM (booking)',
  CubageActual2: 'Volume CBM (actual)',
  CubageDocumentation: 'Volume CBM (preparation)',
  ChargeWeightConsign2: 'Billable weight M/T (commissioned)',
  ChargeWeightBooking: 'Billable weight M/T (booking)',
  ChargeWeightActual2: 'Billable weight M/T (actual)',
  ChargeWeightDocumentation: 'Billable weight M/T (preparation)',
  DensityConsign: 'Density kg/m ³ (commissioned)',
  DensityBooking: 'Density kg/m ³ (booking)',
  DensityActual: 'Density kg/m ³ (actual)',
  DensityDocumentation: 'Density kg/m ³ (preparation)',
  ConsignationCompany2: 'Entrusting unit/actual notifier',
  ConsignationCompanyHeader2: 'Title of the commissioning unit/actual notifier',
  WarehouseSupplier2: 'Warehouse supplier/warehouse',
  ShipperDetail: 'Shipper detail',
  ConsigneeDetail: 'Consignee detail',
  NotifyDetail: 'Notify detail',
  MasterBillNo2: 'MBL',
  SynchroniseBooking: 'Synchronise Booking',
  HBLNoRepeat: 'Duplicate HB/L NO duplicate exists, order number: "{0}"',
  ConfirmSynchronizeHBL: 'When using Synchronize HBL, it will be cleared and the entered information will be manually added. Do you want to continue?',
  GetFiles: 'Get Files',
  UploadCustomerFiles: 'Upload Customer Files',
  CustomerSelfIssuedFiles: 'Customer Self Issued Files',
  CheckTheBLLog: 'Check The BL Log',
  Surrendered: 'Surrendered',
  InterfaceName: 'Interface Name',
  DataFlowDirection: 'Data Flow Direction',
  CheckTheBLCenterApiLog: 'Check The BL Center Api Log',
  PleaseMaintainTheCorresponding: 'Please maintain the corresponding {0}',
  PleaseMaintainThePhoneNumberOfTheCorrespondingPersonnel: 'Please maintain the phone number of the corresponding personnel',
  XhqCsrMsg: 'XinHaoQi Customer Service Message',
  copyLink: 'Copy Link',
  openLink: 'Open Link',
  BillNotCfm: 'The bill of lading has not been confirmed, please confirm first',
  ATDIsNull: 'Not yet departing, please release the order electronically after departure.',
  BillNotRelease: 'The bill of lading release status is not releasable',
  CfmBillFirst: 'Not yet available, please click on Confirm Bill first',
  IsReleased: 'The order has been released and cannot be operated here before uploading the customer manuscript',
  IsReleased2: 'The order has been released, no need to repeat the operation',
  UnStartOrUnConfirmCanUpload: 'Files can only be uploaded when the bill of lading is in the \'Not Started\' or \'Not Confirmed\' status',
  LinkIsNull: 'Link is null',
  OnlySurrenderedSupport: 'Only the "SURRENDERED" bill of lading method supports electronic release of documents',
  SynchronizePackingInfo: 'Synchronize and update packing information',
  ManifestNotConfirmed: 'Manifest not confirmed!',
  AreYouSureSynchronizePackingInfo: 'Are you sure you want to update the packing information synchronously?',
  NoDataSynced: 'No data is synchronized, please confirm the box type~',
  VirtualBillType: 'Virtual bill of lading type',
  DestinationPortAgentIsNotEqualToDesignatedFreightAgent: 'Destination port agent is not equal to designated freight agent',
  MultipleCustomsDeclarationInaccurate: 'There are multiple customs declaration commissions, and the data may be inaccurate. Please contact the customs broker offline to obtain detailed data.',
  OnlySupportOneCustomsDeclaration: 'This function is only applicable to creating one customs declaration commission scenario.',
  OnlySupportOneCustomsCommission: 'Please select one customs declaration commission and request a verification draft.',
  hblRefNo: 'hbl SplitOrder Ref',
  HBLRefNo2: 'HBL Ref No. ',
  BatchPushCharges: 'Batch Push Charges(Consignation)',
  ChargeConfirmed: 'Charge Confirmed',
  ViewReception: 'View Reception',
  ViewSending: 'View Sending',
  branchTransactions: 'branch Transactions',
  OurJobNo: 'Our Job No',
  TheirJobNo: 'Their Job No',
  firstSendTime: 'First Send Time',
  ConfirmReceiveTheseCharges: 'Confirm Receive These Charges?',
  AuditOperator: 'Audit Operator',
  Dimensions: 'Dimensions (L/WH in M)',
  DoorRemarks: 'Additional instructions for door points',
  BillOfLadingDesignatedFreightAgentFeedback: 'Bill-Lading Designated Freight Agent Feedback',
  ChangeValue: 'Change Value',
  AcceptChange: 'Accept Change',
  Rejected: 'Rejected',
  AgentFeedbackRemarks1: 'The online modification suggestions of the designated freight forwarder have been accepted',
  AgentFeedbackRemarks2: 'The online modification suggestions of the designated freight forwarder have been rejected,',
  AgentFeedbackRemarks3: 'Please confirm the final modifications with the shipper and designated freight agent offline',
  AgentEmailSend: 'Agent Bill Confirm Email Send',
  ETAFirstPortOfCall: 'ETA First Port Of Call',
  ETAFirstPortOfCallNotNull: 'In on board mode, "ETA First Port of Call" cannot be empty',
  DocumentOffice: 'Document Office',
  CustomerOffice: 'Customs Service Office',
  PleaseReferToTheEmailForSpecificErrorInformation: 'Please refer to the email for specific error information',
  AMSDeleteTips: 'The AMS No has not been successfully sent in the system and cannot be deleted',
  MultipleMode: 'Multiple single mode',
  NumberExchange: 'Number exchange',
  ReturnMode: 'Return to single order mode',
  OcrTip: '*Tip: Additional recording fields can be set in "Basic Configuration - Document Recognition Settings".',
  OcrOtherInfo: 'Other recording information:',
  DocumentRecognitionSettings: 'Document recognition settings',
  SeOcr: 'Identification of ocean export consignment notes',
  ocrOtherField: 'Please select additional record fields',
  ocrTextMapper: 'Recognizing Text Mapping',
  IdentifyingText: 'Identifying text',
  mappedValue: 'mapped value',
  addMapper: 'add Mapper',
  editMapper: 'edit Mapper',
  supplierCharge: 'Supplier charge',
  supplierOrderNo: 'Supplier OrderNo',
  supplierName: 'Supplier Name',
  supplierMatchName: 'Supplier Match Name',
  chargeItemLocal: 'Local Charge Name',
  refMsg1: 'Reference Information(one)',
  refMsg2: 'Reference Information(two)',
  supportNo: 'support No',
  pushTime: 'push Time',
  confirmCharge: 'confirm Charge',
  selectBeConfirmedCharge: 'Please select the charge to be confirmed',
  RefreshSuccessfulRows: 'Refresh successful {0} rows',
  SupplierFeesToBeProcessed: ' supplier fees to be processed',
  ReceivingBranch: 'Receiving branch',
  ReceivingMatchBranch: 'Receiving Branch Match Name',
  PleaseRefreshThePage: 'Unable to find mapping code, please maintain the mapping. If maintained, please refresh the page',
  BusinessDateIsNull: 'The business date corresponding to the business is empty',
  NoMatchJob: 'No match job,please refresh',
  ReleaseGoodsJY: 'Release Goods JY',
  ReleaseJY: 'Release JY',
  TakeContainerJY: 'Take Container JY',
  ContainerPreloadJY: 'Container Preload JY',
  CancelContainerPreloadJY: 'Cancel Container Preload JY',
  ReleaseGoodsPhotos: 'Release Goods Photos',
  ReleaseGoodsStatus: 'Release Goods Status',
  NoticeTime: 'Notice Time',
  ReleaseGoods: 'Release Goods',
  warehouseNoNotNull: 'Warehouse No Can Not Be Null',
  warehouseNotNull: 'The warehouse name cannot be empty. Please select the warehouse or warehouse supplier in the basic tab',
  consignerNotNull: 'The consigner Can Not be Null',
  ReleaseRemarks: 'Release Remarks',
  RequestDate: 'Require Date',
  TakeContRemarks: 'Take Container Remarks',
  ConfirmSendPackingInstructions: 'Are you sure you want to send the packing instructions?',
  AlreadySentReleaseGoods: 'The release goods have been sent, please do not repeat the operation',
  PleaseSelectWarehouseNo: 'Please select warehouse no',
  TheWarehouseNoHasBeenReleased: 'Has the warehouse entry number been sent before, is it still being sent?',
  ViewReleaseGoodsPhotos: 'View Release Goods Photos',
  JyWarehouseInterfaceLog: 'JY Warehouse Interface Log',
  JyWarehouseApiLog: 'Jy Warehouse Api Log',
  LclDynamic: 'Lcl Dynamic',
  TakeContainerNotice: 'Take Container Notice',
  TakeContainerDone: 'Take Container Done',
  PreloadContainerOrder: 'Preload Container Order',
  PreloadContainerDone: 'Preload Container Done',
  SendPort: 'Send Port',
  SendPortStart: 'Send Port Start',
  ArrivalPort: 'Arrival Port(Warehouse Notice)',
  ExistEmptyContainer: 'Exist Empty Container',
  docLink: 'Doc Link',
  Field: 'field',
  ErrorDescription: 'error description',
  VerificationPrompt: 'Verification prompt',
  InformationSavingOnly: 'Save information only',
  Required: 'REQUIRED',
  InputTwoAbove: 'Please enter two or more digits',
  SendError: 'sending failed',
  CounterTerrorismManifestConfiguration: 'fail in send',
  AfrAccount: 'AFR account',
  AfrPassword: 'AFR password',
  ApplicantEORI: 'Applicant EORI',
  AccountIsNotNull: 'Please select the account to send',
  PasswordIsNotNull: 'Please maintain the password sent',
  Notification: 'notice',
  Error: 'error message',
  NoSendingRecord: 'There is currently no sending record',
  GetExceptions: 'Get exceptions',
  WaitingReceipt: 'The same vessel name, voyage, and NVOCC SCAC have not yet received a customs receipt and cannot be sent. Please be patient and wait',
  NotOperable: 'There are cases where the receipt was not received or was not successfully sent, and the original, correction, or deletion cannot be sent',
  AmsVgm: 'Manifest/VGM',
  AmsReceipt: 'AMS receipt',
  AciReceipt: 'ACI receipt',
  AfrReceipt: 'AFR receipt',
  VgmReceipt: 'VGM receipt',
  EnsReceipt: 'ENS receipt',
  ManifestReceipt: 'Pre arranged manifest receipt',
  UserDefinedRole1: 'Custom Position 1',
  UserDefinedRole2: 'Custom Position 2',
  AmsReceiptRemind: 'Counter terrorism manifest receipt reminder',
  DangerousCargoCode: 'Dangerous Cargo Code',
  CustomerToOrder: 'Customer to order',
  DesignatedGoodsToBillOfLading: 'Designated goods to bill of lading',
  OverwriteOriginalRemark: 'Cover the original [Comments on remote booking]',
  DownloadPortServiceScope: 'Download Port Service Scope',
  AllowSaleProduct: 'Allow Sale Product',
  FullOrInside: 'Full Or Inside',
  Commissioned: 'Commissioned',
  weightVolumeBillWeightConsolidated: 'Weight/volume/chargeable weight including consolidation',
  weightVolumeBillWeightConsolidatedTip: 'The selected business has merged orders, and the weight/volume/billing weight of the merged orders will be calculated. The default statistics are based on the weight/volume/billing weight of the basic tab.',
  AttentionForSynchronizedContainer: 'Attention: This setting takes effect when filling in the box number. If not filled in, it will not take effect.',
  BatchFillGpExplain: 'Fill GP Explain In Batches',
  AiDocRecognition: 'AI document recognition',
  AiRecognition: 'AI recognition',
  SupportMultipleFiles: 'Support to identify freight forwarder bill of lading, bill of lading confirmation, order and other documents!',
  DragOrClick: 'Drag the file here, or',
  ClickUpload: 'click to upload',
  FileSizeLimit: 'You can only upload one file at a time, single file should not exceed 4MB',
  InvalidFileType: 'Invalid file type',
  FileTooLarge: 'File size cannot exceed 4MB',
  Reupload: 'Re-upload',
  StartRecognition: 'Start Recognition',
  RecognitionInProgress: 'Identifying... Please wait, it will take about 30s',
  RecognitionTextTip: 'Please copy and paste the content directly and click the identification button. The system will automatically identify and fill the content into the corresponding field',
  EstimatedTime: 'Estimated time: {time}',
  RecognitionSuccess: 'Recognition successful',
  RecognitionFailed: 'Recognition failed',
  AiRecognitionWarn: 'There may be errors in AI recognition, please check carefully before sending',
  SupportsShanghaiPortShipAgent: 'Only supports viewing the corresponding shipping agent for Shanghai Port',
  ServiceNotActivated: 'You have not activated this service',
  updateOrderContent: 'Update order content',
  CheckCustomsBrokerComfirm: "You have selected the 'Customs Broker' and will batch update the 'Customs Broker' field for the corresponding business. Are you sure?",
  CheckCustomsBrokerComfirm2: "You have selected 'Customs Service' but not 'Customs Broker'. I will clear the 'Customs Broker' field for bulk transactions. Are you sure?",
  ClearCustomsBrokerComfirm: "Have you checked the option to clear the local service 'Customs Declaration' and batch cleared the 'Customs Broker' field for the selected business? Are you sure?",
  EdiEuBolInfo: 'European Line Bill of Lading Supplementary Information',
  EuroLineENSDeclaration: 'European Line ENS Declaration Identifier',
  SelectEuroLineENSDeclaration: 'Please select "European Line ENS Declaration Identifier"',
  ManifestType: 'Manifest Type',
  SelectManifestType: 'Please select Manifest Type',
  SupplementaryDeclarant: 'Supplementary Declarant',
  ChemicalIdentifier: 'Chemical Identifier',
  ChemicalProduct: 'Chemical Product',
  NonChemicalProduct: 'Non-Chemical Product',
  ChemicalCUSCODE: 'Chemical CUS CODE',
  PostalInformation: 'Postal Information',
  PostalInformation2: 'Postal Information<br>(Choose either Street Name and Number)',
  EORICode: 'EORI Code',
  ShipperStreetNumber: 'Shipper Street Number',
  ShipperStreetName: 'Shipper Street Name',
  ActualShipperStreetNumber: 'Actual Shipper Street Number',
  ActualShipperStreetName: 'Actual Shipper Street Name',
  ShipperZipCode: 'Shipper Zip Code',
  ShipperAddress: 'Shipper Address',
  ConsigneeStreetNumber: 'Consignee Street Number',
  ConsigneeStreetName: 'Consignee Street Name',
  ActualConsigneeStreetNumber: 'Actual Consignee Street Number',
  ActualConsigneeStreetName: 'Actual Consignee Street Name',
  ConsigneeZipCode: 'Consignee Zip Code',
  ConsigneeAddress: 'Consignee Address',
  NotifyStreetNumber: 'Notify Street Number',
  NotifyStreetName: 'Notify Street Name',
  NotifyZipCode: 'Notify Zip Code',
  ActualShipper: 'Actual Shipper',
  ActualShipperName: 'Actual Shipper Name',
  ActualConsignee: 'Actual Consignee',
  ActualConsigneeName: 'Actual Consignee Name',
  ByBillingDate: 'By Billing Date',
  ByBusinessDate: 'By Business Date',
  CostRateValue: 'Cost Exchange rate value',
  CopyBusiness: 'Copy Business',
  CopyActualShipper: 'Copy Actual Shipper',
  CopyActualConsignee: 'Copy Actual Consignee',
  SelectEORICode: 'Please enter EORI Code information for {0}',
  TOOrderRequired: 'TO Order is required',
  EORICodeExample: 'Code Type + Code Number',
  PlsInputParameter: 'Please enter {0}',
  PlsSelectUnLCL: 'Please select a business with a containerLoadType of non LCL container',
  StreetInfo: 'Street number, street name, or postal information',
  ImportingLater: 'Importing, please proceed later',
  BusinessSeq: 'Business Number',
  Yard: 'Yard',
  PleaseSelectCarrier: 'Please select the carrier corresponding to the Mbl No',
  ModifyStatus: 'Modify Status',
  ModifyManifestStatusTip: 'Only support modifying the status of SoNo that have been sent with a manifest',
  AllSoNos: 'All SoNos',
  PlsSelectSoNo: 'Please select the SoNo that needs to be modified',
  FclOrderType: 'FCL Order Details',
  LclOrderType: 'BC Order Details',
  ConsoleOrderType: 'Non inbound order details',
  CopyBusinessSendConsigneeNotify: 'Copy business sending and receiving communication',
  DeclarationInformation: 'Declaration information',
  RelatedInformation: 'Related Information',
  SubstratumDeclarant: 'Substratum Declarant',
  PortInformation: 'Port Information',
  BuyerName: "Buyer's name",
  BuyerAddress: "Buyer's address",
  BuyerEORICode: 'Buyer EORI code',
  BuyerPostalCode: "Buyer's postal code",
  BuyerCountry: "Buyer's country",
  BuyerCity: "Buyer's City",
  SellerName: "Seller's name",
  SellerAddress: "Seller's address",
  SellerEORICode: 'Seller EORI Code',
  SellerPostalCode: "Seller's postal code",
  SellerCountry: "Seller's country",
  SellerCity: "Seller's City",
  UCRNO: 'UCR NO',
  ShipperEORI: 'Shipper EORI',
  ConsigneeEORI: 'Consignee EORI',
  NotifyEORI: 'Notify EORI',
  FactoryEORI: 'Factory EORI',
  WarehouseEORI: 'Warehouse EORI',
  LCLPersonEORI: 'LCL person EORI',
  ActualShipperCountry: 'Shipper country',
  ActualShipperCity: 'Shipper city',
  ActualRecipientCountry: 'Recipient country',
  ActualRecipientCity: 'Recipient city',
  NotifyPhone: "Notify person's phone number",
  NotificationCountry: 'Notification country',
  NotifyPersonCity: 'Notify person city',
  BuyerStreetNumber: "Buyer's street number",
  BuyerStreetName: "Buyer's street name",
  SellerStreetNumber: "Seller's street number",
  SellerStreetName: "Seller's street name",
  CopyActualRecipient: 'Copy the actual recipient',
  CopyActualShip: 'Copy the actual shipper',
  LinkSendAmsError: 'Pending status prohibits transmission.',
  DangerousCode: 'Dangerous goods code',
  PleaseEnterHeader: 'Please enter header',
  PleaseEnterAddress: 'Please enter address 1',
  PleaseEnterAddress2: 'Please enter address 2',
  PleaseSelectCountry: 'Please select country',
  PhoneFormat: 'Numbers only',
  PleaseEnterState: 'Please enter state/province',
  PleaseEnterCity: 'Please enter city',
  PleaseEnterPostalCode: 'Please enter postal code',
  PleaseEnterMbl: 'Please enter master bill number without SCAC code',
  VesselCallSignCheck: 'Only 1-9 uppercase letters and digits allowed',
  MarksFormat: 'Only uppercase/lowercase letters, digits, hyphen, slash, comma, space, colon, quote, plus, underscore',
  MustBe3: 'Must be 3 characters',
  OneCargoInfo: 'Only one consolidated cargo entry required',
  Instructions: 'Provide detailed reason',
  ExplanationRequired: 'Selecting “other” requires this field',
  ConfirmDeletion: 'Confirm deletion',
  HblCheck: 'Only uppercase letters, digits, hyphen and slash allowed',
  MustBe2: 'Must be 2 characters',
  MustBe11: 'Must be 11 alphanumeric characters, 4th must be U',
  MustBeU: '4th character must be U',
  MustBe4: 'Must be 4 characters',
  VesselNotNull: 'Please enter vessel name on booking tab',
  VoyageNotNull: 'Please enter voyage on booking tab',
  EtaNotNull: 'Please enter ETA on basic tab',
  StreetName: 'Street name',
  ExampleIllustrateEORI: 'Give an example to illustrate EORI12828',
  CycleTwoHundredTimesNotUseMbl: 'Delayed 200 times, no usable customs clearance found',
  GenerateMblButLessThan: '【 {0} 】 records have been generated, with no remaining customs clearance numbers available',
  selectedRowCount: '{0} items have been selected',
  specialOperationCode: 'Special Operation Code',
  doubleClickToAddSpecialOperationCode: 'Double-click to add a special operation code',
  selectSpecialOperationCode: 'Double-click to select special operation code',
  selectOperationRequirement: 'Double-click to select operation requirement',
  TransshipmentTransportationMethod: 'Transportation method',
  specialHandlingCodes: 'Special Handling Codes',
  AddApproximateSymbolToItemColumn: 'Add the approximate symbol to the item name column',
  BusinessLockedStatus: 'Business Locked Status',
  ImportChargeAllBusiness: 'When a business number exists in multiple business types at the same time, all are processed, that is, the number exists in both outbound and inbound businesses, and is imported into both outbound and inbound businesses simultaneously.',
  OriginBillOfLading: 'Original Bill of Lading',
  ShippingOrder: 'Book Of Documents',
  EmptyOut: 'Empty Out',
  GateIn: 'Gate in',
  VesselDeparturePOL: 'Vessel Departure POL',
  SendAll: 'Send all at once',
  textiles: 'textiles',
  nonTextiles: 'Non-Textiles',
  PendingPickingOrder: 'Pending picking order',
  PickingList: 'Picking list',
  WarehouseReleaseReceipt: 'Warehouse release receipt',
  QuickSearchMBL: 'Quick Search: Main Order Number',
  QuickSearchPickingOrderNo: 'Quick Search: Picking Order Number',
  DeliveryStation: 'Delivery station',
  AssemblyPlanNumber: 'Assembly plan number',
  FlightDateRange: 'Flight date range',
  OutboundInstruction: 'Outbound instruction',
  WarehouseEntryNumber: 'Warehouse entry number',
  BoardNumber: 'Board number',
  GenerateAPickingList: 'Generate a picking list',
  GenerateAndIssueOrders: 'Generate and issue orders',
  PickingOrderNumber: 'Picking Order Number',
  PickingStatus: 'Picking status',
  ThisPickingOrderNoIs: 'This picking order no is:',
  SuccessfullyGenerated: 'Successfully generated',
  CloseAndCopyPickingOrderNo: 'Close and copy the picking order number',
  PleaseCheckSameDataWareHouse: 'Please check the data for the same warehouse',
  DifferentGoodsCannotSamePickingList: 'Goods from different delivery stations cannot be on the same picking list',
  PickingCompleted: 'Picking completed',
  CancelPickingCompleted: 'Cancel picking completed',
  OutboundStatus: 'Outbound status',
  OutboundConfirmation: 'Outbound confirmation',
  CancelWarehouseConfirmation: 'Cancel warehouse confirmation',
  WarehouseConfirmationSuccessful: 'Warehouse confirmation successful',
  CancelWarehouseConfirmationSuccessfully: 'Cancel warehouse confirmation successfully',
  PleaseSelectCorrespondPickingList: 'Please select the corresponding picking list separately',
  PleaseCheckDataPickingCompletionUnOutBound: 'Please select the corresponding picking list separately',
  PleaseCheckDataPickingCompletionOutBound: 'Please check the data that has been picked and has been released from the warehouse',
  NotAllowEditPickingCompletion: 'The data of picking completion cannot be edited',
  NotAllowDeletePickingCompletion: 'The data of picking completion cannot be deleted',
  PleaseCheckDataRemoved: 'Please check the data to be removed',
  KeepLeastOneDetail: 'Keep at least one detail',
  CargoVehicle: 'Cargo vehicle',
  OutboundRemarks: 'Outbound remarks',
  DeliveryTime3: 'Delivery time',
  OutboundUser: 'Outbound User',
  QueryThreeMonths: 'Note: The query data is within the past three months',
  operationTrajectory: 'Operation Trajectory',
  pickupEmptyContainer: 'Pickup Empty Container',
  arrivalFactory: 'Arrival at Factory',
  departureFactory: 'Departure from Factory',
  enterTerminal: 'Enter Terminal',
  customsRelease: 'Customs Release',
  terminalRelease: 'Terminal Release',
  loadedOnVessel: 'Loaded on Vessel',
  departurePort: 'Port Departure',
  arrivalPort: 'Port Arrival',
  destinationCustomsClearance: 'Destination Customs Clearance',
  deliveryGoods: 'Delivery',
  returnContainer: 'Container Return',
  driver: 'Driver',
  contactInfo: 'Contact Information',
  licensePlate: 'License Plate',
  jobNumber: 'Job Number',
  vesselVoyage: 'Vessel & Voyage',
  customsDeclarationNo: 'Customs Declaration No.',
  sailingDate: 'ETD (Estimated Time of Departure)',
  closingTime: 'Customs Closing Time',
  WarehouseEntrySerialNumber: 'Warehouse entry serial number',
  PreWarehouseNumberOfPackages: 'Pre-warehouse number of packages',
  PreWarehouseGrossWeight: 'Pre-warehouse gross weight',
  PreWarehouseVolume: 'Pre-warehouse volume',
  PreWarehouseChargeableWeight: 'Pre-warehouse chargeable weight',
  CargoTerminalNumberOfPackages: 'Cargo terminal number of packages',
  CargoTerminalGrossWeight: 'Cargo terminal gross weight',
  CargoTerminalVolume: 'Cargo terminal volume',
  CargoTerminalChargeableWeight: 'Cargo terminal chargeable weight',
  DocumentationChargeableWeight: 'Documentation chargeable weight',
  SignedDocumentNumberOfPackages: 'Signed document number of packages',
  SignedDocumentGrossWeight: 'Signed document gross weight',
  SignedDocumentVolume: 'Signed document volume',
  SignedDocumentChargeableWeight: 'Signed document chargeable weight',
  DeadlineForDeclaringHazards: 'Deadline for declaring hazards',
  BookingManagementListPage: 'Booking Management List Page',
  PrintByFleet: 'Print by fleet',
  BoxContents: 'Box Contents',
  BatchAssignMasterOrderNumbers: 'Batch assign master order numbers',
  PleaseForThePositiveAssign: 'Please select the business for the positive operation to assign',
  SuccessfullyItemsFailed1Items: 'Successfully assigned {0} items, failed {1} items!',
  ReasonForFailure: 'Reason for failure:',
  MBLNOAlreadyExists: 'MB/L NO already exists',
  NonOperational: 'Non-operational',
  UnableTheMainTrackingNumber: 'Unable to match the main tracking number',
  WarehouseEntryInformation: 'Warehouse entry information',
  NumberOfItemsReceived: 'Number of items received',
  GrossWeightUponEntry: 'Gross weight upon entry',
  WarehouseVolume: 'Warehouse volume'
}
